import React from 'react';
import { Carousel } from 'antd-mobile';
import { convertStyleData, transformPx2Rem, getGoodsTypeByForm } from '@utils/tools';
import { appMethod as app } from '@utils/app';
import { ScrollView } from 'src/jisu-component/scroll-view/ScrollView';
import { RequestStatus } from 'src/common/request-status/RequestStatus';

import './VerticalListCustomComponent.less';


/**
 * type: "vertical-list" 
 * 组件：竖版列表组件
 */

const price = {
  price: (a, b) => {
    var c = (a - b).toFixed(2);
    return c
  },
  shopScore: (a, b) => {
    var c = ((1 - (b - a) / b).toFixed(2)) * 100;
    return c;
  },
  pxToRpx: (size) => {
    return (parseInt(size) * 2.34375)/100 + 'rem';
  },
  parseStyle: (style) => {
    // 调用此方法的话，应改为使用transformPx2Rem
    var styleArr1 = ["width", "font-size",'margin-left'];
    var styleArr2 = ["background-color", 'color','font-style','font-weight','text-decoration'];
    var s = '';
    for (var i = 0; i < styleArr1.length; i++) {
      var idx = styleArr1[i];
      if(style[idx]){
        s += idx + ':' + (parseInt(style[idx]) * 2.34375) + 'rpx;'
        if(idx == "height"){
          s += 'line-height:' + (parseInt(style[idx]) * 2.34375) + 'rpx;'
        }
      }
    }
    for (var i = 0; i < styleArr2.length; i++) {
      var idx = styleArr2[i];
      if(style[idx]){
        s += idx + ':' + style[idx] + ';'
      }
    }
    return s;
  }
}

export default class VerticalListCustomComponent extends React.Component {
  
  constructor(props) {
    super(props);
    let compindex = props.index;
    let pageInstance = app.getAppCurrentPage();
    this.init(compindex, pageInstance);
  }

  init = (compindex, pageInstance) => {
    let compData = pageInstance.data.eles[compindex];
    let customFeature = compData.customFeature;
    let param = {};
    let that = this;
    //根据选择的配送方式获取对应的商品
    param['pick_up_type'] = [];
    if (customFeature.pickUpArr) {
      if (customFeature.is_together) {
        if (customFeature.pickUpArr.dining) {
          param.pick_up_type.push(4);
        }
      } else {
        if (customFeature.pickUpArr.express) {
          param.pick_up_type.push(1);
        }
        if (customFeature.pickUpArr.sameJourney) {
          param.pick_up_type.push(2);
        }
        if (customFeature.pickUpArr.selfLifting) {
          param.pick_up_type.push(3);
        }
        if (customFeature.pickUpArr.dining) {
          param.pick_up_type.push(4);
        }
      }
    }
    //pick_up_type 为空后台默认返回所有商品，
    if (param.pick_up_type.length === 0) {
      param.pick_up_type.push(0);
    }
    param.form = 'goods';
    param.is_count = 0;
    pageInstance.setData({
      ['eles[' + compindex + '].pick_up_type']: param.pick_up_type,
      ['eles[' + compindex + '].buyer_info']: [],
      ['eles[' + compindex + '].user_list']: []
    });
    compData.timer = null;     //轮询定时器
    compData.loopRequest = true;  //轮询接口是否完成
    compData.is_init = true;  //首次需要重新渲染购物车
    compData.addCartComplete = true; //加购物车  成功后才拿到cart_id
    let franchisee_id = app.getPageFranchiseeId();
    if (franchisee_id) {
      compData.location_id = app.globalData[franchisee_id] ? app.globalData[franchisee_id].ec_location_id : '';
    } else {
      compData.location_id = app.globalData.ec_location_id || '';
    }
    this.verticalListCompsInit(compindex, pageInstance, param);
  }

  verticalListCompsInit = (compindex, pageInstance, par) => {
    let that = this;
    let param = par;
    pageInstance.returnToVerticalFlag = 0;
    let compData = pageInstance.data.eles[compindex];
    compData.heightFlag = true;
    compData.flag = true;
    clearInterval(compData.timer);
    let newTostoreData = {};
    newTostoreData['eles[' + compindex + '].goodsDetailShow'] = false;
    newTostoreData['eles[' + compindex + '].goodsModelShow'] = false;
    newTostoreData['eles[' + compindex + '].hideSearchInput'] = false;
    if (pageInstance.data.page_hasNavBar) {
      newTostoreData['eles[' + compindex + '].heightPx'] = app.returnListHeight(compData.customFeature.showShopInfo, 2, pageInstance.data.eles[compindex].customFeature.mode) - app.globalData.topNavBarHeight + (compData.customFeature.pickUpArr.sameJourney ? 0 : 40);
      newTostoreData['eles[' + compindex + '].searchHeight'] = app.getSystemInfoSync().windowHeight - 100 - app.globalData.topNavBarHeight;
    } else {
      newTostoreData['eles[' + compindex + '].heightPx'] = app.returnListHeight(compData.customFeature.showShopInfo, 2, pageInstance.data.eles[compindex].customFeature.mode) + (compData.customFeature.pickUpArr.sameJourney ? 0 : 40);
      newTostoreData['eles[' + compindex + '].searchHeight'] = app.getSystemInfoSync().windowHeight - 100;
    }
    newTostoreData['eles[' + compindex + '].selected'] = 1;
    newTostoreData['eles[' + compindex + '].customFeature.selected'] = 0;
    if (compData.TotalNum == undefined) {
      newTostoreData['eles[' + compindex + '].TotalNum'] = 0;
      newTostoreData['eles[' + compindex + '].TotalPrice'] = 0.00;
    }
    newTostoreData['eles[' + compindex + '].cartList'] = [{}];
    newTostoreData['eles[' + compindex + '].cartGoodsIdList'] = [];
    newTostoreData['eles[' + compindex + '].loading'] = true;
    newTostoreData['eles[' + compindex + '].loadingFail'] = false;
    if (compData.goods_data_list) {
      newTostoreData['eles[' + compindex + '].show_goods_data'] = {};
      newTostoreData['eles[' + compindex + '].goods_data_list'] = {};
    }
    newTostoreData['eles[' + compindex + '].categorySort'] = {};
    newTostoreData['eles[' + compindex + '].showSearch'] = false;
    newTostoreData['eles[' + compindex + '].goodsCateHeight'] = {}; // 每个分类的商品列表高度
    newTostoreData['eles[' + compindex + '].requestNum'] = 0;
    newTostoreData['eles[' + compindex + '].isChangeTab'] = 0;
    newTostoreData['eles[' + compindex + '].showSettlementMask'] = false;
    newTostoreData['eles[' + compindex + '].franchiseeId'] = app.getPageFranchiseeId() || '';
    pageInstance.setData(newTostoreData);
    pageInstance['verticalList'+compindex] || (pageInstance['verticalList'+compindex] = {});
    param['sort_key'] = '';
    param['sort_direction'] = 0;
    param['page'] = 1;
    param['page_size'] = 10;
    param['take_out_style'] = 1;
    if (!(compData.pick_up_type.length == 1 && compData.pick_up_type[0] == 4)) {
      !compData.currentLocationData && !compData.selectSameJourney ? this.getCurrentLocation(compindex, pageInstance) : '';
    }
    let sub_shop_app_id = app.getPageFranchiseeId();
    app.sendRequest({
      url: '/index.php?r=AppEcommerce/getPickUpGoodsTypeSetting',
      data: {
        pick_up_type: 2,
        sub_shop_app_id: sub_shop_app_id || ''
      },
      success: function (res) {
        res.data ? res.data : res.data = {};
        let newdata = {};
        res.data ? res.data : res.data = {};
        let shopInfoData = res.data;
        if (!shopInfoData.app_store_data) {
          app.sendRequest({
            url: '/index.php?r=AppEcommerce/getPickUpGoodsTypeSetting',
            data: {
              pick_up_type: 4,
              sub_shop_app_id: sub_shop_app_id || ''
            },
            success: function (res) {
              res.data ? res.data : res.data = {};
              let newdata = {};
              res.data ? res.data : res.data = {};
              let shopInfoData = res.data;
              newdata['eles[' + compindex + '].shopInfo'] = shopInfoData.app_store_data || {};
              newdata['eles[' + compindex + '].config_data'] = shopInfoData.config_data || {};
              newdata['eles[' + compindex + '].infoHeight'] = 0;
              pageInstance.setData(newdata, function () {
                app.getBoundingClientRect('.shopInfoHeight', function (rects) {
                  let animationData = {};
                  pageInstance['verticalList'+compindex]['shopInfoHeight'] || (pageInstance['verticalList'+compindex]['shopInfoHeight'] = rects[0] != undefined ? rects[0].height : 0);
                  // let animation = app.createAnimation({
                  //   duration: 200,
                  //   timingFunction: 'linear'
                  // })
                  // animation.height(pageInstance['verticalList'+compindex]['shopInfoHeight']).step();
                  // animationData['eles[' + compindex + '].shopInfoHeight'] = animation.export();
                  animationData['eles[' + compindex + '].shopHeight'] = pageInstance['verticalList'+compindex]['shopInfoHeight'];
                  pageInstance.setData(animationData);
                })
              });
            }
          })
        } else {
          newdata['eles[' + compindex + '].shopInfo'] = shopInfoData.app_store_data || {};
          newdata['eles[' + compindex + '].config_data'] = shopInfoData.config_data || {};
          newdata['eles[' + compindex + '].infoHeight'] = 0;
          pageInstance.setData(newdata, function () {
            app.getBoundingClientRect('.shopInfoHeight', function (rects) {
              let animationData = {};
              pageInstance['verticalList'+compindex]['shopInfoHeight'] || (pageInstance['verticalList'+compindex]['shopInfoHeight'] = rects[0] != undefined ? rects[0].height : 0);
              // let animation = app.createAnimation({
              //   duration: 200,
              //   timingFunction: 'linear'
              // })
              // animation.height(pageInstance['verticalList'+compindex]['shopInfoHeight']).step();
              // animationData['eles[' + compindex + '].shopInfoHeight'] = animation.export();
              animationData['eles[' + compindex + '].shopHeight'] = pageInstance['verticalList'+compindex]['shopInfoHeight'];
              pageInstance.setData(animationData);
            })
          });
        }
      }
    });

    if (compData.customFeature.databind && compData.customFeature.databind == 1) {
      app.sendRequest({
        hideLoading: true,
        url: '/index.php?r=AppShop/getGoodsCategory',
        method: 'post',
        data: {
          filter_null: 1,
          goods_type: 0,
          pick_up_type: compData.pick_up_type,
          sub_shop_app_id: app.getPageFranchiseeId() || ''
        },
        success: function (res) {
          let content = [];
          let cateData = {};
          for (let i = 0; i < res.data.length; i++) {
            content.push({
              text: res.data[i].name,
              source: res.data[i].id,
              pic: res.data[i].logo,
            })
          }
          cateData['eles[' + compindex + '].content'] = content;
          for (let j in content) {
            let cateParam = {};
            cateParam.param = {};
            Object.assign(cateParam.param, param);
            cateParam.param.idx_arr = {
              idx: 'category',
              idx_value: content[j].source == 'all' ? '' : content[j].source
            };
            cateData['eles[' + compindex + '].pagination.category' + content[j].source] = cateParam;
          }
          if (pageInstance.data.page_hasNavBar) {
            cateData['eles[' + compindex + '].heightPx'] = app.returnListHeight(compData.customFeature.showShopInfo, 2, pageInstance.data.eles[compindex].customFeature.mode) - app.globalData.topNavBarHeight + (compData.customFeature.pickUpArr.sameJourney ? 0 : 40);
            cateData['eles[' + compindex + '].searchHeight'] = app.getSystemInfoSync().windowHeight - 100 - app.globalData.topNavBarHeight;
          } else {
            cateData['eles[' + compindex + '].heightPx'] = app.returnListHeight(compData.customFeature.showShopInfo, 2, pageInstance.data.eles[compindex].customFeature.mode) + (compData.customFeature.pickUpArr.sameJourney ? 0 : 40);
            cateData['eles[' + compindex + '].searchHeight'] = app.getSystemInfoSync().windowHeight - 100;
          }
          cateData['eles[' + compindex + '].route'] = pageInstance.route;
          pageInstance.setData(cateData);
          if (compData.content.length === 0) {
            return;
          }

          if (compData.customFeature.loadAllData == '1') {
            param.page = -1;
            compData['loading'] = true;
            pageInstance.setData({
              ['eles[' + compindex + '].loadFirstCate']: true
            })
            param.idx_arr = {
              idx: 'category',
              idx_value: compData.content[0].source == 'all' ? '' : compData.content[0].source
            };
            that._getTakeoutStyleGoodsList(param, pageInstance, compindex, 1);
            for (let i = 1; i < compData.content.length; i++) {
              param.idx_arr = {
                idx: 'category',
                idx_value: compData.content[i].source == 'all' ? '' : compData.content[i].source
              };
              param.page = -1;
              that._getTakeoutStyleGoodsList(param, pageInstance, compindex, 1);
            }
          } else {
            param.page = 1;
            param.page_size = 10;
            if (content[0]) {
              param.idx_arr = {
                idx: 'category',
                idx_value: content[0].source == 'all' ? '' : content[0].source
              };
              compData['loading'] = true;
              that._getTakeoutStyleGoodsList(param, pageInstance, compindex, 1);
            }
          }

        }
      })
    } else {
      let content = compData.content;
      let cateData = {};
      for (let j in content) {
        let cateParam = {};
        cateParam.param = {};
        Object.assign(cateParam.param, param);
        cateParam.param.idx_arr = {
          idx: 'category',
          idx_value: content[j].source == 'all' ? '' : content[j].source
        };
        cateData['eles[' + compindex + '].pagination.category' + content[j].source] = cateParam;
      }
      if (pageInstance.data.page_hasNavBar) {
        cateData['eles[' + compindex + '].heightPx'] = app.returnListHeight(compData.customFeature.showShopInfo, 2, pageInstance.data.eles[compindex].customFeature.mode) - app.globalData.topNavBarHeight + (compData.customFeature.pickUpArr.sameJourney ? 0 : 40);
        cateData['eles[' + compindex + '].searchHeight'] = app.getSystemInfoSync().windowHeight - 100 - app.globalData.topNavBarHeight;
      } else {
        cateData['eles[' + compindex + '].heightPx'] = app.returnListHeight(compData.customFeature.showShopInfo, 2, pageInstance.data.eles[compindex].customFeature.mode) + (compData.customFeature.pickUpArr.sameJourney ? 0 : 40);
        cateData['eles[' + compindex + '].searchHeight'] = app.getSystemInfoSync().windowHeight - 100;
      }
      cateData['eles[' + compindex + '].route'] = pageInstance.route;
      pageInstance.setData(cateData);

      if (compData.customFeature.loadAllData == '1') {
        param.page = -1;
        pageInstance.setData({
          ['eles[' + compindex + '].loadFirstCate']: true
        })
        param.idx_arr = {
          idx: 'category',
          idx_value: compData.content[0].source == 'all' ? '' : compData.content[0].source
        };
        that._getTakeoutStyleGoodsList(param, pageInstance, compindex, 1);
        for (let i = 1; i < compData.content.length; i++) {
          param.idx_arr = {
            idx: 'category',
            idx_value: compData.content[i].source == 'all' ? '' : compData.content[i].source
          };
          param.page = -1;
          that._getTakeoutStyleGoodsList(param, pageInstance, compindex, 1);
        }
      } else {
        param.page = 1;
        param.page_size = 10;
        param.idx_arr = {
          idx: 'category',
          idx_value: content[0].source == 'all' ? '' : content[0].source
        };
        compData['loading'] = true;
        that._getTakeoutStyleGoodsList(param, pageInstance, compindex, 1);
      }
    }
  }

  verticalListChangeEvaluate = (event) => {
    let pageInstance = app.getAppCurrentPage();
    let newdata = {};
    let compindex = event.currentTarget.dataset.compindex;
    if (event.currentTarget.dataset.index == 2) {
      pageInstance.hasRequireAssess = true;
      this._getAssessList(pageInstance, compindex);
    }
    newdata['eles[' + compindex + '].selected'] = event.currentTarget.dataset.index;
    pageInstance.setData(newdata);
  }

  //显示隐藏店铺信息
  verticalListTouchstart = (event) => {
    let newdata = {};
    let pageInstance = app.getAppCurrentPage();
    let dataset = event.currentTarget.dataset;
    let compindex = dataset.compindex;
    let startPoint = {
      x: event.touches[0].pageX,
      y: event.touches[0].pageY
    }
    newdata['eles[' + compindex + '].startPoint'] = startPoint;
    pageInstance.setData(newdata);
  }

  verticalListTouchmove = (event) => {
    let newdata = {};
    let pageInstance = app.getAppCurrentPage();
    let dataset = event.currentTarget.dataset;
    let compindex = dataset.compindex;
    let compData = pageInstance.data.eles[compindex];
    if (compData['showSearch']) return;
    if (compData.customFeature.selected > 0) return;
    if (compData.customFeature.loadAllData == '1') return;
    if (!compData.shopInfo || !pageInstance['verticalList'+compindex] || (pageInstance['verticalList'+compindex] && pageInstance['verticalList'+compindex]['shopInfoHeight'] == undefined)) {
      return;
    }
    if (compData.startPoint.y - event.touches[0].pageY > 40 && compData.heightFlag && compData['infoHeight'] === 0) {
      app.getBoundingClientRect('.shopInfoHeight', function (rects) {
        // compData.heightFlag = false; // WEBAPP: 之后要去掉当前注释
        pageInstance['verticalList'+compindex]['shopInfoHeight'] = rects[0] != undefined ? rects[0].height : 0;
        // let animation = app.createAnimation({
        //   duration: 400,
        //   timingFunction: 'linear'
        // })
        // animation.translateY(-pageInstance['verticalList'+compindex]['shopInfoHeight']).height(0).step();
        // newdata['eles[' + compindex + '].shopInfoHeight'] = animation.export();
        newdata['eles[' + compindex + '].infoHeight'] = pageInstance['verticalList'+compindex]['shopInfoHeight'];
        pageInstance.setData(newdata);
      })
    }
    if (event.touches[0].pageY - compData.startPoint.y > 40 && compData.heightFlag && compData['infoHeight'] !== 0) {
      // compData.heightFlag = false; // WEBAPP: 之后要去掉当前注释
      // let animation = app.createAnimation({
      //   duration: 400,
      //   timingFunction: 'linear'
      // })
      // animation.height(pageInstance['verticalList'+compindex]['shopInfoHeight']).step();
      // newdata['eles[' + compindex + '].shopInfoHeight'] = animation.export();
      newdata['eles[' + compindex + '].infoHeight'] = 0;
      pageInstance.setData(newdata);
    }
  }

  stopAnimation = (event) => {
    let pageInstance = app.getAppCurrentPage();
    let dataset = event.currentTarget.dataset;
    let compindex = dataset.compindex;
    let compData = pageInstance.data.eles[compindex];
    compData.heightFlag = true;
  }

  verticalListShowGoodsSearch = (event) => {
    let pageInstance = app.getAppCurrentPage();
    let dataset = event.currentTarget.dataset;
    let compindex = dataset.compindex;
    let compData = pageInstance.data.eles[compindex];
    let data = {};
    data['eles[' + compindex + '].showSearch'] = true;
    if (!compData.shopInfo || !pageInstance['verticalList'+compindex] || (pageInstance['verticalList'+compindex] && pageInstance['verticalList'+compindex]['shopInfoHeight'] == undefined)) {
      return;
    }
    if (compData['show_goods_data'] && compData['show_goods_data']['searchResult']) {
      data['eles[' + compindex + '].show_goods_data.searchResult'] = [];
    }
    // let animation = app.createAnimation({
    //   duration: 300,
    //   timingFunction: 'linear'
    // })
    // animation.height(0).step();
    // data['eles[' + compindex + '].shopInfoHeight'] = animation.export();
    data['eles[' + compindex + '].infoHeight'] = pageInstance['verticalList'+compindex]['shopInfoHeight'];
    pageInstance.setData(data);
  }

  // 隐藏搜索
  verticalListHideGoodsSearch = (event) => {
    let pageInstance = app.getAppCurrentPage();
    let dataset = event.currentTarget.dataset;
    let compindex = dataset.compindex;
    let data = {};
    data['eles[' + compindex + '].showSearch'] = false;
    // let animation = app.createAnimation({
    //   duration: 300,
    //   timingFunction: 'linear'
    // })
    // animation.height(pageInstance['verticalList'+compindex]['shopInfoHeight']).step();
    // data['eles[' + compindex + '].shopInfoHeight'] = animation.export();
    data['eles[' + compindex + '].infoHeight'] = 0;
    pageInstance.data.eles[compindex].heightFlag = true;
    pageInstance.setData(data);
  }

  verticalListBindSearchTitle = (event) => {
    let pageInstance = app.getAppCurrentPage();
    let dataset = event.currentTarget.dataset;
    let compindex = dataset.compindex;
    let newdata = {};
    newdata['eles[' + compindex + '].searchTitle'] = event.target.value;
    pageInstance.setData(newdata);
  }

  verticalListSearchByTitle = (event) => {
    let pageInstance = app.getAppCurrentPage();
    let dataset = event.currentTarget.dataset;
    let compindex = dataset.compindex;
    let compData = pageInstance.data.eles[compindex];
    let newdata = {};
    let pagination = {};
    if (compData.pagination['searchResult']) {
      pagination = compData.pagination['searchResult'];
    } else {
      pagination = compData.pagination['category' + compData.content[0].source];
    }
    let param = JSON.parse(JSON.stringify(pagination.param));
    let category_arr = [];
    let hasAll = false;
    for (let i = 0; i < compData.content.length; i++) {
      if (compData.content[i].source == 'all') {
        hasAll = true;
        break;
      } else {
        category_arr.push(compData.content[i].source);
      }
    }
    hasAll ? '' : param['category_arr'] = category_arr;
    param.idx_arr['idx'] = 'title';
    param.idx_arr['idx_value'] = compData.searchTitle;
    param.page = 1;
    newdata['eles[' + compindex + '].pagination.searchResult.param'] = param;
    newdata['eles[' + compindex + '].pagination.searchResult.requesting'] = false;
    pageInstance.setData(newdata);
    this._getVerticalListListByTitle(param, pageInstance, compindex, 1);
  }

  verticalListClickCategory = (event) => {
    let pageInstance = app.getAppCurrentPage();
    let dataset = event.currentTarget.dataset;
    let compindex = dataset.compindex;
    let index = dataset.index;
    let id = dataset.id;
    let newdata = {};
    let param = JSON.parse(dataset.param);
    let compData = pageInstance.data.eles[compindex];
    let cateIndex = Number(dataset.cateindex);
    if (compData['loading'] || (pageInstance['verticalList'+compindex] && pageInstance['verticalList'+compindex]['shopInfoHeight'] == undefined)) {
      return;
    }
    if (!compData.customFeature.loadAllData || compData.customFeature.loadAllData == '0') {
      if (!(compData.show_goods_data && compData.show_goods_data['category' + id])) {
        newdata['eles[' + compindex + '].loading'] = true;
        this._getTakeoutStyleGoodsList(param, pageInstance, compindex, 0);
      }
      newdata['eles[' + compindex + '].scrollTopLoading'] = false;
      newdata['eles[' + compindex + '].scrollTop'] = '.02rem';
      newdata['eles[' + compindex + '].customFeature.selected'] = index;
      newdata['eles[' + compindex + '].loadingFail'] = false;
    } else {
      newdata['eles[' + compindex + '].customFeature.selected'] = index;
      newdata['eles[' + compindex + '].scrollInto'] = 'cate-' + cateIndex;
      newdata['eles[' + compindex + '].currentCate'] = compData.content[index].text;
    }
    if (index > 0) {
      // let animation = app.createAnimation({
      //   duration: 400,
      //   timingFunction: 'linear'
      // })
      // animation.height(0).step();
      // newdata['eles[' + compindex + '].shopInfoHeight'] = animation.export();
      newdata['eles[' + compindex + '].infoHeight'] = pageInstance['verticalList'+compindex]['shopInfoHeight'];
    }
    pageInstance.setData(newdata);
    compData['isChangeTab'] = true;
  }

  verticalListStyleScrollFunc = (event) => {
    let pageInstance = app.getAppCurrentPage();
    let dataset = event.currentTarget.dataset;
    let compindex = dataset.compindex;
    let compData = pageInstance.data.eles[compindex];
    let categoryId = compData.content[compData.customFeature.selected].source;
    let newdata = {};
    let pagination = compData.pagination['category' + categoryId];
    let param = pagination.param;
    let that = this;
    if ((pagination.requesting || pagination.is_more === 0 || compData['loading']) && !compData.loadingFail) {
      if (pagination.requesting) {
        return;
      }
      if (compData.customFeature.selected < compData.content.length - 1) {
        compData['scrollTo'] = 'bottom';
      }
      return;
    }
    newdata['eles[' + compindex + '].pagination.category' + categoryId + '.requesting'] = true;
    newdata['eles[' + compindex + '].loading'] = true;
    newdata['eles[' + compindex + '].loadingFail'] = false;
    pageInstance.setData(newdata)
    that._getTakeoutStyleGoodsList(param, pageInstance, compindex, 0);
  }

  verticalListStyleScrollTop = (event) => {
    let pageInstance = app.getAppCurrentPage();
    let dataset = event.currentTarget.dataset;
    let compindex = dataset.compindex;
    let compData = pageInstance.data.eles[compindex];
    let categoryId = compData.content[compData.customFeature.selected].source;
    let pagination = compData.pagination['category' + categoryId];
    let param = pagination.param;
    let that = this;
    if (pagination.requesting) {
      return;
    }
    if (compData.customFeature.selected > 0) {
      compData['scrollTo'] = 'top';
    }
  }

  scrollStart = (event) => {
    let pageInstance = app.getAppCurrentPage();
    let dataset = event.currentTarget.dataset;
    let compindex = dataset.compindex;
    let compData = pageInstance.data.eles[compindex];
    let startPoint = {
      x: event.touches[0].pageX,
      y: event.touches[0].pageY
    }
    compData['scrollStratPoint'] = startPoint;
  }

  scrollMove = (event) => {
    let pageInstance = app.getAppCurrentPage();
    let dataset = event.currentTarget.dataset;
    let compindex = dataset.compindex;
    let compData = pageInstance.data.eles[compindex];
    if (compData['scrollTo'] === 'bottom') {
      if (compData.scrollStratPoint.y - event.touches[0].pageY > 20) {
        if (compData['scrollTopLoading'] !== 'bottom') {
          let loadingData = {};
          compData['scrollTopLoading'] = 'bottom';
          loadingData['eles[' + compindex + '].scrollTopLoading'] = 'bottom';
          pageInstance.setData(loadingData);
        }
      }
      if (compData.startPoint.y - event.touches[0].pageY > 150) {
        compData['toCate'] = 'next';
      }
    } else if (compData['scrollTo'] === 'top') {
      if (event.touches[0].pageY - compData.scrollStratPoint.y > 50) {
        if (compData['scrollTopLoading'] !== 'top') {
          let loadingData = {};
          compData['scrollTopLoading'] = 'top';
          loadingData['eles[' + compindex + '].scrollTopLoading'] = 'top';
          pageInstance.setData(loadingData);
        }
      }
      if (event.touches[0].pageY - compData.startPoint.y > 100) {
        compData['toCate'] = 'prev';
      }
    }
  }

  scrollEnd = (event) => {
    let pageInstance = app.getAppCurrentPage();
    let dataset = event.currentTarget.dataset;
    let compindex = dataset.compindex;
    let compData = pageInstance.data.eles[compindex];
    let categoryId = compData.content[compData.customFeature.selected].source;
    let newdata = {};
    let pagination = compData.pagination['category' + categoryId];
    let param = pagination.param;
    let that = this;
    let loadingData = {};
    loadingData['eles[' + compindex + '].scrollTopLoading'] = false;
    pageInstance.setData(loadingData);
    if (compData['loading'] || !compData['toCate']) return;
    let index = +compData.customFeature.selected || 0;
    if (compData['toCate'] === 'next') {
      index = +compData.customFeature.selected + 1;
    } else if (compData['toCate'] === 'prev') {
      index = +compData.customFeature.selected - 1;
    }
    compData['toCate'] = false;
    let id = compData.content[index].source;
    if (!(compData.show_goods_data && compData.show_goods_data['category' + id])) {
      compData['loading'] = true;
      newdata['eles[' + compindex + '].loading'] = true;
      param.page = 1;
      param.idx_arr.idx_value = id == 'all' ? '' : id;
      that._getTakeoutStyleGoodsList(param, pageInstance, compindex, 0);
    }
    // newdata['eles[' + compindex + '].scrollTop'] = '2rpx';
    newdata['eles[' + compindex + '].customFeature.selected'] = index;
    newdata['eles[' + compindex + '].scrollTopLoading'] = false;
    pageInstance.setData(newdata, function () {
      compData['scrollTo'] = false;
    });
  }

  // 排序
  sortVerticalList = (event) => {
    let pageInstance = app.getAppCurrentPage();
    let dataset = event.currentTarget.dataset;
    let compindex = dataset.compindex;
    let compData = pageInstance.data.eles[compindex];
    let categoryId = compData.content[compData.customFeature.selected].source;
    let newdata = {};
    let pagination = compData.pagination['category' + categoryId];
    let param = pagination.param;
    param.idx_arr.idx_value = categoryId == 'all' ? '' : categoryId;
    let sort_key = dataset.sort_key;
    let sort_direction = dataset.direction;
    if (+sort_direction === 0) {
      sort_direction = 1;
    } else {
      sort_direction = 0;
    }
    if (!compData.categorySort) {
      sort_direction = 0;
    } else {
      if (compData.categorySort['category' + categoryId] && compData.categorySort['category' + categoryId].sortKey !== sort_key) {
        sort_direction = 0;
      }
    }
    param.sort_key = sort_key;
    param.sort_direction = sort_direction;
    param.page = 1;
    newdata['eles[' + compindex + '].categorySort'] = compData.categorySort;
    if (!newdata['eles[' + compindex + '].categorySort']) {
      newdata['eles[' + compindex + '].categorySort'] = {};
    }
    newdata['eles[' + compindex + '].categorySort']['category' + categoryId] = {
      sortKey: sort_key,
      sort_direction: sort_direction
    };
    pageInstance.setData(newdata);
    this._getTakeoutStyleGoodsList(param, pageInstance, compindex, 1);
  }

  showVerticalListGoodsDetail = (event) => {
    let pageInstance = app.getAppCurrentPage();
    let dataset = event.currentTarget.dataset;
    let id = dataset.id;
    let index = dataset.index;
    let compindex = dataset.compindex;
    let category = dataset.category;
    let is_search = dataset.is_search || '';
    let compData = pageInstance.data.eles[compindex];
    let showGoodsData;
    if (is_search == 'search') {
      showGoodsData = compData.show_goods_data['searchResult'][index];
    } else {
      showGoodsData = compData.show_goods_data['category' + category][index];
    }
    let businessTime = showGoodsData.business_time ? showGoodsData.business_time.business_time : '';
    if (businessTime) {
      let business_time = '';
      for (let key in businessTime) {
        business_time += businessTime[key].start_time.slice(0, 2) + ':' + businessTime[key].start_time.slice(2, 4) + '-' + businessTime[key].end_time.slice(0, 2) + ':' + businessTime[key].end_time.slice(2, 4) + ' ';
      }
      showGoodsData.businessTime = business_time;
    }
    showGoodsData.des = app.getWxParseResult(showGoodsData.description);
    let sub_shop_app_id = app.getPageFranchiseeId();
    app.sendRequest({
      url: '/index.php?r=AppShop/getAssessList',
      method: 'post',
      data: {
        goods_id: id,
        "idx_arr[0][idx]": 'level',
        "idx_arr[0][idx_value]": 0,
        page: 1,
        page_size: 20,
        sub_shop_app_id: sub_shop_app_id || ''
      },
      success: function (res) {
        let newdata = {};
        newdata['eles[' + compindex + '].goodsDetailShow'] = true;
        newdata['eles[' + compindex + '].hideSearchInput'] = true;
        newdata['eles[' + compindex + '].goodsDetail'] = showGoodsData;
        newdata['eles[' + compindex + '].goodsDetail']['goodsData'] = compData.goods_data_list[id];
        newdata['eles[' + compindex + '].goodsDetail']['goodsAssess'] = res;
        pageInstance.setData(newdata);
        app.sendRequest({
          hideLoading: true,
          url: '/index.php?r=AppShop/GoodsView',
          data: {
            goods_id: id
          },
          success: function () {
          }
        })
      }
    });
  }

  //减商品
  verticalListListMinus = (event) => {
    clearTimeout(this.takeoutTimeout);
    let pageInstance = app.getAppCurrentPage();
    let dataset = event.target.dataset;
    let goodsid = dataset.goodsid;
    let compindex = dataset.compindex;
    let compData = pageInstance.data.eles[compindex];
    let that = this;
    let totalNum = +compData.TotalNum;
    let totalPrice = +compData.TotalPrice;
    let newdata = {};
    let model = Number(dataset.model); // WEBAPP：处理为number类型
    let isInBusiness = dataset.isInBusiness
    if (isInBusiness == 0) {
      app.showModal({
        content: '该商品不在出售时间',
      });
      return;
    }
    if (model) {
      app.showModal({
        content: '多规格商品只能去购物车操作',
      });
      return;
    }
    if (compData.cartList[0][goodsid][0].num == 0) {
      return;
    }
    newdata['eles[' + compindex + '].goods_data_list.' + goodsid] = compData.goods_data_list[goodsid];
    newdata['eles[' + compindex + '].cartList[0].' + goodsid] = compData.cartList[0][goodsid];
    newdata['eles[' + compindex + '].TotalNum'] = --totalNum;
    newdata['eles[' + compindex + '].TotalPrice'] = (+totalPrice - Number(newdata['eles[' + compindex + '].goods_data_list.' + goodsid].calculationPrice)).toFixed(2);
    newdata['eles[' + compindex + '].isDeliver'] = (+compData.shopInfo.min_deliver_price - newdata['eles[' + compindex + '].TotalPrice']).toFixed(2);
    newdata['eles[' + compindex + '].goods_data_list.' + goodsid].totalNum--;
    newdata['eles[' + compindex + '].cartList[0].' + goodsid][0].num--;
    newdata['eles[' + compindex + '].cartList[0].' + goodsid][0].totalPrice = Number(newdata['eles[' + compindex + '].cartList[0].' + goodsid][0].num * newdata['eles[' + compindex + '].cartList[0].' + goodsid][0].calculationPrice).toFixed(2);
    pageInstance.setData(newdata, function () {
      that.takeoutTimeout = setTimeout(() => {
        let options = {
          goods_type: 0,
          cartListData: compData.cartList,
          thisPage: pageInstance,
          compindex: compindex
        }
        that._addTakeoutCart(options, that.eachCartList(options), null, goodsid);
      }, 300);
    });
  }

  //加商品
  verticalListListPlus = (event) => {
    clearTimeout(this.takeoutTimeout);
    let pageInstance = app.getAppCurrentPage();
    let dataset = event.target.dataset;
    let goodsid = dataset.goodsid;
    let compindex = dataset.compindex;
    let compData = pageInstance.data.eles[compindex];
    let that = this;
    if (compData.flag) {
      return;
    }
    compData.addCartComplete = false;
    let model = Number(dataset.model); // WEBAPP：处理为number类型
    let goodsInfo = compData.goods_data_list[goodsid];
    let totalNum = compData.TotalNum;
    let totalPrice = +compData.TotalPrice;
    let is_in_business = dataset.isInBusiness;
    let newdata = {};
    newdata['eles[' + compindex + '].modelPrice'] = 0;
    let userCart = compData.cartList[0];
    let myCartNum = 0;
    for (let k in userCart) {
      for (let j in userCart[k]) {
        myCartNum += userCart[k][j].num;
      }
    }
    if (is_in_business == 0) {
      app.showModal({
        content: '该商品不在出售时间'
      })
      return;
    }
    if (model) {
      newdata['eles[' + compindex + '].goodsModelShow'] = true;
      newdata['eles[' + compindex + '].hideSearchInput'] = true;
      newdata['eles[' + compindex + '].modelGoodsId'] = goodsid;
      newdata['eles[' + compindex + '].modelIdArr'] = [];
      for (let index = 0; index < compData.goods_data_list[goodsid]['model'].modelData.length; index++) {
        newdata['eles[' + compindex + '].modelIdArr'].push(0)
      }
      pageInstance.setData(newdata);
    } else {
      newdata['eles[' + compindex + '].goods_data_list.' + goodsid] = goodsInfo;
      newdata['eles[' + compindex + '].cartList[0].' + goodsid] = compData.cartList[0][goodsid] || {};
      let newNum = 1;
      newdata['eles[' + compindex + '].TotalNum'] = +totalNum + 1;
      newdata['eles[' + compindex + '].TotalPrice'] = (+totalPrice + +goodsInfo.calculationPrice).toFixed(2);
      newdata['eles[' + compindex + '].isDeliver'] = (+compData.shopInfo.min_deliver_price - newdata['eles[' + compindex + '].TotalPrice']).toFixed(2);
      newdata['eles[' + compindex + '].goods_data_list.' + goodsid].totalNum++;
      if (newdata['eles[' + compindex + '].cartList[0].' + goodsid][0]) {
        newdata['eles[' + compindex + '].cartList[0].' + goodsid][0].num++
        newdata['eles[' + compindex + '].cartList[0].' + goodsid][0].totalPrice = (+newdata['eles[' + compindex + '].cartList[0].' + goodsid][0].num * goodsInfo.calculationPrice).toFixed(2)
      } else {
        newdata['eles[' + compindex + '].cartList[0].' + goodsid][0] = {
          list: 'list',
          id: goodsid,
          modelId: 0,
          num: newNum,
          // price: goodsInfo.price,
          price: goodsInfo.calculationPrice,
          gooodsName: goodsInfo.name,
          totalPrice: (newNum * goodsInfo.calculationPrice).toFixed(2),
          stock: goodsInfo.stock,
          cart_id: 0,
          in_business_time: compData.goods_data_list[goodsid].in_business_time,
          pick_up_type: goodsInfo.pick_up_type,
          is_vip_goods: goodsInfo.is_vip_goods || 0
          // calculationPrice: goodsInfo.calculationPrice
        };
      }
      if (compData.cartGoodsIdList.indexOf(+goodsid) == -1) {
        newdata['eles[' + compindex + '].cartGoodsIdList'] = compData.cartGoodsIdList
        newdata['eles[' + compindex + '].cartGoodsIdList'].push(+goodsid)
      }
      myCartNum += 1;
      newdata['eles[' + compindex + '].myCartNum'] = myCartNum;
      clearInterval(compData.timer);
      compData.loopRequest = false;
      pageInstance.setData(newdata, function () {
        that.takeoutTimeout = setTimeout(() => {
          let options = {
            goods_type: 0,
            cartListData: compData.cartList,
            thisPage: pageInstance,
            compindex: compindex
          }
          that._addTakeoutCart(options, that.eachCartList(options), null, goodsid)
        }, 300);
      });
    }
  }

  //搜索下拉获取更多
  verticalListSearchScrollFunc = (event) => {
    let pageInstance = app.getAppCurrentPage();
    let dataset = event.currentTarget.dataset;
    let compindex = dataset.compindex;
    let compData = pageInstance.data.eles[compindex];
    let newdata = {};
    let pagination = compData.pagination['searchResult'];
    let param = pagination.param;
    if ((pagination.requesting || pagination.is_more === 0) && !compData.loadingFail) {
      return;
    }
    newdata['eles[' + compindex + '].loading'] = true;
    newdata['eles[' + compindex + '].loadingFail'] = false;
    pageInstance.setData(newdata)
    this._getVerticalListListByTitle(param, pageInstance, compindex, 0);
  }

  // 搜索商品
  _getVerticalListListByTitle = (param, pageInstance, compindex, isOnShow) => {
    let _this = this;
    pageInstance.requesting = true;
    let newdata = {};
    newdata['eles[' + compindex + '].searchLoading'] = true;
    pageInstance.setData(newdata);
    param.form = 'goods';
    param.only_display_common = 0;
    app.sendRequest({
      hideLoading: true,
      url: '/index.php?r=AppShop/GetGoodsList',
      data: param,
      method: 'post',
      success: function (res) {
        if (res.status == 0) {
          pageInstance.requesting = false;
          newdata['eles[' + compindex + '].searchLoading'] = false;
          let compData = pageInstance.data.eles[compindex],
            isRequireing = {},
            categoryList = {};
          isRequireing['eles[' + compindex + '].pagination.searchResult'] = compData.pagination['searchResult'];
          isRequireing['eles[' + compindex + '].pagination.searchResult'].requesting = false;
          pageInstance.setData(isRequireing);
          if (!compData.show_goods_data || (compData.show_goods_data && !compData.show_goods_data['searchResult']) || isOnShow == 1) {
            categoryList['searchResult'] = []
          } else {
            categoryList['searchResult'] = compData.show_goods_data['searchResult']
          }
          if (compData.goods_data_list) {
            newdata['eles[' + compindex + '].goods_data_list'] = compData.goods_data_list
          } else {
            newdata['eles[' + compindex + '].goods_data_list'] = {}
          }
          if (!pageInstance['verticalList'+compindex]['goods_model_list']) {
            pageInstance['verticalList'+compindex]['goods_model_list'] = {};
          }
          for (let i in res.data) {
            let form_data = res.data[i].form_data
            categoryList['searchResult'].push({
              app_id: form_data.app_id,
              cover: form_data.cover,
              description: form_data.description,
              goods_model: form_data.goods_model ? form_data.goods_model.length : 0,
              id: form_data.id,
              price: form_data.price,
              sales: form_data.sales,
              title: form_data.title,
              business_time: form_data.business_time,
              is_in_business_time: form_data.goods_in_business_time,
              stock: form_data.stock,
              virtual_price: form_data.virtual_price,
              vipGoods: (form_data.paid_vip_card_condition || form_data.paid_vip_level_condition || form_data.vip_card_condition || form_data.vip_level_condition) ? true : false,
              integral: form_data.integral,
              img_urls: form_data.img_urls || [],
              vip_price: form_data.vip_min_price == form_data.vip_max_price ? form_data.vip_min_price : form_data.vip_min_price + '~' + form_data.vip_max_price,
              vip_goods_price: form_data.vip_goods_price && form_data.vip_goods_price !== 0 && !compData.customFeature.is_together ? Number(form_data.vip_goods_price).toFixed(2) : null,
              calculationPrice: form_data.vip_goods_price && form_data.vip_goods_price !== 0 && !compData.customFeature.is_together ? Number(form_data.vip_goods_price).toFixed(2) : form_data.price,
              is_vip_goods: form_data.is_vip_goods || 0
            });
            newdata['eles[' + compindex + '].goods_data_list']['' + form_data.id + ''] = {
              totalNum: 0,
              stock: form_data.stock,
              goods_model: form_data.goods_model ? form_data.goods_model.length : 0,
              name: form_data.title,
              price: form_data.price,
              in_business_time: form_data.goods_in_business_time,
              model: {},
              goods_model: {},
              vip_price: form_data.vip_min_price == form_data.vip_max_price ? form_data.vip_min_price : form_data.vip_min_price + '~' + form_data.vip_max_price,
              vip_goods_price: form_data.vip_goods_price && form_data.vip_goods_price !== 0 && !compData.customFeature.is_together ? Number(form_data.vip_goods_price).toFixed(2) : null,
              calculationPrice: form_data.vip_goods_price && form_data.vip_goods_price !== 0 && !compData.customFeature.is_together ? Number(form_data.vip_goods_price).toFixed(2) : form_data.price,
              is_vip_goods: form_data.is_vip_goods || 0
            }
            if (form_data.goods_model) {
              let new_goods_model = {}
              for (let i in form_data.goods_model) {
                new_goods_model[form_data.goods_model[i].id] = {
                  model: form_data.goods_model[i].model,
                  stock: form_data.goods_model[i].stock,
                  price: form_data.goods_model[i].price,
                  goods_id: form_data.goods_model[i].goods_id,
                  totalNum: 0,
                  vip_price: form_data.vip_price && form_data.vip_price !== 0 ? Number(form_data.vip_price).toFixed(2) : null,
                  calculationPrice: form_data.vip_price && form_data.vip_price !== 0 ? Number(form_data.vip_price).toFixed(2) : form_data.price,
                  is_vip_goods: form_data.is_vip_goods || 0
                }
              }
              newdata['eles[' + compindex + '].goods_data_list']['' + form_data.id + '']['model'] = {
                modelData: [],
                name: form_data.title
              }
              pageInstance['verticalList'+compindex]['goods_model_list'][form_data.id] = {
                goods_model: new_goods_model
              }
              for (let k in form_data.model) {
                newdata['eles[' + compindex + '].goods_data_list']['' + form_data.id + '']['model']['modelData'].push({
                  name: form_data.model[k].name,
                  subModelName: form_data.model[k].subModelName,
                  subModelId: form_data.model[k].subModelId
                })
              }
            } else {
              newdata['eles[' + compindex + '].goods_data_list']['' + form_data.id + '']['model'] = {};
              newdata['eles[' + compindex + '].goods_data_list']['' + form_data.id + '']['model'][0] = {
                price: form_data.price,
                num: 0,
                stock: form_data.stock,
                vip_price: form_data.vip_price && form_data.vip_price !== 0 ? Number(form_data.vip_price).toFixed(2) : null,
                calculationPrice: form_data.vip_price && form_data.vip_price !== 0 ? Number(form_data.vip_price).toFixed(2) : form_data.price,
                is_vip_goods: (form_data.is_vip_goods && form_data.vip_goods_price != form_data.price) || 0
              }
            }
          }
          newdata['eles[' + compindex + '].show_goods_data.searchResult'] = categoryList['searchResult'];
          newdata['eles[' + compindex + '].in_business_time'] = res.in_business_time;
          newdata['eles[' + compindex + '].pagination.searchResult'] = compData.pagination['searchResult'];
          param.page = res.current_page + 1;
          newdata['eles[' + compindex + '].pagination.searchResult'].param = param;
          newdata['eles[' + compindex + '].pagination.searchResult'].is_more = res.is_more;
          newdata['eles[' + compindex + '].pagination.searchResult'].current_page = res.current_page;
          newdata['eles[' + compindex + '].modelChoose'] = [];
          newdata['eles[' + compindex + '].modelIdArr'] = [];
          newdata['eles[' + compindex + '].loading'] = false;
          newdata['eles[' + compindex + '].loadingFail'] = false;
          pageInstance.setData(newdata);
          if (compData.customFeature.is_together) {
            compData.loopRequest = true;
            _this.getMultiOrderingVerticalCart(compindex, pageInstance);
          } else {
            _this._getTakeoutStyleCartList(pageInstance, compindex);
          }
        }
      },
      fail: function () {
        newdata['eles[' + compindex + '].loadingFail'] = true;
        newdata['eles[' + compindex + '].loading'] = false;
        newdata['eles[' + compindex + '].searchLoading'] = false;
        pageInstance.setData(newdata);
      },
      complete: function () {
        setTimeout(function () {
          pageInstance.requesting = false;
        }, 300);
      }
    });
  }

  //显示购物车
  verticalListShowShoppingCartPop = (event) => {
    let pageInstance = app.getAppCurrentPage();
    let dataset = event.currentTarget.dataset;
    let compindex = dataset.compindex;
    let isShowShoppingCart = dataset.isshow;
    let newdata = {};
    if (isShowShoppingCart) {
      newdata['eles[' + compindex + '].shoppingCartShow'] = false;
    } else {
      newdata['eles[' + compindex + '].shoppingCartShow'] = true;
    }
    pageInstance.setData(newdata);
  }

  //结算（旧版）
  verticalListChooseComplete = (event) => {
    clearTimeout(this.takeoutTimeout);
    let pageInstance = app.getAppCurrentPage();
    let compindex = event.target.dataset.compindex;
    let compData = pageInstance.data.eles[compindex];
    let that = this;
    if (!compData.TotalNum) {
      return;
    }
    this.takeoutTimeout = setTimeout(() => {
      let options = {
        goods_type: 0,
        cartListData: compData.cartList,
        thisPage: pageInstance,
        compindex: compindex
      }
      that._addTakeoutCart(options, that.eachCartList(options), (idArr) => {
        let franchiseeId = app.getPageFranchiseeId();
        let franchiseeParam = franchiseeId ? ('&franchisee=' + franchiseeId) : '';
        pageInstance.returnToVerticalFlag = 1;
        app.turnToPage('/orderMeal/pages/previewOrderDetail/previewOrderDetail?cart_arr=' + idArr + franchiseeParam);
      })
    }, 300);
  }

  //切换评论类别
  verticalListChangeAssessType = (event) => {
    let pageInstance = app.getAppCurrentPage();
    let newdata = {};
    let assessActive = event.currentTarget.dataset.active;
    let showAssess = [];
    let compindex = event.currentTarget.dataset.compindex;
    let compData = pageInstance.data.eles[compindex];
    newdata['eles[' + compindex + '].assessActive'] = assessActive;
    for (let i = 0; i < compData.assessList.length; i++) {
      let alist = compData.assessList[i];
      if (assessActive == 0) {
        alist.assess_info.has_img == 1 ? showAssess.push(alist) : null;
      } else if (alist.assess_info.level == assessActive) {
        showAssess.push(alist);
      }
    }
    newdata['eles[' + compindex + '].showAssess'] = showAssess;
    pageInstance.setData(newdata);
  }

  //获取更多评论
  verticalListGetMoreAssess = (event) => {
    let dataset = event.currentTarget.dataset;
    let page = dataset.nextpage;
    let compindex = dataset.compindex;
    let pageInstance = app.getAppCurrentPage();
    let compData = pageInstance.data.eles[compindex];
    let newdata = {};
    app.sendRequest({
      hideLoading: true,
      url: '/index.php?r=AppShop/getAssessList',
      method: 'post',
      data: {
        "idx_arr[0][idx]": 'goods_type',
        "idx_arr[0][idx_value]": 0,
        page: page,
        page_size: 20,
        obj_name: 'app_id'
      },
      chain: true,
      subshop: pageInstance.franchiseeId || '',
      success: function (res) {
        let alist = compData.assessList;
        for (let i in res.data) {
          alist.push(res.data[i]);
        }
        newdata['eles[' + compindex + '].assessList'] = alist;
        let commentNums = [],
          showAssess = [],
          hasImgAssessList = 0,
          goodAssess = 0,
          normalAssess = 0,
          badAssess = 0;
        for (let i = 0; i < alist.length; i++) {
          let listItem = alist[i];
          listItem.assess_info.has_img == 1 ? hasImgAssessList++ : null;
          listItem.assess_info.level == 3 ? goodAssess++ : (listItem.assess_info.level == 1 ? badAssess++ : normalAssess++)
          if (listItem.assess_info.has_img == 1 && compData.assessActive == 0) {
            showAssess.push(listItem);
          } else if (listItem.assess_info.level == 3 && compData.assessActive == 3) {
            showAssess.push(listItem);
          } else if (listItem.assess_info.level == 1 && compData.assessActive == 1) {
            showAssess.push(listItem);
          } else if (listItem.assess_info.level == 2 && compData.assessActive == 2) {
            showAssess.push(listItem);
          }
        }
        commentNums = [hasImgAssessList, goodAssess, normalAssess, badAssess];
        newdata['eles[' + compindex + '].commentNums'] = commentNums;
        newdata['eles[' + compindex + '].assessCurrentPage'] = page;
        newdata['eles[' + compindex + '].showAssess'] = showAssess;
        newdata['eles[' + compindex + '].moreAssess'] = res.is_more;
        pageInstance.setData(newdata);
      }
    })
  }

  //打开地图
  openVerticalListLocation = (event) => {
    let dataset = event.currentTarget.dataset;
    app.openLocation({
      latitude: +dataset.lat,
      longitude: +dataset.lng,
      name: dataset.name,
      address: dataset.address
    })
  }

  verticalListHideDetailPop = (event) => {
    let pageInstance = app.getAppCurrentPage();
    let dataset = event.currentTarget.dataset;
    let compindex = dataset.compindex;
    let newdata = {};
    newdata['eles[' + compindex + '].goodsDetailShow'] = false;
    newdata['eles[' + compindex + '].hideSearchInput'] = false;
    pageInstance.setData(newdata);
  }

  //获取单个商品评论
  verticalListGetMoreGoodsAssess = (event) => {
    let pageInstance = app.getAppCurrentPage();
    let dataset = event.currentTarget.dataset;
    let compindex = dataset.compindex;
    let sub_shop_app_id = app.getPageFranchiseeId();
    let compData = pageInstance.data.eles[compindex];
    let newdata = {};

    app.sendRequest({
      url: '/index.php?r=AppShop/getAssessList',
      method: 'post',
      data: {
        goods_id: compData.goodsDetail.id,
        "idx_arr[0][idx]": 'level',
        "idx_arr[0][idx_value]": 0,
        page: compData.goodsDetail.goodsAssess.current_page + 1,
        page_size: 20,
        sub_shop_app_id: sub_shop_app_id || ''
      },
      success: function (res) {
        newdata['eles[' + compindex + '].goodsDetail'] = compData['goodsDetail'];
        newdata['eles[' + compindex + '].goodsDetail']['goodsAssess']['data'] = compData['goodsDetail']['goodsAssess']['data'].concat(res.data);
        newdata['eles[' + compindex + '].goodsDetail']['goodsAssess']['is_more'] = res.is_more;
        newdata['eles[' + compindex + '].goodsDetail']['goodsAssess']['current_page'] = res.current_page;
        pageInstance.setData(newdata)
      }
    });
  }

  //隐藏选择规格弹窗
  verticalListHideModelPop = (event) => {
    let pageInstance = app.getAppCurrentPage();
    let dataset = event.currentTarget.dataset;
    let compindex = dataset.compindex;
    let newdata = {};
    newdata['eles[' + compindex + '].goodsModelShow'] = false;
    newdata['eles[' + compindex + '].hideSearchInput'] = false;
    newdata['eles[' + compindex + '].modelPrice'] = 0;
    newdata['eles[' + compindex + '].modelChoose'] = [];
    newdata['eles[' + compindex + '].modelIdArr'] = [];
    newdata['eles[' + compindex + '].modelNum'] = 0;
    newdata['eles[' + compindex + '].addCartComplete'] = true;
    pageInstance.setData(newdata);
  }

  //选择规格
  verticalListChooseModel = (event) => {
    let pageInstance = app.getAppCurrentPage();
    let dataset = event.currentTarget.dataset;
    let pIndex = dataset.parentindex;
    let index = dataset.index;
    let compindex = dataset.compindex;
    let goodsid = dataset.goodsid;
    let compData = pageInstance.data.eles[compindex];
    let modelData = compData.goods_data_list[goodsid]['model'].modelData;
    let newdata = {};
    newdata['eles[' + compindex + '].modelChoose'] = compData.modelChoose;
    newdata['eles[' + compindex + '].modelIdArr'] = compData.modelIdArr;
    newdata['eles[' + compindex + '].modelChoose'][pIndex] = modelData[pIndex].subModelName[index];
    newdata['eles[' + compindex + '].modelIdArr'][pIndex] = modelData[pIndex].subModelId[index];
    pageInstance.setData(newdata);
    this._ModelPirce(dataset, [].concat(newdata['eles[' + compindex + '].modelIdArr']));
  }

  //商品规格价格
  _ModelPirce = (dataset, modelNameArr) => {
    let pageInstance = app.getAppCurrentPage();
    let newdata = {};
    let compindex = dataset.compindex;
    let goods_model = pageInstance['verticalList'+compindex].goods_model_list[dataset.goodsid].goods_model;
    let compData = pageInstance.data.eles[compindex];
    for (let i in goods_model) {
      if (goods_model[i].model.split(',').sort().join(',') == modelNameArr.sort().join(',')) {
        newdata['eles[' + compindex + '].modelChooseId'] = i;
        if (goods_model[i].is_vip_goods  && !compData.customFeature.is_together){
          newdata['eles[' + compindex + '].modelPrice'] = goods_model[i].vip_price;
          goods_model[i].vip_price != goods_model[i].price ? newdata['eles[' + compindex + '].isModelPrice'] = true : newdata['eles[' + compindex + '].isModelPrice'] = false;
        } else {
          newdata['eles[' + compindex + '].modelPrice'] = goods_model[i].price;
          newdata['eles[' + compindex + '].isModelPrice'] = false;
        }

        if (compData.cartList[0][dataset.goodsid] && compData.cartList[0][dataset.goodsid][i]) {
          newdata['eles[' + compindex + '].modelNum'] = compData.cartList[0][dataset.goodsid][i].num;
        } else {
          newdata['eles[' + compindex + '].modelNum'] = 0;
        }
      }
    }
    pageInstance.setData(newdata)
  }

  //加多规格商品
  verticalListSureChooseModel = (event) => {
    clearTimeout(this.takeoutTimeout);
    let pageInstance = app.getAppCurrentPage();
    let dataset = event.currentTarget.dataset;
    let newdata = {};
    let compindex = dataset.compindex;
    let compData = pageInstance.data.eles[compindex];
    let goodsid = compData.modelGoodsId;
    let price = +compData.modelPrice;
    let modelId = compData.modelChooseId;
    let thisModelInfo = pageInstance['verticalList'+compindex].goods_model_list[goodsid].goods_model[modelId];
    if (!compData.modelPrice) {
      app.showModal({
        content: '请选择规格'
      });
      return;
    }
    if (thisModelInfo.stock <= thisModelInfo.totalNum) {
      app.showModal({
        content: '该规格库存不足'
      });
      return;
    }
    newdata['eles[' + compindex + '].mdelInfo'] = thisModelInfo;
    newdata['eles[' + compindex + '].cartGoodsIdList'] = compData.cartGoodsIdList;
    let goods_num = thisModelInfo.totalNum + 1;
    newdata['eles[' + compindex + '].goods_data_list.' + goodsid] = compData.goods_data_list[goodsid];
    newdata['eles[' + compindex + '].goods_data_list.' + goodsid].totalNum = compData.goods_data_list[goodsid].totalNum + 1;
    newdata['eles[' + compindex + '].goods_data_list.' + goodsid].goods_model[modelId] = thisModelInfo;
    newdata['eles[' + compindex + '].goods_data_list.' + goodsid].goods_model[modelId].totalNum++;
    newdata['eles[' + compindex + '].TotalPrice'] = (Number(compData.TotalPrice) + Number(price)).toFixed(2);
    newdata['eles[' + compindex + '].isDeliver'] = (+compData.shopInfo.min_deliver_price - newdata['eles[' + compindex + '].TotalPrice']).toFixed(2);
    newdata['eles[' + compindex + '].TotalNum'] = ++compData.TotalNum;
    newdata['eles[' + compindex + '].hideSearchInput'] = false;
    newdata['eles[' + compindex + '].cartList[0].' + goodsid] = compData.cartList[0][goodsid] || {};
    newdata['eles[' + compindex + '].cartList[0].' + goodsid][modelId] = {
      modelName: compData.modelChoose.join(' | '),
      modelId: modelId,
      num: goods_num,
      price: price,
      id: goodsid,
      gooodsName: compData.goods_data_list[goodsid].name,
      totalPrice: (thisModelInfo.totalNum * price).toFixed(2),
      stock: thisModelInfo.stock,
      cart_id: 0,
      pick_up_type: compData.goods_data_list[goodsid].pick_up_type
    }
    if (!compData.customFeature.is_together && compData.goods_data_list[goodsid].is_vip_goods){
      newdata['eles[' + compindex + '].cartList[0].' + goodsid][modelId].is_vip_goods = 1;
    }
    if (newdata['eles[' + compindex + '].cartGoodsIdList'].indexOf(+goodsid) == -1) {
      newdata['eles[' + compindex + '].cartGoodsIdList'].push(+goodsid);
    }
    if (compData['modelNum']) {
      newdata['eles[' + compindex + '].modelNum'] = +compData['modelNum'] + 1;
    } else {
      newdata['eles[' + compindex + '].modelNum'] = 1;
    }

    pageInstance.setData(newdata, function () {
      let userCart = compData.cartList[0];
      let myCartNum = 0;
      for (let k in userCart) {
        for (let j in userCart[k]) {
          myCartNum += userCart[k][j].num;
        }
      }
      pageInstance.setData({
        ['eles[' + compindex + '].myCartNum']: myCartNum
      })
    });
    this.takeoutTimeout = setTimeout(() => {
      let options = {
        goods_type: 0,
        cartListData: compData.cartList,
        thisPage: pageInstance,
        compindex: compindex
      }
      this._addTakeoutCart(options, this.eachCartList(options), null, goodsid)
    }, 300)
  }

  //减多规格商品
  verticalListMinuModel = (event) => {
    clearTimeout(this.takeoutTimeout);
    let pageInstance = app.getAppCurrentPage();
    let dataset = event.currentTarget.dataset;
    let newdata = {};
    let compindex = dataset.compindex;
    let compData = pageInstance.data.eles[compindex];
    let goodsid = compData.modelGoodsId;
    let price = +compData.modelPrice;
    let modelid = compData.modelChooseId;
    newdata['eles[' + compindex + '].cartList[0].' + goodsid] = compData.cartList[0][goodsid];
    newdata['eles[' + compindex + '].goods_data_list.' + goodsid] = compData.goods_data_list[goodsid];
    newdata['eles[' + compindex + '].TotalNum'] = --compData.TotalNum;
    newdata['eles[' + compindex + '].TotalPrice'] = (Number(compData.TotalPrice) - Number(price)).toFixed(2);
    newdata['eles[' + compindex + '].isDeliver'] = (+compData.shopInfo.min_deliver_price - newdata['eles[' + compindex + '].TotalPrice']).toFixed(2);
    newdata['eles[' + compindex + '].cartList[0].' + goodsid][modelid].num--;
    newdata['eles[' + compindex + '].cartList[0].' + goodsid][modelid].totalPrice = Number(price * newdata['eles[' + compindex + '].cartList[0].' + goodsid][modelid].num).toFixed(2);
    newdata['eles[' + compindex + '].modelNum'] = --compData.modelNum;
    if (newdata['eles[' + compindex + '].goods_data_list.' + goodsid]) {
      newdata['eles[' + compindex + '].goods_data_list.' + goodsid].totalNum--;
    }
    let thisModelInfo = pageInstance['verticalList'+compindex].goods_model_list[goodsid];
    if (thisModelInfo && thisModelInfo.goods_model) {
      thisModelInfo.goods_model[modelid].totalNum--;
    }
    pageInstance.setData(newdata, function () {
      let userCart = compData.cartList[0];
      let myCartNum = 0;
      for (let k in userCart) {
        for (let j in userCart[k]) {
          myCartNum += userCart[k][j].num;
        }
      }
      pageInstance.setData({
        ['eles[' + compindex + '].myCartNum']: myCartNum
      })
    });
    this.takeoutTimeout = setTimeout(() => {
      let options = {
        goods_type: 0,
        cartListData: pageInstance.data.eles[compindex].cartList,
        thisPage: pageInstance,
        compindex: compindex
      }
      this._addTakeoutCart(options, this.eachCartList(options), null, goodsid)
    }, 300);
  }

  //隐藏购物车
  verticalListHideShoppingCart = (event) => {
    let pageInstance = app.getAppCurrentPage();
    let dataset = event.currentTarget.dataset;
    let compindex = dataset.compindex;
    let newdata = {};
    newdata['eles[' + compindex + '].shoppingCartShow'] = false;
    pageInstance.setData(newdata);
  }

  verticalListDeleteAllCarts = (event) => {
    let compindex = event.currentTarget.dataset.compindex;
    let pageInstance = app.getAppCurrentPage();
    let compData = pageInstance.data.eles[compindex];
    let cartIds = [];
    cartIds = this.getCartIdArray(compindex, pageInstance);
    if (cartIds.length == 0) {
      app.showModal({
        content: '请先添加商品'
      });
      return;
    }
    this._removeFromCart(cartIds, () => {
      this._removeFromCartCallback({
        compData: compData,
        compindex: compindex,
        thisPage: pageInstance
      })
    }, compindex)
  }

  _removeFromCartCallback = (options) => {
    let n = {};
    let c = options.compindex;
    let goods_data_list = options.compData.goods_data_list;
    let pageInstance = app.getAppCurrentPage();
    let goods_model_list = pageInstance.data.eles[c]['goods_model_list'];
    n['eles[' +c + '].cartList'] = [{}];
    n['eles[' +c + '].cart_data'] = [];
    for (let i in goods_data_list) {
      goods_data_list[i].totalNum = 0;
    }
    for (let i in goods_model_list) {
      for (let j in goods_model_list[i].goods_model) {
        goods_model_list[i].goods_model[j].totalNum = 0
      }
    }
    n['eles[' +c + '].goods_data_list'] = goods_data_list;
    n['eles[' +c + '].cartGoodsIdList'] = [];
    n['eles[' +c + '].TotalNum'] = 0;
    n['eles[' +c + '].TotalPrice'] = 0;
    options.compData.shopInfo.min_deliver_price ? n['eles[' +c + '].isDeliver'] = options.compData.shopInfo.min_deliver_price : '';
    n['eles[' +c + '].shoppingCartShow'] = true;
    options.thisPage.setData(n);
  }

  //购物车减商品
  verticalListCartListMinus = (event) => {
    clearTimeout(this.takeoutTimeout);
    let pageInstance = app.getAppCurrentPage();
    let dataset = event.currentTarget.dataset;
    let data = pageInstance.data;
    let newdata = {};
    let compindex = dataset.compindex;
    let goodsid = dataset.goodsid;
    let price = dataset.price;
    let modelid = dataset.modelid;
    let compData = pageInstance.data.eles[compindex];
    let index = dataset.index;
    let id = dataset.id;
    if (compData.cartList[index][goodsid][modelid].num == 0) {
      return;
    }
    newdata['eles[' + compindex + '].cartList' + '[' + index + '].' + goodsid] = compData.cartList[index][goodsid];
    if (compData.goods_data_list[goodsid]) {
      newdata['eles[' + compindex + '].goods_data_list.' + goodsid] = compData.goods_data_list[goodsid];
    }
    if (modelid != 0) {
      if (pageInstance['verticalList'+compindex]['goods_model_list'][goodsid] && pageInstance['verticalList'+compindex]['goods_model_list'][goodsid].goods_model) {
        pageInstance['verticalList'+compindex]['goods_model_list'][goodsid].goods_model[modelid].totalNum--;
      }
    }
    newdata['eles[' + compindex + '].TotalNum'] = --compData.TotalNum;
    newdata['eles[' + compindex + '].TotalPrice'] = (Number(compData.TotalPrice) - Number(price)).toFixed(2);
    newdata['eles[' + compindex + '].isDeliver'] = (+compData.shopInfo.min_deliver_price - newdata['eles[' + compindex + '].TotalPrice']).toFixed(2);
    newdata['eles[' + compindex + '].cartList' + '[' + index + '].' + goodsid][modelid].num--;
    newdata['eles[' + compindex + '].cartList' + '[' + index + '].' + goodsid][modelid].totalPrice = Number(price * newdata['eles[' + compindex + '].cartList' + '[' + index + '].' + goodsid][modelid].num).toFixed(2);
    if (newdata['eles[' + compindex + '].goods_data_list.' + goodsid]) {
      newdata['eles[' + compindex + '].goods_data_list.' + goodsid].totalNum--;
    }
    if (index === 0) {
      let userCart = compData.cartList[0];
      let myCartNum = 0;
      for (let k in userCart) {
        for (let j in userCart[k]) {
          myCartNum += userCart[k][j].num;
        }
      }
      newdata['eles[' + compindex + '].myCartNum'] = myCartNum
    }
    clearInterval(compData.timer);
    compData.loopRequest = false;
    pageInstance.setData(newdata);
    this.takeoutTimeout = setTimeout(() => {
      let options = {
        goods_type: 0,
        cartListData: compData.cartList,
        thisPage: pageInstance,
        compindex: compindex,
        index: index || 0
      }
      this._addTakeoutCart(options, this.eachCartList(options), null, goodsid)
    }, 300);
  }

  //购物车加商品
  verticalListCartListPlus = (event) => {
    clearTimeout(this.takeoutTimeout);
    let pageInstance = app.getAppCurrentPage();
    let newdata = {};
    let dataset = event.currentTarget.dataset;
    let goodsid = dataset.goodsid;
    let modelid = dataset.modelid;
    let is_in_business = dataset.isInBusiness;
    let num = dataset.num;
    let stock = dataset.stock;
    let compindex = dataset.compindex;
    let compData = pageInstance.data.eles[compindex];
    let index = dataset.index;
    let id = dataset.id;
    if (num == stock) {
      app.showModal({
        content: '该商品库存不足'
      });
      return;
    }
    if (is_in_business == 0) {
      app.showModal({
        content: '该商品不在出售时间'
      })
      return;
    }
    if (compData.goods_data_list[goodsid]) {
      newdata['eles[' + compindex + '].goods_data_list.' + goodsid] = compData.goods_data_list[goodsid]
    }
    newdata['eles[' + compindex + '].cartList' + '[' + index + '].' + goodsid] = compData.cartList[index][goodsid];
    newdata['eles[' + compindex + '].TotalNum'] = compData.TotalNum + 1;
    newdata['eles[' + compindex + '].TotalPrice'] = (Number(compData.TotalPrice) + Number(compData.cartList[index][goodsid][modelid].price)).toFixed(2);
    newdata['eles[' + compindex + '].isDeliver'] = (+compData.shopInfo.min_deliver_price - newdata['eles[' + compindex + '].TotalPrice']).toFixed(2);
    if (+modelid) {
      if (compData.goods_data_list[goodsid]) {
        newdata['eles[' + compindex + '].goods_data_list.' + goodsid].totalNum = ++compData.goods_data_list[goodsid].totalNum
      }
      newdata['eles[' + compindex + '].cartList' + '[' + index + '].' + goodsid][modelid].num = ++compData.cartList[index][goodsid][modelid].num;
      newdata['eles[' + compindex + '].cartList' + '[' + index + '].' + goodsid][modelid].totalPrice = Number(newdata['eles[' + compindex + '].cartList' + '[' + index + '].' + goodsid][modelid].num * compData.cartList[index][goodsid][modelid].price).toFixed(2);
      if (pageInstance['verticalList'+compindex]['goods_model_list'][goodsid]) {
        pageInstance['verticalList'+compindex]['goods_model_list'][goodsid].goods_model[modelid].totalNum++;
      }
    } else {
      if (compData.goods_data_list[goodsid] && compData.goods_data_list[goodsid].totalNum) {
        newdata['eles[' + compindex + '].goods_data_list.' + goodsid].totalNum = ++compData.goods_data_list[goodsid].totalNum
        newdata['eles[' + compindex + '].cartList' + '[' + index + '].' + goodsid][0].num++;
        newdata['eles[' + compindex + '].cartList' + '[' + index + '].' + goodsid][0].totalPrice = Number(newdata['eles[' + compindex + '].cartList' + '[' + index + '].' + goodsid][0].num * newdata['eles[' + compindex + '].cartList' + '[' + index + '].' + goodsid][0].price).toFixed(2);
      } else {
        newdata['eles[' + compindex + '].cartList' + '[' + index + '].' + goodsid][0].num++;
        newdata['eles[' + compindex + '].cartList' + '[' + index + '].' + goodsid][0].totalPrice = Number(newdata['eles[' + compindex + '].cartList' + '[' + index + '].' + goodsid][0].num * newdata['eles[' + compindex + '].cartList' + '[' + index + '].' + goodsid][0].price).toFixed(2);
      }
    }
    clearInterval(compData.timer);
    compData.loopRequest = false;
    pageInstance.setData(newdata);
    this.takeoutTimeout = setTimeout(() => {
      let options = {
        goods_type: 0,
        cartListData: compData.cartList,
        thisPage: pageInstance,
        compindex: compindex,
        index: index || 0
      }
      this._addTakeoutCart(options, this.eachCartList(options), null, goodsid)
    }, 300);
  }

  verticalListHideCouponsList = (event) => {
    let pageInstance = app.getAppCurrentPage();
    let dataset = event.currentTarget.dataset;
    let compindex = dataset.compindex;
    let newdata = {};
    newdata['eles[' + compindex + '].shoppingCouponsList'] = false;
    pageInstance.setData(newdata);
  }

  tapVerticalListCoupon = (event) => {
    let coupon_id = event.currentTarget.dataset.id;
    let franchisee = app.getPageFranchiseeId();
    let chainParam = franchisee ? '&franchisee=' + franchisee : '';
    pageInstance.returnToVerticalFlag = 1;
    app.turnToPage('/pages/couponDetail/couponDetail?detail=' + coupon_id + chainParam);
  }

  deleteSingleCarts = (event) => {
    let dataset = event.currentTarget.dataset;
    let pageInstance = app.getAppCurrentPage();
    let compindex = dataset.compindex;
    let goodsid = dataset.goodsid;
    let modelid = dataset.modelid;
    let compData = pageInstance.data.eles[compindex];
    this._removeFromCart([compData.cartList[0][goodsid][modelid].cart_id], () => {
      let newdata = {};
      let num = compData.cartList[0][goodsid][modelid].num;
      let price = (compData.cartList[0][goodsid][modelid].price * num).toFixed(2)
      delete compData.cart_data[goodsid][modelid]
      delete compData.cartList[0][goodsid][modelid]
      if (util.isPlainObject(compData.cart_data[goodsid])) {
        delete compData.cart_data[goodsid]
        delete compData.cartList[0][goodsid]
      }
      newdata['eles[' + compindex + '].goods_data_list.' + goodsid + '.totalNum'] = compData.goods_data_list[goodsid].totalNum - num;
      newdata['eles[' + compindex + '].cart_data'] = compData.cart_data;
      newdata['eles[' + compindex + '].cartList[0]'] = compData.cartList[0];
      newdata['eles[' + compindex + '].TotalNum'] = compData.TotalNum - num;
      newdata['eles[' + compindex + '].TotalPrice'] = (compData.TotalPrice - +price).toFixed(2);
      pageInstance.setData(newdata);
    }, compindex)
  }

  //清空购物车
  _removeFromCart = (cart_id, callback, compindex) => {
    let pageInstance = app.getAppCurrentPage();
    let compData = pageInstance.data.eles[compindex];
    let that = this;
    let data = {
      cart_id_arr: cart_id,
    }
    compData.location_id ? data.location_id = compData.location_id : data = data;
    compData.loopRequest = false;
    clearInterval(compData.timer);
    app.sendRequest({
      url: '/index.php?r=AppShop/deleteCart',
      method: 'post',
      data: data,
      chain: true,
      subshop: pageInstance.franchiseeId || '',
      hideLoading: true,
      success: function (res) {
        callback && callback()
      },
      fail: function (res) {
        app.showModal({
          content: '清空购物车失败'
        })
      },
      complete: function () {
        compData.loopRequest = true;
        if (compData.customFeature.is_together && compData['location_id']) {
          that.getDiningCart(pageInstance, compindex);
        }
      }
    });
  }

  //获取商品
  _getTakeoutStyleGoodsList = (param, pageInstance, compindex, isOnShow) => {
    if (!param.is_integral) {
      param.is_integral = 5
    }
    let _this = this;
    let categoryId = param.idx_arr.idx_value == '' ? 'all' : param.idx_arr.idx_value;
    param.form = 'goods';
    param.only_display_common = 0;
    app.sendRequest({
      hideLoading: true,
      url: '/index.php?r=AppShop/GetGoodsList',
      data: param,
      method: 'post',
      chain: true,
      subshop: pageInstance.franchiseeId || '',
      success: function (res) {
        if (res.status == 0) {
          pageInstance.requesting = false;
          let compData = pageInstance.data.eles[compindex],
            newdata = {},
            isRequireing = {},
            categoryList = {};
          isRequireing['eles[' + compindex + '].pagination.category' + categoryId] = compData.pagination['category' + categoryId];
          isRequireing['eles[' + compindex + '].pagination.category' + categoryId].requesting = false;
          pageInstance.setData(isRequireing);
          if (compData.customFeature.loadAllData == '1') {
            let pxRatio;
            if (app.isWeixin()) {
              pxRatio = app.globalData.systemInfo.windowWidth ? 750 / app.globalData.systemInfo.windowWidth : 2;
            } else {
              pxRatio = window.innerWidth ? 750 / window.innerWidth : 2;
            }
            compData.requestNum++;
            compData.goodsCateHeight[categoryId] = {};
            if (compData.customFeature.listArrange == 1) {
              compData.goodsCateHeight[categoryId] = (Math.ceil(res.data.length / 2) * 474 + 38) / pxRatio;
            } else {
              compData.goodsCateHeight[categoryId] = (res.data.length * 226 + 38) / pxRatio;
            }
          }
          if (!compData.show_goods_data || (compData.show_goods_data && !compData.show_goods_data['category' + categoryId]) || isOnShow == 1) {
            categoryList['category' + categoryId] = []
          } else {
            categoryList['category' + categoryId] = compData.show_goods_data['category' + categoryId]
          }
          if (compData.goods_data_list) {
            newdata['eles[' + compindex + '].goods_data_list'] = compData.goods_data_list
          } else {
            newdata['eles[' + compindex + '].goods_data_list'] = {}
          }
          if (!pageInstance['verticalList'+compindex]['goods_model_list']) {
            pageInstance['verticalList'+compindex]['goods_model_list'] = {};
          }
          for (let i in res.data) {
            let form_data = res.data[i].form_data
            categoryList['category' + categoryId].push({
              app_id: form_data.app_id,
              cover: form_data.cover,
              description: form_data.description,
              goods_model: form_data.goods_model ? form_data.goods_model.length : 0,
              id: form_data.id,
              price: form_data.price,
              sales: form_data.sales,
              title: form_data.title,
              business_time: form_data.business_time,
              is_in_business_time: form_data.goods_in_business_time,
              stock: form_data.stock,
              virtual_price: form_data.virtual_price,
              corner_mark: form_data.corner_mark,
              corner_url: form_data.corner_url,
              vipGoods: (form_data.paid_vip_card_condition || form_data.paid_vip_level_condition || form_data.vip_card_condition || form_data.vip_level_condition) ? true : false,
              integral: form_data.integral,
              img_urls: form_data.img_urls || [],
              max_can_use_integral: Number(form_data.max_can_use_integral),
              vip_price: form_data.vip_min_price == form_data.vip_max_price ? form_data.vip_min_price : form_data.vip_min_price + '~' + form_data.vip_max_price,
              vip_goods_price: form_data.vip_goods_price && form_data.vip_goods_price !== 0 && !compData.customFeature.is_together ? Number(form_data.vip_goods_price).toFixed(2) : null,
              calculationPrice: form_data.vip_goods_price && form_data.vip_goods_price !== 0 && !compData.customFeature.is_together ? Number(form_data.vip_goods_price).toFixed(2) : form_data.price,
              is_vip_goods: form_data.is_vip_goods || 0
            });
            newdata['eles[' + compindex + '].goods_data_list']['' + form_data.id + ''] = {
              totalNum: 0,
              stock: form_data.stock,
              goods_model: form_data.goods_model ? form_data.goods_model.length : 0,
              name: form_data.title,
              price: form_data.price,
              in_business_time: form_data.goods_in_business_time,
              model: {},
              goods_model: {},
              pick_up_type: form_data.pick_up_type,
              paid_vip_card_condition: form_data.paid_vip_card_condition,
              paid_vip_level_condition: form_data.paid_vip_level_condition,
              vip_card_condition: form_data.vip_card_condition,
              vip_level_condition: form_data.vip_level_condition,
              vip_price: form_data.vip_min_price == form_data.vip_max_price ? form_data.vip_min_price : form_data.vip_min_price + '~' + form_data.vip_max_price,
              vip_goods_price: form_data.vip_goods_price && form_data.vip_goods_price !== 0 && !compData.customFeature.is_together ? Number(form_data.vip_goods_price).toFixed(2) : null,
              calculationPrice: form_data.vip_goods_price && form_data.vip_goods_price !== 0 && !compData.customFeature.is_together ? Number(form_data.vip_goods_price).toFixed(2) : form_data.price,
              is_vip_goods: form_data.is_vip_goods || 0
            }
            if (form_data.goods_model) {
              let new_goods_model = {}
              for (let i in form_data.goods_model) {
                new_goods_model[form_data.goods_model[i].id] = {
                  model: form_data.goods_model[i].model,
                  stock: form_data.goods_model[i].stock,
                  price: form_data.goods_model[i].price,
                  goods_id: form_data.goods_model[i].goods_id,
                  totalNum: 0,
                  vip_price: form_data.goods_model[i].vip_price && form_data.goods_model[i].vip_price !== 0 ? Number(form_data.goods_model[i].vip_price).toFixed(2) : null,
                  is_vip_goods: form_data.is_vip_goods || 0
                }
              }
              newdata['eles[' + compindex + '].goods_data_list']['' + form_data.id + '']['model'] = {
                modelData: [],
                name: form_data.title
              }
              pageInstance['verticalList'+compindex]['goods_model_list'][form_data.id] = {
                goods_model: new_goods_model
              }
              for (let k in form_data.model) {
                newdata['eles[' + compindex + '].goods_data_list']['' + form_data.id + '']['model']['modelData'].push({
                  name: form_data.model[k].name,
                  subModelName: form_data.model[k].subModelName,
                  subModelId: form_data.model[k].subModelId
                })
              }
            } else {
              newdata['eles[' + compindex + '].goods_data_list']['' + form_data.id + '']['model'] = {};
              newdata['eles[' + compindex + '].goods_data_list']['' + form_data.id + '']['model'][0] = {
                price: form_data.price,
                num: 0,
                stock: form_data.stock,
                vip_price: form_data.vip_price && form_data.vip_price !== 0 ? Number(form_data.vip_price).toFixed(2) : null,
                is_vip_goods: (form_data.is_vip_goods && form_data.vip_goods_price != form_data.price) || 0
              }
            }
          }
          newdata['eles[' + compindex + '].show_goods_data.category' + categoryId] = categoryList['category' + categoryId];
          newdata['eles[' + compindex + '].in_business_time'] = res.in_business_time;
          newdata['eles[' + compindex + '].pagination.category' + categoryId] = compData.pagination['category' + categoryId];
          param.page = res.current_page + 1;
          newdata['eles[' + compindex + '].pagination.category' + categoryId].param = param;
          newdata['eles[' + compindex + '].pagination.category' + categoryId].is_more = res.is_more;
          newdata['eles[' + compindex + '].pagination.category' + categoryId].current_page = res.current_page;
          newdata['eles[' + compindex + '].modelChoose'] = [];
          newdata['eles[' + compindex + '].modelIdArr'] = [];
          newdata['eles[' + compindex + '].loading'] = false;
          newdata['eles[' + compindex + '].loadingFail'] = false;
          newdata['eles[' + compindex + '].loadFirstCate'] = false;
          pageInstance.setData(newdata);
          if (compData.customFeature.loadAllData == '1') {
            if (compData.requestNum == compData.content.length) {
              if (compData.customFeature.is_together) {
                compData.loopRequest = true;
                _this.getMultiOrderingVerticalCart(compindex, pageInstance, false);
                if (compData.location_id) {
                  _this.getDiningCart(pageInstance, compindex);
                }
              } else {
                _this._getTakeoutStyleCartList(pageInstance, compindex);
              };
            }
          } else {
            if (compData.customFeature.is_together) {
              compData.loopRequest = true;
              _this.getMultiOrderingVerticalCart(compindex, pageInstance, false);
              if (compData.location_id) {
                _this.getDiningCart(pageInstance, compindex);
              }
            } else {
              if(app.globalData.isLogin){
                _this._getTakeoutStyleCartList(pageInstance, compindex);
              }else{
                _this._parseTakeoutCartListData({data: []}, pageInstance, compindex);
              }
            }
          }
        }
      },
      fail: function () {
        let newdata = {};
        newdata['eles[' + compindex + '].loadingFail'] = true;
        newdata['eles[' + compindex + '].loading'] = false;
        pageInstance.setData(newdata);
      },
      complete: function () {
        setTimeout(function () {
          pageInstance.requesting = false;
        }, 300);
      }
    });
  }

  //获取购物车
  _getTakeoutStyleCartList = (pageInstance, compindex) => {
    let _this = this;
    let franchiseeId = app.getPageFranchiseeId();
    app.sendRequest({
      hideLoading: true,
      url: '/index.php?r=AppShop/cartList',
      data: {
        page: -1,
        page_size: 1000,
        sub_shop_app_id: franchiseeId || '',
        parent_shop_app_id: franchiseeId ? app.getAppId() : '',
        not_get_takeout: 1
      },
      success: function (cartlist) {
        _this._parseTakeoutCartListData(cartlist, pageInstance, compindex);
      },
      fail: function (res) {
        app.showModal({
          content: '购物车数据请求失败，点击确定重新加载',
          confirm: function () {
            _this._getTakeoutStyleCartList(pageInstance, compindex);
          }
        })
      }
    })
  }

  _parseTakeoutCartListData = (cartlist, pageInstance, compindex) => {
    let newdata = {},
      stockEmpty = false,
      compData = pageInstance.data.eles[compindex],
      totalNum = 0,
      totalPrice = 0.00;
    newdata['eles[' + compindex + '].cart_data'] = {};
    let goodsList = compData.goods_data_list || {};
    newdata['eles[' + compindex + '].goods_data_list'] = goodsList;
    newdata['eles[' + compindex + '].cartGoodsIdList'] = [];
    compData.flag = false;
    if (cartlist.data.length) {
      for (let i in cartlist.data) {
        let item = cartlist.data[i];
        if (goodsList[item.goods_id]) {
          goodsList[item.goods_id].totalNum = 0;
        }
      }
      newdata['eles[' + compindex + '].cartlistData'] = [];
      for (let i in cartlist.data) {
        let item = cartlist.data[i];
        newdata['eles[' + compindex + '].cartlistData'].push(item);
        if (item.goods_type == 0) {
          if (+item.num > +item.stock) {
            item.num = item.stock;
            stockEmpty = true;
          }
          newdata['eles[' + compindex + '].cart_data'][item.goods_id] ? null : newdata['eles[' + compindex + '].cart_data'][item.goods_id] = {};
          newdata['eles[' + compindex + '].cart_data'][item.goods_id][item.model_id] = {
            cart_id: item.id
          };
          if (compData.goods_data_list[item.goods_id]) {
            newdata['eles[' + compindex + '].goods_data_list']['' + item.goods_id].totalNum += +item.num;
            if (pageInstance['verticalList'+compindex]['goods_model_list'][item.goods_id + '']) {
              if (pageInstance['verticalList'+compindex]['goods_model_list'][item.goods_id + ''].goods_model) {
                pageInstance['verticalList'+compindex]['goods_model_list'][item.goods_id + ''].goods_model[item.model_id].totalNum += +item.num
              } else {
                pageInstance['verticalList'+compindex]['goods_model_list'][item.goods_id + ''][0].num += +item.num
              }
            }
          }
          if (!newdata['eles[' + compindex + '].cartList[0].' + item.goods_id]) {
            newdata['eles[' + compindex + '].cartList[0].' + item.goods_id] = {};
          }
          if (newdata['eles[' + compindex + '].cartGoodsIdList'].indexOf(+item.goods_id) == -1) {
            newdata['eles[' + compindex + '].cartGoodsIdList'].push(+item.goods_id);
          }
          newdata['eles[' + compindex + '].cartList[0].' + item.goods_id][item.model_id] = {
            list: 'list',
            id: item.goods_id,
            modelName: item.model_value ? item.model_value.join(' | ') : '',
            modelId: item.model_id,
            num: +item.num,
            price: +item.price,
            gooodsName: item.title,
            totalPrice: Number(item.num * item.price).toFixed(2),
            stock: item.stock,
            cart_id: item.id,
            in_business_time: compData.goods_data_list[item.goods_id] && compData.goods_data_list[item.goods_id].in_business_time,
            pick_up_type: item.pick_up_type,
            is_vip_goods: (item.cart_vip_goods && item.original_price != item.price) || 0
          }
          totalNum += Number(item.num);
          totalPrice += Number(item.price) * item.num;
        }
      }
      newdata['eles[' + compindex + '].TotalNum'] = totalNum;
      newdata['eles[' + compindex + '].TotalPrice'] = Number(+totalPrice).toFixed(2);
      newdata['eles[' + compindex + '].loadFirstCate'] = false;
      pageInstance.setData(newdata);
      if (stockEmpty) {
        app.showModal({
          content: '部分商品库存不足，购物车总数量已修改为最大库存'
        })
        let options = {
          goods_type: 0,
          cartListData: compData.cartList,
          thisPage: pageInstance,
          compindex: compindex
        }
        this._addTakeoutCart(options, this.eachCartList(options))
      }
    } else {
      newdata['eles[' + compindex + '].TotalNum'] = 0;
      newdata['eles[' + compindex + '].TotalPrice'] = 0.00;
      newdata['eles[' + compindex + '].loadFirstCate'] = false;
      pageInstance.setData(newdata);
    }
  }

  //加入购物车
  _addTakeoutCart = (options, cart_info, callback, goodsid) => {
    let that = this;
    let compindex = options.compindex;
    let compData = options.thisPage.data.eles[compindex];
    let franchiseeId = app.getPageFranchiseeId();
    let pageInstance = app.getAppCurrentPage();
    cart_info.map((item) => {
      if (item.pick_up_type) {
        delete item.pick_up_type;
      }
    })
    let cartInfo = [];
    for (let i = 0; i < cart_info.length; i++) {
      if (goodsid == cart_info[i].goods_id) {
        cartInfo.push(cart_info[i]);
      }
    }
    let data = {
      cart_info: cartInfo,
      goods_type: options.goods_type,
      sub_app_id: franchiseeId || ''
    }
    if (compData['location_id'] && compData.customFeature.is_together) {
      data.location_id = compData['location_id'];
    }
    compData.loopRequest = false;
    compData.addCartComplete = false;
    app.sendRequest({
      url: '/index.php?r=AppShop/addVerticalCart',
      method: 'post',
      hideLoading: false,
      data: data,
      success: function (res) {
        if (res.status === 0) {
          let data = {}
          data['eles[' + compindex + '].cart_data.' + goodsid] = res.data[goodsid] || {};
          let cartIdArr = [];
          let isNotEnouth = true;
          for (let k in cart_info) {
            let item = cart_info[k];
            let goods = res.data[item.goods_id];
            if (goods && goods[item.model_id] && goods[item.model_id].stock < item.num) {
              isNotEnouth = false;
              data['eles[' + compindex + '].cartList[0].' + item.goods_id + '.' + item.model_id + '.num'] = goods[item.model_id].stock;
              data['eles[' + compindex + '].cartList[0].' + item.goods_id + '.' + item.model_id + '.totalPrice'] = (goods[item.model_id].stock * compData.cartList[0][item.goods_id][item.model_id].price).toFixed(2);
              data['eles[' + compindex + '].cartList[0].' + item.goods_id + '.' + item.model_id + '.cart_id'] = goods[item.model_id].cart_id;
            }
            if (item.num > 0 && goods && goods[item.model_id]) {
              cartIdArr.push(goods[item.model_id].cart_id);
            }
          }
          that.changeStock(res.data, options);
          callback && callback(cartIdArr);
          options.thisPage.setData(data, function () {
            compData.addCartComplete = true;
          });
          if (!isNotEnouth) {
            app.showModal({
              content: '商品库存不足'
            })
            that.updateGoodsListNum(compindex, goodsid)
          }
        }
      },
      successStatusAbnormal: function (res) {
        if (res.status === 1 && res.is_vip_limit === 1) {
          if (compData.customFeature.is_together) {
            compData.loopRequest = true;
            that.getMultiOrderingVerticalCart(compindex, pageInstance, true, 1);
          } else {
            that._getTakeoutStyleCartList(pageInstance, compindex);
          }

          //会员购权益不足，不加入cartList
          if (goodsid) {
            let newdata = {};
            let goodsInfo = compData.goods_data_list[goodsid];
            newdata['eles[' + compindex + '].goods_data_list.' + goodsid] = goodsInfo;
            newdata['eles[' + compindex + '].cartList[0]'] = compData.cartList[0];
            newdata['eles[' + compindex + '].goods_data_list.' + goodsid].totalNum = 0;
            for (let i in compData.cartList[0]) {
              for (let j in compData.cartList[0][i]) {
                if (compData.cartList[0][i] && compData.cartList[0][i][j].id == goodsid) {
                  newdata['eles[' + compindex + '].modelPrice'] = 0;
                  newdata['eles[' + compindex + '].modelNum'] = 0;
                  newdata['eles[' + compindex + '].goodsModelShow'] = false;
                  delete newdata['eles[' + compindex + '].cartList[0]'][goodsid]
                }
              }
            }
            that.getGoodsVipCondtionInfo(compindex, goodsid);
            newdata['eles[' + compindex + '].showVipDialog'] = true;
            pageInstance.setData(newdata);
            return false;
          }
        }
      },
      complete: function () {
        compData.loopRequest = true;
        compData.addCartComplete = true;
        if (compData.customFeature.is_together && compData['location_id']) {
          that.getDiningCart(pageInstance, compindex);
        }
      }
    })
  }

  changeStock = (data, options) => {
    let newdata = {};
    for (let i in data) {
      for (let j in data[i]) {
        newdata['eles[' + options.compindex + '].cartList[0].' + i + '.' + j + '.stock'] = data[i][j].stock;
        newdata['eles[' + options.compindex + '].goods_data_list.' + i + '.stock'] = data[i][j].stock;
        newdata['eles[' + options.compindex + '].cartList[0].' + i + '.' + j + '.cart_id'] = data[i][j].cart_id;
      }
    }
    options.thisPage.setData(newdata);
  }

  updateGoodsListNum = (compindex, goodsid) => {
    let pageInstance = app.getAppCurrentPage();
    let compData = pageInstance.data.eles[compindex];
    let newdata = {};
    let totalprice = 0;
    newdata['eles[' + compindex + '].TotalNum'] = 0;
    newdata['eles[' + compindex + '].TotalPrice'] = 0;
    for (let i in compData.cartList[0]) {
      let num = 0;
      let price = 0;
      for (let j in compData.cartList[0][i]) {
        num += +compData.cartList[0][i][j].num
        price = +(price + +compData.cartList[0][i][j].num * compData.cartList[0][i][j].price).toFixed(2)
      }
      newdata['eles[' + compindex + '].goods_data_list.' + i + '.totalNum'] = num;
      newdata['eles[' + compindex + '].TotalNum'] += num;
      totalprice = (+totalprice + +price).toFixed(2)
      newdata['eles[' + compindex + '].TotalPrice'] = totalprice
    }
    pageInstance.setData(newdata)
    this.takeoutTimeout = setTimeout(() => {
      let options = {
        goods_type: 0,
        cartListData: compData.cartList,
        thisPage: pageInstance,
        compindex: compindex
      }
      this._addTakeoutCart(options, this.eachCartList(options), null, goodsid)
    }, 300);
  }

  //返回购物车数组
  eachCartList = (options, callback) => {
    let cart_info = [];
    let cart_index = options.index || 0;
    for (let index in options.cartListData[cart_index]) {
      if (index != undefined) {
        for (let j in options.cartListData[cart_index][index]) {
          let obj = {
            goods_id: index.replace('goods', ''),
            model_id: options.cartListData[cart_index][index][j].modelId,
            num: options.cartListData[cart_index][index][j].num,
            pick_up_type: options.cartListData[cart_index][index][j].pick_up_type
          }
          options.cartListData[cart_index][index][j].cart_id ? obj['id'] = options.cartListData[cart_index][index][j].cart_id : '';
          cart_info.push(obj);
        }
      }
    }
    return cart_info;
  }

  //获取评论
  _getAssessList = (pageInstance, compindex) => {
    let idx_value = 0;
    app.sendRequest({
      hideLoading: true, // 页面第一个请求才展示loading
      url: '/index.php?r=AppShop/getAssessList&idx_arr[0][idx]=goods_type&idx_arr[0][idx_value]=' + idx_value,
      data: {
        page: 1,
        page_size: 20,
        obj_name: 'app_id'
      },
      chain: true,
      subshop: pageInstance.franchiseeId || '',
      success: function (res) {
        let newdata = {},
          showAssess = [],
          hasImgAssessList = 0,
          goodAssess = 0,
          normalAssess = 0,
          badAssess = 0;
        for (let i = 0; i < res.data.length; i++) {
          res.data[i].assess_info.has_img == 1 ? (hasImgAssessList++ , showAssess.push(res.data[i])) : null;
          res.data[i].assess_info.level == 3 ? goodAssess++ : (res.data[i].assess_info.level == 1 ? badAssess++ : normalAssess++)
        }
        for (let j = 0; j < res.num.length; j++) {
          res.num[j] = parseInt(res.num[j])
        }
        newdata['eles[' + compindex + '].assessActive'] = 0;
        newdata['eles[' + compindex + '].assessList'] = res.data;
        newdata['eles[' + compindex + '].showAssess'] = showAssess;
        newdata['eles[' + compindex + '].assessNum'] = res.num;
        newdata['eles[' + compindex + '].moreAssess'] = res.is_more;
        newdata['eles[' + compindex + '].assessCurrentPage'] = res.current_page;
        pageInstance.setData(newdata);
      }
    })
  }

  //加载全部数据，列表滚动事件
  verticalListGoodsListScroll = (e) => {
    let pageInstance = app.getAppCurrentPage();
    let dataset = e.currentTarget.dataset;
    let compindex = dataset.compindex;
    let compData = pageInstance.data.eles[compindex];
    let newdata = {};
    let that = this;
    let scrollTop = e.target.scrollTop;
    let cate = compData.content;
    let totalHeight = -40;
    let cateHeight = compData.goodsCateHeight;
    let id = 0;
    let index = 0;
    if (compData['isChangeTab']) {
      compData['isChangeTab'] = false;
      return;
    }
    for (let i = 0; i < cate.length; i++) {
      totalHeight += (cateHeight[cate[i].source]);
      if (scrollTop < totalHeight) {
        id = cate[i].source;
        index = i;
        break;
      }
    }
    if (compData.customFeature.selected !== index) {
      let data = {};
      data['eles[' + compindex + '].customFeature.selected'] = index;
      pageInstance.setData(data);
    }
    if (scrollTop > 100 && compData.heightFlag && compData['infoHeight'] === 0) {
      compData.heightFlag = false;
      app.getBoundingClientRect('.shopInfoHeight', function (rects) {
        compData.heightFlag = false;
        pageInstance['verticalList'+compindex]['shopInfoHeight'] = rects[0] != undefined ? rects[0].height : 0;
        // let animation = app.createAnimation({
        //   duration: 400,
        //   timingFunction: 'linear'
        // })
        // animation.translateY(-pageInstance['verticalList'+compindex]['shopInfoHeight']).height(0).step();
        // newdata['eles[' + compindex + '].shopInfoHeight'] = animation.export();
        newdata['eles[' + compindex + '].infoHeight'] = pageInstance['verticalList'+compindex]['shopInfoHeight'];
        pageInstance.setData(newdata);
      })
    } else if (scrollTop < 20 && compData.heightFlag && compData['infoHeight'] !== 0) {
      compData.heightFlag = false;
      // let animation = app.createAnimation({
      //   duration: 200,
      //   timingFunction: 'linear'
      // })
      // animation.height(pageInstance['verticalList'+compindex]['shopInfoHeight']).step();
      // newdata['eles[' + compindex + '].shopInfoHeight'] = animation.export();
      newdata['eles[' + compindex + '].infoHeight'] = 0;
      pageInstance.setData(newdata);
    }
  }

  //跳转到手动选择地址
  vlSelectGoodsSameJourney = (e, compIndex) => {
    let pageInstance = app.getAppCurrentPage();
    let compindex = e ? e.currentTarget.dataset.compindex : compIndex;
    let compData = pageInstance.data.eles[compindex];
    let newdata = {};
    let selectSameJourney = pageInstance.data.selectSameJourney;
    let franchiseeId = app.getPageFranchiseeId();
    pageInstance.returnToVerticalFlag = 1;
    app.turnToPage('/eCommerce/pages/goodsSameJourney/goodsSameJourney?sameJourneyId=' + (selectSameJourney ? selectSameJourney.id : '') + '&franchiseeId=' + franchiseeId + '&compindex=' + compindex + '&from=' + 'preview');
  }

  //获取当前定位
  getCurrentLocation = (compindex, pageInstance) => {
    let _this = this;
    let newdata = {};
    let compData = pageInstance.data.eles[compindex];
    app.getLocation({
      success(res) {
        const latitude = res.latitude;
        const longitude = res.longitude;
        app.sendRequest({
          url: '/index.php?r=Map/getAreaInfoByLatAndLng',
          method: 'post',
          data: {
            latitude: latitude,
            longitude: longitude
          },
          success: function (res) {
            newdata['eles[' + compindex + '].currentLocationData'] = res.data;
            pageInstance.setData(newdata);
          }
        });
      }
    })
  }

  //cartIdArray
  getCartIdArray = (compindex, pageInstance) => {
    let compData = pageInstance.data.eles[compindex];
    let cartIds = [];
    for (let i = 0; i < compData.cartList.length; i++) {
      let userCart = compData.cartList[i];
      for (let k in userCart) {
        for (let j in userCart[k]) {
          if (userCart[k][j].num > 0) {
            cartIds.push(userCart[k][j].cart_id);
          }
        }
      }
    }
    return cartIds;
  }

  //获取自己的cartIds
  getMyCartIdArray = (compindex, pageInstance) => {
    let compData = pageInstance.data.eles[compindex];
    let cartIds = [];
    let userCart = compData.cartList[0];
    for (let k in userCart) {
      for (let j in userCart[k]) {
        if (userCart[k][j].num > 0) {
          cartIds.push(userCart[k][j].cart_id);
        }
      }
    }
    return cartIds;
  }

  //结算（新版）
  verticalListSettlement = (event) => {
    let pageInstance = app.getAppCurrentPage();
    let compindex = event.currentTarget.dataset.compindex;
    let compData = pageInstance.data.eles[compindex];
    let payIdArr = [];
    let franchiseeId = app.getPageFranchiseeId() || '';
    let cartIdArray = [];
    let that = this;
    this.saveFormId(event.target.formId);
    if (!compData.addCartComplete) {
      return;
    }
    cartIdArray = this.getCartIdArray(compindex, pageInstance);
    if (!cartIdArray.length) {
      app.showModal({
        content: '请选择结算的商品'
      });
      return;
    }
    // 只选择一件商品和商家后台只有一种取货方式时不弹窗 (多人点餐只有堂食)
    if (compData.pick_up_type.length === 1 && cartIdArray.length == 1 || compData.customFeature.is_together) {
      let currentLocationData = compData.currentLocationData;
      let selectSameJourney = compData.selectSameJourney;
      let data = {
        cart_id_arr: cartIdArray,
        filter_pick_up_type: compData.pick_up_type
      }
      if (!(compData.pick_up_type.length == 1 && compData.pick_up_type[0] == 4)) {
        if (!selectSameJourney && !currentLocationData){
          app.turnToPage('/eCommerce/pages/goodsSameJourney/goodsSameJourney?sameJourneyId=' + (selectSameJourney ? selectSameJourney.id : '') + '&franchiseeId=' + franchiseeId + '&compindex=' + compindex + '&from=' + 'preview');
          return;
        }
        let lat = selectSameJourney ? selectSameJourney.latitude : currentLocationData.location.lat;
        let lng = selectSameJourney ? selectSameJourney.longitude : currentLocationData.location.lng;
        let regionId = selectSameJourney ? selectSameJourney.address_info.district.id : currentLocationData.region_id;
        data['latitude'] = lat;
        data['longitude'] = lng;
        data['region_id'] = regionId;
      }
      app.sendRequest({
        url: '/index.php?r=AppEcommerce/getCanUsePickUpTypeAtCart',
        method: 'post',
        data: data,
        success: function (res) {
          if (res.is_modify) {
            if (compData.customFeature.is_together) {
              that.getMultiOrderingVerticalCart(compindex, pageInstance);
            } else {
              that._getTakeoutStyleCartList(pageInstance, compindex);
            }
          }
          //同城和堂食需要判断是否在营业时间
          if (compData.customFeature.is_together) {
            if (!res.data || !res.data[4]) {
              app.showModal({
                content: '下单方式已关闭，无法下单，请联系管理员'
              })
              return;
            }
            if (res.data[4].dining_data.in_business_time === 0) {
              app.showModal({
                content: '不在营业时间'
              })
              return;
            }
          }
          if (compData.pick_up_type[0] == 2) {
            if (res.data[2].intra_city_data.in_business_time === 0) {
              app.showModal({
                content: '不在营业时间'
              })
              return;
            }
          }
          let addressId = compData.selectSameJourneyId;
          let pagePath = '/eCommerce/pages/previewGoodsOrder/previewGoodsOrder?cart_arr=' + encodeURIComponent(cartIdArray);
          franchiseeId && (pagePath += '&franchisee=' + franchiseeId);
          addressId && (pagePath += '&addressId=' + addressId);
          compData.location_id && (pagePath += '&ec_location_id=' + compData.location_id);
          compData.customFeature.is_together ? (pagePath += '&is_together=true') : (pagePath += '&is_together=false');
          pagePath += '&type=' + compData.pick_up_type[0];
          pageInstance.returnToVerticalFlag = 1;
          app.turnToPage(pagePath);
          return;
        }
      })
    } else {
      that.showSettlement(compindex);
      return;
    }
  }

  //打开分开结算弹窗
  showSettlement = (compindex) => {
    let _this = this;
    let pageInstance = app.getAppCurrentPage();
    let compData = pageInstance.data.eles[compindex];
    let sub_shop_app_id = app.getPageFranchiseeId();
    let cartIds = [];
    cartIds = this.getCartIdArray(compindex, pageInstance);
    let currentLocationData = compData.currentLocationData;
    let selectSameJourney = compData.selectSameJourney;
    if (!currentLocationData && !selectSameJourney) {
      app.turnToPage('/eCommerce/pages/goodsSameJourney/goodsSameJourney?sameJourneyId=' + (selectSameJourney ? selectSameJourney.id : '') + '&franchiseeId=' + sub_shop_app_id + '&compindex=' + compindex + '&from=' + 'preview');
      return;
    }
    let lat = selectSameJourney ? selectSameJourney.latitude : currentLocationData.location.lat;
    let lng = selectSameJourney ? selectSameJourney.longitude : currentLocationData.location.lng;
    let regionId = selectSameJourney ? selectSameJourney.address_info.district.id : currentLocationData.region_id;
    if (!cartIds.length) {
      app.showModal({
        content: '请选择商品'
      })
      return;
    }
    app.sendRequest({
      url: '/index.php?r=AppEcommerce/getCanUsePickUpTypeAtCart',
      method: 'post',
      data: {
        latitude: lat,
        longitude: lng,
        region_id: regionId,
        cart_id_arr: cartIds,
        sub_shop_app_id: sub_shop_app_id || '',
        filter_pick_up_type: compData.pick_up_type
      },
      success: function (res) {
        if (res.is_modify) {
          if (compData.customFeature.is_together) {
            _this.getMultiOrderingVerticalCart(compindex, pageInstance);
          } else {
            _this._getTakeoutStyleCartList(pageInstance, compindex);
          }
        }
        let data = res.data;
        let cartIdArray;
        let type = 0;
        // 多件商品同时只支持一种取货方式时不弹窗
        if (data.hasOwnProperty(1) && !data.hasOwnProperty(2) && !data.hasOwnProperty(3) && !data.hasOwnProperty(4)) {
          cartIdArray = data[1].cart_list;
          type = 1;
        }
        if (!data.hasOwnProperty(1) && data.hasOwnProperty(2) && !data.hasOwnProperty(3) && !data.hasOwnProperty(4)) {
          cartIdArray = data[2].cart_list;
          type = 2;
        }
        if (!data.hasOwnProperty(1) && !data.hasOwnProperty(2) && data.hasOwnProperty(3) && !data.hasOwnProperty(4)) {
          cartIdArray = data[3].cart_list;
          type = 3;
        }
        if (!data.hasOwnProperty(1) && !data.hasOwnProperty(2) && !data.hasOwnProperty(3) && data.hasOwnProperty(4)) {
          cartIdArray = data[4].cart_list;
          type = 4;
        }
        if (cartIdArray) {
          let franchiseeId = app.getPageFranchiseeId();
          let addressId = compData.selectSameJourneyId ? compData.selectSameJourneyId.id : undefined;
          let pagePath = '/eCommerce/pages/previewGoodsOrder/previewGoodsOrder?cart_arr=' + encodeURIComponent(cartIdArray);
          franchiseeId && (pagePath += '&franchisee=' + franchiseeId);
          addressId && (pagePath += '&addressId=' + addressId);
          compData.location_id && (pagePath += '&ec_location_id=' + compData.location_id);
          compData.customFeature.is_together ? (pagePath += '&is_together=true') : (pagePath += '&is_together=false');
          pagePath += '&type=' + type;
          pageInstance.returnToVerticalFlag = 1;
          app.turnToPage(pagePath);
          return;
        }
        let newdata = {};
        newdata['eles[' + compindex + '].canUsePickUpType'] = data;
        newdata['eles[' + compindex + '].intraCityData'] = data[2] && data[2].intra_city_data || '';
        newdata['eles[' + compindex + '].dining_data'] = data[4] && data[4].dining_data || '';
        newdata['eles[' + compindex + '].showSettlementMask'] = true;
        pageInstance.setData(newdata);
      }
    });
  }

  //隐藏分开结算弹窗
  verticalListCloseSettlement = (event) => {
    let pageInstance = app.getAppCurrentPage();
    let newdata = {};
    let compindex = event.currentTarget.dataset.compindex;
    let compData = pageInstance.data.eles[compindex];
    newdata['eles[' + compindex + '].showSettlementMask'] = false;
    pageInstance.setData(newdata);
  }

  //结算
  goodsPay = (e) => {
    let pageInstance = app.getAppCurrentPage();
    let dataset = e.currentTarget.dataset;
    let compindex = dataset.compindex;
    let compData = pageInstance.data.eles[compindex];
    let newdata = {};
    let franchiseeId = app.getPageFranchiseeId(),
      cartIdArray = [],
      type = e.currentTarget.dataset.type,
      cartId = e.currentTarget.dataset.cartId,
      addressId = compData.selectSameJourneyId ? compData.selectSameJourneyId.id : undefined;
    cartIdArray = cartId;
    let pagePath = '/eCommerce/pages/previewGoodsOrder/previewGoodsOrder?type=' + type + '&cart_arr=' + encodeURIComponent(cartIdArray);
    franchiseeId && (pagePath += '&franchisee=' + franchiseeId);
    addressId && (pagePath += '&addressId=' + addressId);
    compData.location_id && (pagePath += '&ec_location_id=' + compData.location_id);
    compData.customFeature.is_together ? (pagePath += '&is_together=true') : (pagePath += '&is_together=false');
    pagePath += '&type=' + type;
    pageInstance.returnToVerticalFlag = 1;
    app.turnToPage(pagePath);
  }

  //关闭会员权益不足弹窗 
  verticalListCloseVipDialog = (e) => {
    let pageInstance = app.getAppCurrentPage();
    let dataset = e.currentTarget.dataset;
    let compindex = dataset.compindex;
    let newdata = {};
    newdata['eles[' + compindex + '].showVipDialog'] = false;
    pageInstance.setData(newdata);
  }

  //获取会员卡信息
  getGoodsVipCondtionInfo = (compindex, goodsId) => {
    let pageInstance = app.getAppCurrentPage();
    let compData = pageInstance.data.eles[compindex];
    let that = this;
    let newdata = {};
    app.sendRequest({
      url: '/index.php?r=AppShop/getGoodsVipCondtionInfo',
      method: 'post',
      hideLoading: false,
      data: {
        goods_id: goodsId
      },
      success: function (res) {
        if (res.status == 0) {
          newdata['eles[' + compindex + '].vipCondtionInfo'] = res.data;
          pageInstance.setData(newdata);
        }
      }
    })
  }

  scanMove = (e) => {
    e.stopPropagation;
    let pageInstance = app.getAppCurrentPage();
    let dataset = e.currentTarget.dataset;
    let compindex = dataset.compindex;
    let y = e.changedTouches[0].clientY;
    let width = app.getSystemInfoSync().windowWidth;
    let maxHeight = app.getSystemInfoSync().windowHeight - 208 / 750 * width
    y = y < 120 ? 120 : (y > maxHeight ? maxHeight : y);
    pageInstance.setData({
      ['eles[' + compindex + '].scanCode']: y
    })
  }

  //扫码
  scanShopping = (e) => {
    let pageInstance = app.getAppCurrentPage();
    let dataset = e.currentTarget.dataset;
    let compindex = dataset.compindex;
    let compData = pageInstance.data.eles[compindex];
    let newdata = {};
    let _this = this;
    let pre_location_id = compData.location_id || 0;
    let cartIdArray = [];
    let sub_shop_app_id = app.getPageFranchiseeId() || '';
    cartIdArray = _this.getMyCartIdArray(compindex, pageInstance);
    app.scanCode({
      success: function (res) {
        let path = res.path;
        if (!path) {
          app.showModal({
            content: '位置码错误'
          })
          return;
        }
        let location_id = path.match(/\ec_location_id=(\S*)/) && path.match(/\ec_location_id=(\S*)/)[1];
        if (!location_id) {
          app.showModal({
            content: '位置码错误'
          })
          return;
        }
        app.sendRequest({
          url: "/index.php?r=AppEcommerce/getEcLocationData",
          data: {
            id: location_id,
            sub_shop_app_id: sub_shop_app_id || ''
          },
          hideLoading: true,
          success: function (res) {
            if (res.status === 0) {
              compData['location_id'] = location_id;
              pageInstance.setData({
                ['eles[' + compindex + '].location_id']: location_id
              })
              let franchisee_id = app.getPageFranchiseeId();
              if (franchisee_id) {
                app.globalData[franchisee_id] = {};
                app.globalData[franchisee_id].ec_location_id = location_id;
              } else {
                app.globalData.ec_location_id = location_id;
              }
              setTimeout(() => {
                app.hideToast();
                app.showToast({
                  title: '已获取桌位号，可立即点餐啦',
                  icon: 'none',
                  duration: 2000
                });
              }, 1000)
              if (!compData.customFeature.is_together) {
                return;
              }
              let data = {
                location_id: location_id,
                cart_id_arr: cartIdArray,
                sub_shop_app_id: sub_shop_app_id || ''
              }
              pre_location_id ? data.pre_location_id = pre_location_id : '';
              app.sendRequest({
                url: "/index.php?r=AppEcommerce/scanQrcodeInitCartUserInfo",
                method: 'post',
                data: data,
                hideLoading: true,
                success: function (res) {
                  compData.loopRequest = true;
                  _this.getDiningCart(pageInstance, compindex);
                }
              })
            }
          }
        })
      },
      fail: function (res) {
        console.log(res.errMsg)
      }
    })
  }

  //获取多人点餐购物车
  getMultiOrderingVerticalCart = (compindex, pageInstance, hideLoading, isFirst) => {
    let that = this;
    let compData = pageInstance.data.eles[compindex];
    let data = {
      get_user_list: 1,
      page: -1,
      page_size: 1000,
      sub_shop_app_id: app.getPageFranchiseeId() || ''
    };
    let newdata = {};
    if (compData['location_id']) {
      data.location_id = compData['location_id'];
    }
    app.sendRequest({
      url: "/index.php?r=AppEcommerce/getMultiOrderingVerticalCart",
      method: 'get',
      data: data,
      hideLoading: hideLoading === false ? false : true,
      success: function (res) {
        compData.flag = false;
        if (!compData.loopRequest) {
          return;
        }
        compData.loopRequest = false;
        if (res.status == 0) {
          if (res.is_notice) {
            pageInstance.setData({
              ['eles[' + compindex + '].cartList']: [{}]
            })
            app.showModal({
              content: "您的同桌" + res.buyer_nickname + '已下单'
            })
          }
          if (!compData.user_list || res.user_list.length !== compData.user_list.length) {
            pageInstance.setData({
              ['eles[' + compindex + '].user_list']: res.user_list
            })
          }
          let buyer_info = res.buyer_info;
          let user_list = res.user_list;
          let my_info = {};
          for (let i = 0; i < user_list.length; i++) {
            if (user_list[i].is_myself) {
              my_info = user_list[i];
            }
          }
          let hasMyInfo = false;
          for (let j = 0; j < buyer_info.length; j++) {
            if (my_info.buyer_id === buyer_info[j].buyer_id) {
              hasMyInfo = true;
              buyer_info.unshift(buyer_info.splice(j, 1)[0]);
            }
          }
          if (!hasMyInfo) {
            buyer_info.unshift(my_info);
          }
          pageInstance.setData({
            ['eles[' + compindex + '].buyer_info']: buyer_info
          })
          if (res.is_reload || isFirst || compData.is_init) {
            compData.is_init = false;
            pageInstance.setData({
            }, function () {
              that._parseDinningCartListData(res, pageInstance, compindex);
            })
          }
        }
      },
      complete: function () {
        compData.loopRequest = true;
      },
      fail: function () {
        app.showModal({
          content: '购物车数据请求失败，点击确定重新加载',
          confirm: function () {
            that.getMultiOrderingVerticalCart(compindex, pageInstance, hideLoading, isFirst);
          }
        })
      }
    })
  }
  //多人点餐购物车数据处理
  _parseDinningCartListData = (cartlist, pageInstance, compindex) => {
    let newdata = {},
      stockEmpty = false,
      compData = pageInstance.data.eles[compindex],
      totalNum = 0,
      totalPrice = 0.00;
    newdata['eles[' + compindex + '].cart_data'] = {};
    let goodsList = compData.goods_data_list || {};
    newdata['eles[' + compindex + '].cartGoodsIdList'] = [];
    compData.flag = false;
    for (let k in goodsList) {
      goodsList[k].totalNum = 0;
    }
    newdata['eles[' + compindex + '].goods_data_list'] = goodsList;
    if (cartlist.data.length) {
      newdata['eles[' + compindex + '].cartlistData'] = [];
      let buyer_info = cartlist.buyer_info;
      let data = cartlist.data;
      let cartlistArr = [];
      for (let i = 0; i < buyer_info.length; i++) {
        cartlistArr[i] = {};
        for (let j = 0; j < data.length; j++) {
          let item = data[j];
          newdata['eles[' + compindex + '].cartlistData'].push(item);
          if (item.goods_type == 0) {
            if (+item.num > +item.stock) {
              item.num = item.stock;
              stockEmpty = true;
            }
            newdata['eles[' + compindex + '].cart_data'][item.goods_id] ? null : newdata['eles[' + compindex + '].cart_data'][item.goods_id] = {};
            newdata['eles[' + compindex + '].cart_data'][item.goods_id][item.model_id] = {
              cart_id: item.id
            };
            if (compData.goods_data_list[item.goods_id] && i == 0) {
              newdata['eles[' + compindex + '].goods_data_list']['' + item.goods_id].totalNum += +item.num;
              if (pageInstance['verticalList'+compindex]['goods_model_list'][item.goods_id + '']) {
                if (pageInstance['verticalList'+compindex]['goods_model_list'][item.goods_id + ''].goods_model) {
                  pageInstance['verticalList'+compindex]['goods_model_list'][item.goods_id + ''].goods_model[item.model_id].totalNum = +item.num;
                } else {
                  pageInstance['verticalList'+compindex]['goods_model_list'][item.goods_id + ''][0].num += +item.num
                }
              }
            }
            if (newdata['eles[' + compindex + '].cartGoodsIdList'].indexOf(+item.goods_id) == -1) {
              newdata['eles[' + compindex + '].cartGoodsIdList'].push(+item.goods_id);
            }
            if (item.buyer_id === buyer_info[i].buyer_id) {
              cartlistArr[i][item.goods_id] = cartlistArr[i][item.goods_id] || {};
              cartlistArr[i][item.goods_id][item.model_id] = {
                list: 'list',
                id: item.goods_id,
                modelName: item.model_value ? item.model_value.join(' | ') : '',
                modelId: item.model_id,
                num: +item.num,
                price: +item.price,
                gooodsName: item.title,
                totalPrice: Number(item.num * item.price).toFixed(2),
                stock: item.stock,
                cart_id: item.id,
                in_business_time: compData.goods_data_list[item.goods_id] && compData.goods_data_list[item.goods_id].in_business_time,
                pick_up_type: item.pick_up_type,
                is_vip_goods: (item.cart_vip_goods && item.original_price != item.price) || 0
              }
            }
          }
          if (i == 0) {
            totalNum += Number(item.num);
            totalPrice += Number(item.price) * item.num;
          }
        }
      }
      let userCart = cartlistArr[0];
      let myCartNum = 0;
      for (let k in userCart) {
        for (let j in userCart[k]) {
          myCartNum += userCart[k][j].num;
        }
      }
      newdata['eles[' + compindex + '].myCartNum'] = myCartNum;
      newdata['eles[' + compindex + '].cartList'] = cartlistArr;
      newdata['eles[' + compindex + '].TotalNum'] = totalNum;
      newdata['eles[' + compindex + '].TotalPrice'] = Number(+totalPrice).toFixed(2);
      newdata['eles[' + compindex + '].loadFirstCate'] = false;
      pageInstance.setData(newdata);
      if (stockEmpty) {
        app.showModal({
          content: '部分商品库存不足，购物车总数量已修改为最大库存'
        })
        let options = {
          goods_type: 0,
          cartListData: compData.cartList,
          thisPage: pageInstance,
          compindex: compindex
        }
        this._addTakeoutCart(options, this.eachCartList(options))
      }
    } else {
      newdata['eles[' + compindex + '].TotalNum'] = 0;
      newdata['eles[' + compindex + '].TotalPrice'] = 0.00;
      newdata['eles[' + compindex + '].loadFirstCate'] = false;
      pageInstance.setData(newdata);
    }
    pageInstance.setData(newdata);
  }

  //轮询点餐购物车
  getDiningCart = (pageInstance, compindex) => {
    let compData = pageInstance.data.eles[compindex];
    let that = this;
    clearInterval(compData.timer);
    compData.timer = setInterval(() => {
      that.getMultiOrderingVerticalCart(compindex, pageInstance, true);
    }, 4000)
  }

  //多人点餐清空
  verticalListDeleteBuyerCarts = (e) => {
    let pageInstance = app.getAppCurrentPage();
    let dataset = e.currentTarget.dataset;
    let compindex = dataset.compindex;
    let compData = pageInstance.data.eles[compindex];
    let newdata = {};
    let that = this;
    let index = dataset.index;
    let cartIds = [];
    let buyerCartList = compData.cartList[index];
    for (let i in buyerCartList) {
      for (let j in buyerCartList[i]) {
        if (buyerCartList[i][j].num > 0) {
          cartIds.push(buyerCartList[i][j].cart_id);
        }
      }
    }
    if (cartIds.length == 0) {
      app.showModal({
        content: '请先添加商品'
      });
      return;
    }
    this._removeFromCart(cartIds, () => {
      that._removeByerCartCallback({
        compData: compData,
        compindex: compindex,
        thisPage: pageInstance,
        index: index
      })
    }, compindex)
  }

  _removeByerCartCallback = (options) => {
    let n = {};
    let c = options.compindex;
    let goods_data_list = options.compData.goods_data_list;
    let pageInstance = app.getAppCurrentPage();
    let goods_model_list = pageInstance[c]['goods_model_list'];
    let index = options.index;
    n['eles[' +c + '].cartList' + '[' + index + ']'] = [{}];
    let buyerCartList = options.compData.cartList[index];
    let buyer_totalNum = 0;
    let buyer_totalPrice = 0;
    for (let goodsId in buyerCartList) {
      for (let i in buyerCartList[goodsId]) {
        buyer_totalNum += Number(buyerCartList[goodsId][i].num);
        buyer_totalPrice += Number((buyerCartList[goodsId][i].num * buyerCartList[goodsId][i].price).toFixed(2));
        if (goods_data_list[goodsId]) {
          goods_data_list[goodsId].totalNum -= buyerCartList[goodsId][i].num;
        }
      }
    }
    for (let i in goods_model_list) {
      for (let j in goods_model_list[i].goods_model) {
        goods_model_list[i].goods_model[j].totalNum = 0
      }
    }
    if (index === 0) {
      n['eles[' +c + '].myCartNum'] = 0;
    }
    n['eles[' +c + '].goods_data_list'] = goods_data_list;
    n['eles[' +c + '].TotalNum'] = options.compData.TotalNum - buyer_totalNum;
    n['eles[' +c + '].TotalPrice'] = Number(options.compData.TotalPrice - buyer_totalPrice).toFixed(2);
    options.compData.shopInfo.min_deliver_price ? n['eles[' +c + '].isDeliver'] = options.compData.shopInfo.min_deliver_price : '';
    n['eles[' +c + '].shoppingCartShow'] = true;
    options.thisPage.setData(n);
  }

  //保存formId
  saveFormId = (form_id) => {
    let that = this;
    app.sendRequest({
      hideLoading: true,
      url: '/index.php?r=api/AppMsgTpl/SaveUserFormId',
      data: {
        form_id: form_id
      },
      method: 'post',
      success: function (res) {
        console.log(res)
      }
    })
  }

  scrollStart = (e) => {
    app.scrollStart(e);
  }

  scrollMove = (e) => {
    app.scrollMove(e);
  }

  scrollEnd = (e) => {
    app.scrollEnd(e);
  }

  stopAnimation = (e) => {
    app.stopAnimation(e);
  }

  previewImage = (e) => {
    const { src, imgarr } = e.currentTarget.dataset;
    app.previewImage({
      current: src,
      urls: JSON.parse(imgarr)
    });
  }

  stopPropagation = (e) => {
    e.stopPropagation()
  }

  render() {
    // 组件数据
    const data = this.props.data;
    // 组件配置对象
    const customFeature = data.customFeature;
    // 判断当前页是否有导航
    let isShowBottom = app.isTabBarPage();
    return (
      <div className="custom-component vertical-list">
        <div className="verticalList-wrap" onTouchStart={this.verticalListTouchstart} onTouchMove={this.verticalListTouchmove} data-compindex={ this.props.index }>
          {
            !!(data.customFeature.pickUpArr.sameJourney && !data.customFeature.is_together) && (
              <div className="goods-location-box" onClick={(e)=> {this.vlSelectGoodsSameJourney(e);e.stopPropagation()}} data-compindex={this.props.index}>
                <span className="ico-moon icon-goods-location"></span>
                <span className="address-box">{data.selectSameJourney ? data.selectSameJourney.address_info.province.text + data.selectSameJourney.address_info.city.text + data.selectSameJourney.address_info.district.text + data.selectSameJourney.detail_address : (data.currentLocationData && data.currentLocationData.formatted_addresses && data.currentLocationData.formatted_addresses.recommend || '暂无地址')}</span>
                <span className="ico-moon icon-fesdown"></span>
              </div>
            )
          }
          {
            !!data.customFeature.showShopInfo && (
              <div className='shopInfoHeight'
                hidden={data.infoHeight && data.shopHeight} // TOOD: 后续处理了动画之后可以去掉这个
                style={{
                  overflow: 'hidden'
                }}
                // animation={data.shopInfoHeight} 
                // bindtransitionend="stopAnimation"
                data-compindex={this.props.index}>
                {
                  data.customFeature.mode == 0 && (
                    <div className="takeout-shop-desc" style={{
                      paddingBottom: data.customFeature.is_together ? null : '.16rem'
                    }}>
                      <div style={{
                        display: 'inline-block',
                        verticalAlign: 'top',
                        position: 'relative',
                        overflow: 'hidden',
                      }} data-a={data.in_business_time}>
                        <img src={data.shopInfo && data.shopInfo.logo} style={{
                          borderRadius: price.pxToRpx(data.customFeature.logoRadius),
                        }}/>
                        {
                          data.in_business_time == 0 && (
                            <div className="takeoutShopRest">商家休息</div>
                          )
                        }
                      </div>
                      <div className="shop-info">
                        <div className="shop-title" style={{ color: data.customFeature.storeMainColor || '#000' }}>
                          <span style={{ color: data.customFeature.storeMainColor || '#000' }}>{data.shopInfo ? data.shopInfo.title : ''}</span>
                        </div>
                        {
                          !!(data.customFeature.pickUpArr.sameJourney && !data.customFeature.is_together) && (
                            <div className="shop-send" style={{
                              marginBottom: '.08rem',
                            }}>起送¥{data.config_data && (data.config_data.set_deliver_area_type == 1 ? data.config_data.deliver_rule_data.base_min_deliver_price : data.config_data.min_deliver_price)}
                              <span style={{ margin: '0 .1rem', color: '#E5E5E5' }}>|</span>配送费¥{data.config_data && (data.config_data.set_deliver_area_type == 1 ? data.config_data.deliver_rule_data.base_deliver_fee : data.config_data.deliver_fee)}
                              <span style={{ margin: '0 .1rem', color: '#E5E5E5' }}>|</span>{data.config_data && (data.config_data.set_deliver_area_type == 1 ? data.config_data.deliver_rule_data.base_deliver_time : data.config_data.deliver_time)}分钟送达
                            </div>
                          )
                        }
                        <div className="shop-adress" style={{ color: data.customFeature.storeMainColor || '#000' }}>
                          <span style={{ color: data.customFeature.storeMainColor || '#000' }}>店铺地址：{data.shopInfo ? data.shopInfo.address_detail : ''}</span>
                        </div>
                      </div>
                    </div>
                  )
                }
                {
                  data.customFeature.mode == 1 && (
                    <div className="takeout-shop-desc1">
                      <div className="takeout-shop-bgPic"
                        style={{
                          opacity: data.customFeature.style['opacity'],
                          background: data.customFeature['backgroundType']=='0' ? data.customFeature.style['background-color'] : (data.customFeature.style['background-image']),
                          backgroundSize: '100%',
                        }}>
                      </div>
                      <div className="shop-info shopInfo1">
                        <div className="shop-title" style={{ color: data.customFeature.storeMainColor || '#000' }}>
                          <span style={{ color: data.customFeature.storeMainColor || '#000' }}>{data.shopInfo ? data.shopInfo.title : ''}</span>
                        </div>
                        {
                          !!(data.customFeature.pickUpArr.sameJourney && !data.customFeature.is_together) && (
                            <div className="shop-send" style={{ marginBottom: '.12rem'}}>起送¥{(data.config_data && data.config_data.set_deliver_area_type == 1) ? data.config_data.deliver_rule_data.base_min_deliver_price : (data.config_data ? data.config_data.min_deliver_price : '')}
                              <span style={{ margin: '0 .1rem', color: '#E5E5E5' }}>|</span>配送费¥{(data.config_data && data.config_data.set_deliver_area_type == 1) ? data.config_data.deliver_rule_data.base_deliver_fee : (data.config_data ? data.config_data.deliver_fee : '')}
                              <span style={{ margin: '0 .1rem', color: '#E5E5E5' }}>|</span>{(data.config_data && data.config_data.set_deliver_area_type == 1) ? data.config_data.deliver_rule_data.base_deliver_time : (data.config_data ? data.config_data.deliver_time : '')}分钟送达
                            </div>
                          )
                        }
                        <div className='shop-adress' style={{ color: data.customFeature.storeMainColor || '#000' }}>
                          <span style={{ color: data.customFeature.storeMainColor || '#000' }}>店铺地址：{data.shopInfo ? data.shopInfo.address_detail : ''}</span>
                        </div>
                      </div>
                      <div className='shop-info-cover'>
                        <img src={data.shopInfo && data.shopInfo.logo} style={{
                          borderRadius: price.pxToRpx(data.customFeature.logoRadius),
                        }}/>
                      </div>
                    </div>
                  )
                }
                {
                  data.customFeature.mode == 2 && (
                    <div className="takeout-shop-desc2">
                      <div className='takeout-shop-bgPic'
                        style={{
                          opacity: data.customFeature.style['opacity'],
                          backgroundColor: data.customFeature['backgroundType'] == '0' ? data.customFeature.style['background-color'] : null,
                          backgroundImage: data.customFeature['backgroundType'] != '0' ? data.customFeature.style['background-image'] : null,
                          backgroundSize: '100%',
                        }}>
                      </div>
                      <div className='shop-info shopInfo'>
                        <div className='shop-title' style={{ color: data.customFeature.storeMainColor || '#000' }}>
                          <span style={{ color: data.customFeature.storeMainColor || '#000' }}>{data.shopInfo ? data.shopInfo.title : ''}</span>
                        </div>
                        {
                          !!(data.customFeature.pickUpArr.sameJourney && !data.customFeature.is_together) && (
                            <div className="shop-send" style={{ marginBottom: '.12rem'}}>起送¥{(data.config_data && data.config_data.set_deliver_area_type == 1) ? data.config_data.deliver_rule_data.base_min_deliver_price : (data.config_data ? data.config_data.min_deliver_price : '')}
                              <span style={{ margin: '0 .1rem', color: '#E5E5E5' }}>|</span>配送费¥{(data.config_data && data.config_data.set_deliver_area_type == 1) ? data.config_data.deliver_rule_data.base_deliver_fee : (data.config_data ? data.config_data.deliver_fee : '')}
                              <span style={{ margin: '0 .1rem', color: '#E5E5E5' }}>|</span>{(data.config_data && data.config_data.set_deliver_area_type == 1) ? data.config_data.deliver_rule_data.base_deliver_time : (data.config_data ? data.config_data.deliver_time : '')}分钟送达
                            </div>
                          )
                        }
                        <div className='shop-adress' style={{ color: data.customFeature.storeMainColor || '#000' }}>
                          <span style={{ color: data.customFeature.storeMainColor || '#000' }}>店铺地址：{data.shopInfo ? data.shopInfo.address_detail : ''}</span>
                        </div>
                      </div>
                      <div className='shop-info-cover1'>
                        <img src={data.shopInfo && data.shopInfo.logo} style={{
                          borderRadius: price.pxToRpx(data.customFeature.logoRadius),
                        }}/>
                      </div>
                    </div>
                  )
                }
                {
                  !!(data.customFeature.mode != 2 && !data.customFeature.is_together) && (
                    <div className="cutoffLine" style={{
                      height: '.20rem'
                    }}></div>
                  )
                }
              </div>
            )
          }
          {
            !!data.customFeature.is_together && (
              <div className="user_list">
                <div className='table_user_info'>
                  {
                    data.user_list && data.user_list.map((user, index) => (
                      <div key={index} className="cover_thumb" style={{
                        zIndex: data.user_list.length - index,
                        marginLeft: index === 0 ? '0rem' : '-.20rem' 
                      }}>
                        <img src={user.cover_thumb}/>
                      </div>
                    ))
                  }
                  <div>
                    <span>{data.user_list.length}人正在选购中</span>
                  </div>
                </div>
                {
                  data.customFeature.mode != 2 && (
                    <div className="cutoffLine" style={{ height: '.20rem' }}></div>
                  )
                }
              </div>
            )
          }
          {
            !data.showSearch && (
              <div className="waimai-goods-evaluate-search">
                <div style={{ width: data.customFeature.isShowSearch? '25%' : '33%'}}>
                  <div data-index="1" data-compindex={this.props.index} onClick={(e)=> {this.verticalListChangeEvaluate(e);e.stopPropagation()}} className={data.selected == 1 ? 'selected': ''}>商品</div>
                </div>
                <div style={{ width: data.customFeature.isShowSearch? '25%' : '33%'}}>
                  <div className={data.selected == 2 ? 'selected': ''} data-index="2" data-compindex={this.props.index} onClick={(e)=> {this.verticalListChangeEvaluate(e);e.stopPropagation()}}>评价</div>
                </div>
                <div style={{ width: data.customFeature.isShowSearch? '25%' : '33%'}}>
                  <div className={data.selected == 3 ? 'selected': ''} data-index="3" data-compindex={this.props.index} onClick={(e)=> {this.verticalListChangeEvaluate(e);e.stopPropagation()}}>店铺</div>
                </div>
                {
                  !!data.customFeature.isShowSearch && (
                    <div className='waimai-list-search'>
                      <div onClick={this.verticalListShowGoodsSearch} data-compindex={this.props.index}>
                        <label className='ico-moon icon-waimai-search'></label>
                        <span>搜索</span>
                      </div>
                    </div>
                  ) 
                }
              </div>
            )
          }
          {
            !!data.showSearch && (
              <div className="waimai-goods-evaluate-search-mode2">
                <div className='ico-moon icon-leftarrow' onClick={this.verticalListHideGoodsSearch} data-compindex={this.props.index}></div>
                <div className='waimai-goods-search-input'>
                  <label className='ico-moon icon-waimai-search' style={{float:'left'}}></label>
                  {
                    !data.hideSearchInput && (
                      <input placeholder='请输入商品名称' onInput={this.verticalListBindSearchTitle} onKeyDown={(e) => {if (e.keyCode !== 13) {return};this.verticalListSearchByTitle(e)}} data-compindex={this.props.index} />
                    )
                  }
                </div>
                <div className='evaluate-search-button' onClick={this.verticalListSearchByTitle} data-compindex={this.props.index}>搜索</div>
              </div>
            )
          }
          {
            !data.showSearch && data.selected == 1 && (
              <div className="element waimai waimai-container-wrap" style={{
                  ...convertStyleData(data.style),
                  height: `calc(${data.heightPx}px ${data.infoHeight ? '' : '- ' +(data.shopHeight || 0) + 'px'} - .68rem - .76rem ${data.customFeature.is_together ? '- .52rem': '- 0rem'} ${isShowBottom ? ' - .98rem' : ''})`,
                }}
                // bindanimationend="animationEnd"
                data-compindex={this.props.index}
              >
                <ScrollView
                  className="typeList"
                  scroll-y={true}
                  style={{
                    width: '1.52rem',
                    height: '100%',
                    maxWidth: '1.52rem',
                  }}
                  >
                  {
                    data.content && data.content.map((item, index) => (
                      <div key={index} className="waimaiCategory"
                        style={{
                          ...convertStyleData(data.customFeature.leftSpan),
                          padding: '.32rem 0',
                          backgroundColor: data.customFeature.selected == index ? data.customFeature.selectedBackgroundColor : convertStyleData(data.customFeature.leftSpan).backgroundColor,
                          color: data.customFeature.selected == index ? data.customFeature.selectedColor : convertStyleData(data.customFeature.leftSpan).color,
                          borderLeft: data.customFeature.selected == index ? '.08rem solid #ff7100' : '',
                          textAlign: (data.customFeature.typeLeft&&data.customFeature.typeLeft!='px') ? price.pxToRpx(data.customFeature.typeLeft) :'',
                          maxWidth: '1.52rem'
                        }}
                        onClick={(e)=> {this.verticalListClickCategory(e);e.stopPropagation()}}
                        data-index={index}
                        data-id={item.source}
                        data-compindex={this.props.index}
                        data-param={data.pagination && JSON.stringify(data.pagination['category'+item.source].param)}
                        data-cateindex={index}
                        >
                        {
                          !!+((item.pic && data.customFeature.directionLeft == 0 && data.customFeature.isShowListIcon && +data.customFeature.databind)||(item.pic && data.customFeature.directionLeft == 0 && !+data.customFeature.databind)) && (
                            <img src={item.pic}
                              style={{
                                display: 'inline-block',
                                verticalAlign: 'middle',
                                marginRight: '.10rem',
                                width: data.customFeature.typeImgWidth ? price.pxToRpx(data.customFeature.typeImgWidth) : '.30rem',
                                height: data.customFeature.typeImgWidth ? price.pxToRpx(data.customFeature.typeImgWidth): '.30rem',
                                borderRadius: price.pxToRpx(data.customFeature.iconRadius),
                              }}
                            />
                          )
                        }
                        <span className="waimai-cate-text">{ item.text }</span>
                        {
                          !!+((item.pic && data.customFeature.directionLeft == 1 && data.customFeature.isShowListIcon && +data.customFeature.databind)||(item.pic && data.customFeature.directionLeft == 1 && !+data.customFeature.databind)) && (
                            <img src={item.pic}
                              style={{
                                display: 'inline-block',
                                verticalAlign: 'middle',
                                marginLeft: '.10rem',
                                width: price.pxToRpx(data.customFeature.typeImgWidth),
                                height: price.pxToRpx(data.customFeature.typeImgWidth),
                                borderRadius: price.pxToRpx(data.customFeature.iconRadius),
                              }}
                            />
                          )
                        }
                      </div>
                    ))
                  }
                  <div style={{height: '1.11rem'}}></div>
                </ScrollView>
                {
                  !!(!data.customFeature.loadAllData || data.customFeature.loadAllData == '0') && (
                    <div className="waimai-shoppingList" style={{
                        left: '1.52rem',
                        width: 'calc(100% - 1.52rem)',
                        display: 'inline-block',
                        verticalAlign: 'top',
                        height: '100%',
                        minWidth: 'calc(100% - 1.52rem)'
                      }}>
                      <div>
                        {
                          !!(data.scrollTopLoading === 'top' &&  data.customFeature.selected > 0) && (
                            <span style={{
                              height: '2.00rem',
                              lineHeight: '2.00rem',
                              textAlign: 'center',
                              color: '#999',
                              fontSize: '.24rem',
                              display: 'block',
                            }}>上滑查看上一类</span>
                          ) 
                        }
                      </div>
                      {
                        data.content && data.content.map((items, index) => (
                          (
                            index == data.customFeature.selected && (
                              <ScrollView key={index} className="waimaigoodslist"
                                key={index}
                                style={{
                                  left: '1.52rem',
                                  verticalAlign: 'top',
                                  height: '100%',
                                }}
                                scroll-into-view={data.scrollId}
                                scroll-y={(data.customFeature.showShopInfo && !data.infoHeight && data.customFeature.selected == 0) ? false : true} data-compindex={this.props.index}
                                data-curpage={data.curpage}
                                data-categoryid={items.source}
                                data-param={data.pagination && JSON.stringify(data.pagination['category'+items.source].param)}
                                bindscrolltolower={this.verticalListStyleScrollFunc}
                                scroll-top={data.scrollTop}
                                bindscrolltoupper={this.verticalListStyleScrollTop}
                                upper-threshold=".20rem"
                                lower-threshold=".50rem"
                                bindtouchstart={this.scrollStart}
                                bindtouchmove={this.scrollMove}
                                bindtouchend={this.scrollEnd}
                                >
                                <div className="takeoutCategory" data-source={items.source}>{items.text}
                                  {
                                    data.customFeature.listType == '1' && (
                                      <div className='price'
                                        onClick={this.sortVerticalList}
                                        data-compindex={this.props.index}
                                        data-curpage={data.curpage}
                                        data-categoryid={items.source}
                                        data-param={data.pagination && JSON.stringify(data.pagination['category'+items.source].param)}
                                        data-sort_key="price"
                                        data-direction={data.categorySort['category'+items.source] && data.categorySort['category'+items.source].sort_direction}
                                        >
                                        <span>价格</span>
                                        <label className="ico-moon icon-news-up"
                                          style={{
                                            color: (data.categorySort['category'+items.source] && data.categorySort['category'+items.source].sort_direction == 1 && data.categorySort['category'+items.source].sortKey == 'price') ? '#666':'#ccc'
                                          }}
                                          ></label>
                                        <label className="ico-moon icon-news-down"
                                          style={{
                                            color: (data.categorySort['category'+items.source] && data.categorySort['category'+items.source].sort_direction == 0 && data.categorySort['category'+items.source].sortKey == 'price') ? '#666':'#ccc'
                                          }}
                                          ></label>
                                      </div>
                                    )
                                  }
                                  {
                                    data.customFeature.listType == '1' && (
                                      <div className="sales"
                                        onClick={this.sortVerticalList}
                                        data-compindex={this.props.index}
                                        data-curpage={data.curpage}
                                        data-categoryid={items.source}
                                        data-param={data.pagination && JSON.stringify(data.pagination['category'+items.source].param)}
                                        data-sort_key="sales"
                                        data-direction={data.categorySort['category'+items.source] && data.categorySort['category'+items.source].sort_direction}
                                        >
                                        <span>销量</span>
                                        <label className="ico-moon icon-news-up"
                                          style={{
                                            color: (data.categorySort['category'+items.source] && data.categorySort['category'+items.source].sort_direction == 1 && data.categorySort['category'+items.source].sortKey == 'sales') ? '#666':'#ccc'
                                          }}
                                          ></label>
                                        <label className="ico-moon icon-news-down"
                                          style={{
                                            color: (data.categorySort['category'+items.source] && data.categorySort['category'+items.source].sort_direction == 0 && data.categorySort['category'+items.source].sortKey == 'sales') ? '#666':'#ccc'
                                          }}
                                          ></label>
                                      </div>
                                    )
                                  }
                                </div>
                                {
                                  (data.show_goods_data && data.show_goods_data['category'+items.source]) && data.show_goods_data['category'+items.source].map((item, index) => (
                                    <React.Fragment key={index}>
                                      {
                                        data.customFeature['listArrange'] == '0' && (
                                          <div className="waimaigoods-list-item list-item">
                                            {
                                              !(!data.customFeature.showIntegral && item.integral === '1') && (
                                                <div data-id={item.id} data-compindex={this.props.index}>
                                                  <div className="inner-content">
                                                    <img className="waimai-img"
                                                      src={ item.cover }
                                                      onClick={this.showVerticalListGoodsDetail}
                                                      data-id={ item.id }
                                                      data-compindex={this.props.index}
                                                      data-index={ index }
                                                      data-category={items.source} />
                                                    {
                                                      (data.customFeature.isShowStock && item.stock < 6) && (
                                                        <label className='goods-stock'>仅剩{item.stock}件</label>
                                                      )
                                                    }
                                                    {
                                                      !!+item.corner_mark && (
                                                        <img className='new-goods' src={item.corner_url} />
                                                      )
                                                    }
                                                    <div className="waimai-title" style={{width: 'initial'}} >
                                                      <div className="waimai-title-text"
                                                        onClick={this.showVerticalListGoodsDetail}
                                                        data-id={ item.id }
                                                        data-compindex={this.props.index}
                                                        data-index={ index }
                                                        data-category={items.source}>
                                                        {
                                                          (item.max_can_use_integral > 0) && (
                                                            <span className='jifen'>积</span>
                                                          )
                                                        }
                                                        <span className='text'>{ item.title }</span>
                                                        {
                                                          !!(item.vipGoods && data.customFeature.vipShopping) && (
                                                            <span className='vip-goods'>会员购</span>
                                                          )
                                                        }
                                                      </div>
                                                      <div className='waimai-title-dec'>
                                                        {
                                                          data.customFeature.sale !== false ?
                                                            <span>销量：{item.sales}</span>
                                                            :
                                                            <span></span>
                                                        }
                                                      </div>
                                                      {
                                                        !!item.is_vip_goods && (
                                                          <div className='vip_goods_price'>
                                                            <span style={{
                                                                marginRight: '.08rem'
                                                              }}><span style={{
                                                                fontSize: '.24rem',
                                                                fontWeight: 'normal',
                                                              }}>¥</span>{item.vip_price}</span>
                                                            <span className='vip_goods_tips'>会员价</span>
                                                          </div>
                                                        )
                                                      }
                                                      <div className="waimai-item-bottom" style={{
                                                          paddingTop: 0,
                                                          marginTop: item.is_vip_goods ? '.26rem' : '.60rem',
                                                        }}>
                                                        <span className="waimai-price-per">
                                                        <span style={{
                                                          fontSize: '.24rem',
                                                          fontWeight: 'normal',
                                                        }}>¥</span>{ item.price }</span>
                                                        {
                                                          !!(data.customFeature.isShowVirtualPrice && item.virtual_price && item.virtual_price!='0.00') && (
                                                            <span style={{
                                                              textDecoration: 'line-through',
                                                              fontSize: '.22rem',
                                                              color: '#999'
                                                            }}>¥{item.virtual_price}</span>
                                                          )
                                                        }
                                                        <label className="waimai-number-change">
                                                          {
                                                            !!(data.goods_data_list[item.id].totalNum > 0 && !data.customFeature.is_together) && (
                                                              <label className={`waimai-count-minus`} data-goodsid={ item.id } onClick={(e)=> {this.verticalListListMinus(e);e.stopPropagation()}} data-stock={data.goods_data_list[item.id].stock}
                                                                data-compindex={this.props.index} data-model={item.goods_model} data-is-in-business={item.is_in_business_time}></label>
                                                            )
                                                          }
                                                          {
                                                            data.goods_data_list[item.id].totalNum  > 0 && (
                                                              <span className="waimai-number">{data.goods_data_list[item.id].totalNum}</span>
                                                            )
                                                          }
                                                          {
                                                            !item.goods_model && (
                                                              <label className={`waimai-count-plus ${data.goods_data_list[item.id].totalNum >= data.goods_data_list[item.id].stock ? 'disabled' : ''}`} data-goodsid={ item.id } onClick={(e)=> {this.verticalListListPlus(e);e.stopPropagation()}} data-stock={data.goods_data_list[item.id].stock}
                                                                data-compindex={this.props.index} data-model={item.goods_model} data-is-in-business={item.is_in_business_time}></label>
                                                            )
                                                          }
                                                          {
                                                            !!item.goods_model && (
                                                              <label className="waimai-count-model-plus" data-goodsid={ item.id } onClick={(e)=> {this.verticalListListPlus(e);e.stopPropagation()}} data-stock={data.goods_data_list[item.id].stock} data-compindex={this.props.index} data-model={item.goods_model}
                                                              data-is-in-business={item.is_in_business_time}>选规格</label>
                                                            )
                                                          }
                                                        </label>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              )
                                            }
                                          </div>
                                        )
                                      }
                                      {
                                        data.customFeature['listArrange'] == '1' && (
                                          <div className='waimai-list-mode2'>
                                            {
                                              !(!data.customFeature.showIntegral && item.integral === '1') && (
                                                <div data-id={ item.id } data-compindex={this.props.index}>
                                                  <div className="inner-mode2-content">
                                                    <div className='image-content'>
                                                      <img className="waimai-mode2-img" src={ item.cover } onClick={this.showVerticalListGoodsDetail} data-id={ item.id } data-compindex={this.props.index} data-index={ index } data-category={items.source} />
                                                      {
                                                        !!(data.customFeature.isShowStock && item.stock < 6) && (
                                                          <label className='goods-stock'>仅剩{item.stock}件</label>
                                                        )
                                                      }
                                                      {
                                                        !!+item.corner_mark && (
                                                          <img className='new-goods' src={item.corner_url} />
                                                        )
                                                      }
                                                    </div>
                                                    <div style={{width: 'initial'}} className="waimai-title waimai-mode2-title">
                                                      <div className="waimai-title-mode2-text" onClick={this.showVerticalListGoodsDetail} data-id={ item.id } data-compindex={this.props.index} data-index={ index } data-category={items.source}>
                                                        {
                                                          item.max_can_use_integral > 0 && (
                                                            <span className='jifen'>积</span>
                                                          )
                                                        }
                                                        <span className='text'>{ item.title }</span>
                                                        {
                                                          item.vipGoods && data.customFeature.vipShopping && (
                                                            <span className='vip-goods'>会员购</span>
                                                          )
                                                        }
                                                      </div>
                                                      <div className='waimai-title-mode2-dec'>
                                                        {
                                                          data.customFeature.sale !== false && (
                                                            <span>销量：{item.sales}</span>
                                                          )
                                                        }
                                                      </div>
                                                      {
                                                        !!item.is_vip_goods && (
                                                          <div className='vip_goods_price'>
                                                            <span style={{marginRight: '.08rem'}}><span style={{fontSize: '.24rem', fontWeight: 'normal'}}>¥</span>{item.vip_price}</span>
                                                            <span className='vip_goods_tips'>会员价</span>
                                                          </div>
                                                        )
                                                      }
                                                      <div className="waimai-item-bottom" style={{
                                                        paddingTop: '0',
                                                        marginTop: item.is_vip_goods ? '.02rem' : '.36rem'
                                                      }}>
                                                        <span className="waimai-price-per">
                                                        <span style={{
                                                          fontSize: '.24rem',
                                                          fontWeight: 'normal'
                                                        }}>¥</span>{ item.price }</span>
                                                        {
                                                          !!(data.customFeature.isShowVirtualPrice && item.virtual_price && item.virtual_price!='0.00') && (
                                                            <span style={{
                                                              textDecoration: 'line-through',
                                                              fontSize: '.22rem',
                                                              color: '#999'
                                                            }}>¥{item.virtual_price}</span>
                                                          )
                                                        }
                                                        <label className="waimai-number-change">
                                                          {
                                                            !item.goods_model && (
                                                              <label className={`waimai-count-plus ${data.goods_data_list[item.id].totalNum >= data.goods_data_list[item.id].stock ? 'disabled' : ''}`} data-goodsid={ item.id } onClick={(e)=> {this.verticalListListPlus(e);e.stopPropagation()}} data-stock={data.goods_data_list[item.id].stock}
                                                                data-compindex={this.props.index} data-model={item.goods_model} data-is-in-business={item.is_in_business_time}>
                                                                {
                                                                  data.goods_data_list[item.id].totalNum > 0 && (
                                                                    <label>{data.goods_data_list[item.id].totalNum}</label>
                                                                  )
                                                                }
                                                              </label>
                                                            )
                                                          }
                                                          {
                                                            !!item.goods_model && (
                                                              <label className="waimai-count-model-plus" data-goodsid={ item.id } onClick={(e)=> {this.verticalListListPlus(e);e.stopPropagation()}} data-stock={data.goods_data_list[item.id].stock} data-compindex={this.props.index} data-model={item.goods_model}
                                                                data-is-in-business={item.is_in_business_time}>选规格
                                                                {
                                                                  data.goods_data_list[item.id].totalNum > 0 && (
                                                                    <label>{data.goods_data_list[item.id].totalNum}</label>
                                                                  )
                                                                }
                                                              </label>
                                                            )
                                                          }
                                                        </label>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              )
                                            }
                                          </div>
                                        )
                                      }
                                    </React.Fragment>
                                  ))
                                }
                                {
                                  (data.customFeature.selected !== data.content.length-1 && (data.show_goods_data && data.show_goods_data['category'+items.source] && data.show_goods_data['category'+items.source].length > 0)) && (
                                    <div style={{
                                      height: '5.00rem',
                                      lineHeight: '5.00rem',
                                      textAlign: 'center',
                                      color: '#999',
                                      fontSize: '.24rem',
                                    }}>
                                      {
                                        (data.scrollTopLoading === 'bottom' && data.pagination['category'+items.source].is_more == 0) && (
                                          <span>下滑查看下一分类</span>
                                        )
                                      }
                                    </div>
                                  )
                                }
                                {
                                  (data.customFeature.selected == data.content.length-1) && (
                                    <div style={{height:'2.00rem'}}></div>
                                  )
                                }
                                {/* 加载loading */}
                                {
                                  data.loading && 
                                  <RequestStatus is="requestLoading"></RequestStatus>
                                }
                                {/* 加载没有数据 */}
                                {
                                  !!(data.pagination && data.pagination['category'+items.source].is_more == 0 && data.show_goods_data && data.show_goods_data['category'+items.source] && data.show_goods_data['category'+items.source].length == 0) &&
                                  <RequestStatus is="requestNone" data={{ data: '暂无数据~'}}></RequestStatus>
                                }
                                {/* 加载失败 */}
                                {
                                  data.loadingFail &&
                                  <RequestStatus is="requestFail" data={{refreshEvent: 'verticalListStyleScrollFunc', compindex: this.props.index}}></RequestStatus>
                                }
                                {/* 加载完所有数据 */}
                                {
                                  !!(data.pagination && data.pagination['category'+items.source].is_more == 0 && data.show_goods_data && data.show_goods_data['category'+items.source] && data.show_goods_data['category'+items.source].length > 0 && data.customFeature.selected == data.content.length-1) &&
                                  <RequestStatus is="requestAll"></RequestStatus>
                                }
                              </ScrollView>
                            )
                          )
                        )) 
                      }
                      {
                        data.customFeature.loadAllData == '1' && (
                          <div style={{height: '1.11rem'}}></div>
                        )
                      }
                    </div>
                  )
                }
                {
                  data.customFeature.loadAllData == '1' && (
                    <div className='waimai-shoppingList' style={{
                        left: '1.52rem',
                        width: 'calc(100% - 1.52rem)',
                        display: 'inline-block',
                        verticalAlign: 'top',
                        height: '100%',
                        minWidth: 'calc(100% - 1.52rem)'
                      }}>
                      <ScrollView style={{height: '100%', verticalAlign: 'top'}} className="waimaigoodslist"  scroll-y={true} scroll-into-view={data.scrollInto} scroll-with-animation={true} onScroll={this.verticalListGoodsListScroll} data-compindex={this.props.index}>
                        <div className="takeoutCategory"></div>
                        {
                          data.content && data.content.map((cate, index) => (
                            <React.Fragment key={index}>
                              <div id={`cate-${index}`} style={{
                                height: '.38rem',
                                paddingLeft: '.20rem',
                              }}>{cate.text}</div>
                              {
                                (data.loadFirstCate && index == 0) && (
                                  <div className='firstCate' style={{
                                    height: '100%',
                                    position: 'absolute',
                                    width: '100%',
                                    zIndex: '99'
                                  }}>
                                    <RequestStatus is="requestLoading"></RequestStatus>
                                  </div>
                                )
                              }
                              {
                                data.show_goods_data && data.show_goods_data['category'+cate.source] && data.show_goods_data['category'+cate.source].map((item, index) => (
                                  <React.Fragment key={index}>
                                    {
                                      data.customFeature['listArrange'] == '0' && (
                                        <div className="waimaigoods-list-item list-item">
                                          {
                                            !(!data.customFeature.showIntegral && item.integral === '1') && (
                                              <div data-id={ item.id } data-compindex={this.props.index}> 
                                                <div className="inner-content">
                                                  <img className="waimai-img" src={ item.cover } onClick={this.showVerticalListGoodsDetail} data-id={ item.id } data-compindex={this.props.index} data-index={ index } data-category={cate.source} />
                                                  {
                                                    !!(data.customFeature.isShowStock && item.stock < 6) && (
                                                      <label className='goods-stock'>仅剩{item.stock}件</label>
                                                    )
                                                  }
                                                  {
                                                    !!+item.corner_mark && (
                                                      <img className='new-goods' src={item.corner_url} />
                                                    )
                                                  }
                                                  <div style={{width: 'initial'}} className="waimai-title">
                                                    <div className="waimai-title-text" onClick={this.showVerticalListGoodsDetail} data-id={ item.id } data-compindex={this.props.index} data-index={ index } data-category={cate.source}>
                                                      {
                                                        item.max_can_use_integral > 0 && (
                                                          <span className='jifen'>积</span>
                                                        )
                                                      }
                                                      <span className='text'>{ item.title }</span>
                                                      {
                                                        item.vipGoods && data.customFeature.vipShopping && (
                                                          <span className='vip-goods'>会员购</span>
                                                        )
                                                      }
                                                    </div>
                                                    <div className='waimai-title-dec'>
                                                      {
                                                        data.customFeature.sale !== false ?
                                                          <span>销量：{item.sales}</span>
                                                          :
                                                          <span></span>
                                                      }
                                                    </div>
                                                    {
                                                      !!item.is_vip_goods && (
                                                        <div className='vip_goods_price'>
                                                          <span style={{marginRight: '.08rem'}}><span style={{fontSize: '.24rem', fontWeight: 'normal'}}>¥</span>{item.vip_price}</span>
                                                          <span className='vip_goods_tips'>会员价</span>
                                                        </div>
                                                      )
                                                    }
                                                    <div className="waimai-item-bottom" style={{
                                                        paddingTop: '0',
                                                        marginTop: item.is_vip_goods ? '.26rem' : '.60rem'
                                                      }}>
                                                      <span className="waimai-price-per">
                                                        <span style={{fontSize: '.24rem', fontWeight: 'normal'}}>¥</span>{ item.price }
                                                      </span>
                                                      {
                                                        !!(data.customFeature.isShowVirtualPrice && item.virtual_price && item.virtual_price!='0.00') && (
                                                          <span style={{
                                                            textDecoration: 'line-through',
                                                            fontSize: '.22rem',
                                                            color: '#999'
                                                          }}>¥{item.virtual_price}</span>
                                                        )
                                                      }
                                                      <label className="waimai-number-change">
                                                        {
                                                          !!(data.goods_data_list[item.id].totalNum > 0 && !data.customFeature.is_together) && (
                                                            <label className={`waimai-count-minus`} data-goodsid={ item.id } onClick={(e)=> {this.verticalListListMinus(e);e.stopPropagation()}} data-stock={data.goods_data_list[item.id].stock} data-compindex={this.props.index} data-model={item.goods_model} data-is-in-business={item.is_in_business_time}></label>
                                                          )
                                                        }
                                                        {
                                                          (data.goods_data_list[item.id].totalNum  > 0) && (
                                                            <span className="waimai-number">{ data.goods_data_list[item.id].totalNum }</span>
                                                          )
                                                        }
                                                        {
                                                          !item.goods_model && (
                                                            <label className={`waimai-count-plus ${data.goods_data_list[item.id].totalNum >= data.goods_data_list[item.id].stock ? 'disabled' : ''}`} data-goodsid={ item.id } onClick={(e)=> {this.verticalListListPlus(e);e.stopPropagation()}} data-stock={data.goods_data_list[item.id].stock} data-compindex={this.props.index} data-model={item.goods_model} data-is-in-business={item.is_in_business_time}></label>
                                                          )
                                                        }
                                                        {
                                                          !!item.goods_model && (
                                                            <label className="waimai-count-model-plus" data-goodsid={ item.id } onClick={(e)=> {this.verticalListListPlus(e);e.stopPropagation()}} data-stock={data.goods_data_list[item.id].stock} data-compindex={this.props.index} data-model={item.goods_model} data-is-in-business={item.is_in_business_time}>选规格</label>
                                                          ) 
                                                        }
                                                      </label>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            )
                                          }
                                        </div>
                                      )
                                    }
                                    {
                                      data.customFeature['listArrange'] == '1' && (
                                        <div className='waimai-list-mode2'>
                                          {
                                            !(!data.customFeature.showIntegral && item.integral === '1') && (
                                              <div data-id={ item.id } data-compindex={this.props.index}>
                                                <div className="inner-mode2-content">
                                                  <div className='image-content'>
                                                    <img className="waimai-mode2-img" src={ item.cover } onClick={this.showVerticalListGoodsDetail} data-id={ item.id } data-compindex={this.props.index} data-index={ index } data-category={cate.source}/>
                                                    {
                                                      !!(data.customFeature.isShowStock && item.stock < 6) && (
                                                        <label className='goods-stock'>仅剩{item.stock}件</label>
                                                      )
                                                    }
                                                    {
                                                      !!+item.corner_mark && (
                                                        <img className='new-goods' src={item.corner_url} />
                                                      )
                                                    }
                                                  </div>
                                                  <div style={{width: 'initial'}} className="waimai-title waimai-mode2-title">
                                                    <div className="waimai-title-mode2-text" onClick={this.showVerticalListGoodsDetail} data-id={ item.id } data-compindex={this.props.index} data-index={ index } data-category={cate.source}>
                                                      {
                                                        item.max_can_use_integral > 0 && (
                                                          <span className='jifen'>积</span>
                                                        )
                                                      }
                                                      <span className='text'>{ item.title }</span>
                                                      {
                                                        item.vipGoods && data.customFeature.vipShopping && (
                                                          <span className='vip-goods'>会员购</span>
                                                        )
                                                      }
                                                    </div>
                                                    <div className='waimai-title-mode2-dec'>
                                                      {
                                                        data.customFeature.sale !== false &&(
                                                          <span>销量：{item.sales}</span>
                                                        )
                                                      }
                                                    </div>
                                                    {
                                                      !!item.is_vip_goods && (
                                                        <div className='vip_goods_price'>
                                                          <span style={{marginRight: '.08rem'}}><span style={{fontSize: '.24rem', fontWeight: 'normal'}}>¥</span>{item.vip_price}</span>
                                                          <span className='vip_goods_tips'>会员价</span>
                                                        </div>
                                                      )
                                                    }
                                                    <div className="waimai-item-bottom" style={{
                                                        paddingTop: '0',
                                                        marginTop: item.is_vip_goods ? '.02rem' : '.36rem'
                                                      }}>
                                                      <span className="waimai-price-per">
                                                        <span style={{fontSize: '.24rem', fontWeight: 'normal'}}>¥</span>{ item.price }
                                                      </span>
                                                      {
                                                        !!(data.customFeature.isShowVirtualPrice && item.virtual_price && item.virtual_price!='0.00') && (
                                                          <span style={{
                                                            textDecoration: 'line-through',
                                                            fontSize: '.22rem',
                                                            color: '#999'
                                                          }}>¥{item.virtual_price}</span>
                                                        )
                                                      }
                                                      <label className="waimai-number-change">
                                                        {
                                                          !item.goods_model && (
                                                            <label className={`waimai-count-plus ${data.goods_data_list[item.id].totalNum >= data.goods_data_list[item.id].stock ? 'disabled' : ''}`} data-goodsid={ item.id } onClick={(e)=> {this.verticalListListPlus(e);e.stopPropagation()}} data-stock={data.goods_data_list[item.id].stock} data-compindex={this.props.index} data-model={item.goods_model} data-is-in-business={item.is_in_business_time}>
                                                              {
                                                                data.goods_data_list[item.id].totalNum > 0 && (
                                                                  <label>{data.goods_data_list[item.id].totalNum}</label>
                                                                )
                                                              }
                                                            </label>
                                                          )
                                                        }
                                                        {
                                                          !!item.goods_model && (
                                                            <label className="waimai-count-model-plus" data-goodsid={ item.id } onClick={(e)=> {this.verticalListListPlus(e);e.stopPropagation()}} data-stock={data.goods_data_list[item.id].stock} data-compindex={this.props.index} data-model={item.goods_model} data-is-in-business={item.is_in_business_time}>选规格
                                                              {
                                                                data.goods_data_list[item.id].totalNum > 0 && (
                                                                  <label>{data.goods_data_list[item.id].totalNum}</label>
                                                                )
                                                              }
                                                            </label>
                                                          ) 
                                                        }
                                                      </label>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            )
                                          }
                                        </div>
                                      )
                                    }
                                  </React.Fragment>
                                ))
                              }
                            </React.Fragment>
                          ))
                        }
                        <div style={{height: '3.00rem'}}></div>
                      </ScrollView>
                    </div>
                  )
                }
              </div>
            )
          }
          {
            !!data.showSearch && (
              <div className="element waimai waimai-container-wrap searchResult" data-compindex={this.props.index} >
                <ScrollView scroll-y="true" data-compindex={this.props.index} style={{height:`calc(${data.searchHeight}px ${data.customFeature.is_together ? '- .20rem' : '- 0em'}${isShowBottom ? ' - .98rem' : ''}})`}} data-compindex={this.props.index} bindscrolltolower="verticalListSearchScrollFunc">
                  {
                    data.show_goods_data['searchResult'] && data.show_goods_data['searchResult'].map((item, index) => (
                      <div key={index} data-id={ item.id } data-compindex={this.props.index} className='clearfix' style={{padding:'.20rem'}}>
                        <div className="inner-content">
                        <img className="waimai-img" src={ item.cover } onClick={this.showVerticalListGoodsDetail} data-id={ item.id } data-compindex={this.props.index} data-index={ index } data-category={item.source} data-is_search='search'/>
                        {
                          !!(data.customFeature.isShowStock && item.stock < 6) && (
                            <label className='goods-stock'>仅剩{item.stock}件</label>
                          )
                        }
                        <div style={{width: 'initial'}} className="waimai-title">
                          <div className="waimai-title-text" onClick={this.showVerticalListGoodsDetail} data-id={ item.id } data-id={ item.id } data-compindex={this.props.index} data-index={ index } data-category={item.source} data-is_search='search'>
                            {
                              item.max_can_use_integral > 0 && (
                                <span className='jifen'>积</span>
                              )
                            }
                            <span className='text'>{ item.title }</span>
                            {
                              item.vipGoods && data.customFeature.vipShopping && (
                                <span className='vip-goods'>会员购</span>
                              )
                            }
                          </div>
                          <div className='waimai-title-dec'>
                            {
                              data.customFeature.sale !== false ?
                                <span>销量：{item.sales}</span>
                                :
                                <span></span>
                            }
                          </div>
                          {
                            !!item.is_vip_goods && (
                              <div className='vip_goods_price'>
                                <span style={{marginRight: '.08rem'}}><span style={{fontSize: '.24rem', fontWeight: 'normal'}}>¥</span>{item.vip_price}</span>
                                <span className='vip_goods_tips'>会员价</span>
                              </div>
                            )
                          }
                          <div className="waimai-item-bottom" style={{
                              paddingTop: '0',
                              marginTop: item.is_vip_goods ? '.0rem' : '.60rem'
                            }}>
                            <span className="waimai-price-per">
                              <span style={{fontSize: '.24rem', fontWeight: 'normal'}}>¥</span>{ item.price }
                            </span>
                            {
                              !!(data.customFeature.isShowVirtualPrice && item.virtual_price && item.virtual_price!='0.00') && (
                                <span style={{
                                  fontSize: '.28rem',
                                  color: '#666666',
                                  textDecoration: 'line-through',
                                }}>¥{item.virtual_price}</span>
                              )
                            }
                            <label className="waimai-number-change">
                              {
                                !!(data.goods_data_list[item.id].totalNum > 0 && !data.customFeature.is_together) && (
                                  <label className={`waimai-count-minus`} data-goodsid={ item.id } onClick={(e)=> {this.verticalListListMinus(e);e.stopPropagation()}} data-stock={data.goods_data_list[item.id].stock} data-compindex={this.props.index} data-model={item.goods_model} data-is-in-business={item.is_in_business_time}></label>
                                )
                              }
                              {
                                (data.goods_data_list[item.id].totalNum  > 0) && (
                                  <span className="waimai-number">{ data.goods_data_list[item.id].totalNum }</span>
                                )
                              }
                              {
                                !item.goods_model && (
                                  <label className={`waimai-count-plus ${data.goods_data_list[item.id].totalNum >= data.goods_data_list[item.id].stock ? 'disabled' : ''}`} data-goodsid={ item.id } onClick={(e)=> {this.verticalListListPlus(e);e.stopPropagation()}} data-stock={data.goods_data_list[item.id].stock} data-compindex={this.props.index} data-model={item.goods_model} data-is-in-business={item.is_in_business_time}></label>
                                )
                              }
                              {
                                !!item.goods_model && (
                                  <label className="waimai-count-model-plus" data-goodsid={ item.id } onClick={(e)=> {this.verticalListListPlus(e);e.stopPropagation()}} data-stock={data.goods_data_list[item.id].stock} data-compindex={this.props.index} data-model={item.goods_model} data-is-in-business={item.is_in_business_time}>选规格</label>
                                ) 
                              }
                            </label>
                          </div>
                        </div>
                        </div>
                      </div>
                    ))
                  }
                  {
                    data.searchLoading && (
                      <RequestStatus is="requestLoading"></RequestStatus>
                    )
                  }
                  {
                    !!(data.pagination['searchResult'] && data.pagination['searchResult'].is_more == 0 && data.show_goods_data['searchResult'].length > 0) && (
                      <RequestStatus is="requestAll"></RequestStatus>
                    )
                  }
                  {
                    !!(data.pagination['searchResult'] && data.pagination['searchResult'].is_more == 0 && data.show_goods_data['searchResult'].length == 0) && (
                      <RequestStatus is="requestNone" data={{ data: '暂无数据~'}}></RequestStatus>
                    )
                  }
                </ScrollView>
              </div>
            )
          }
          {
            !!(data.selected == 1 || data.showSearch) && (
              <div className="goods-bottom-opt"
                  style={{
                    bottom: isShowBottom ? '1.18rem' : '.20rem',
                  }}
                  data-compindex={this.props.index} onClick={(e)=> {this.verticalListShowShoppingCartPop(e);e.stopPropagation()}}>
                <div className="shoppingcart-total-money">
                  <div className="shopping-cart-wrap">
                    <label className="ico-moon icon-fn-cart" data-compindex={this.props.index} onClick={(e)=> {this.verticalListShowShoppingCartPop(e);e.stopPropagation()}}></label>
                    {
                      data.TotalNum != 0 && (
                        <label className="waimai-count">{ data.TotalNum }</label>
                      )
                    }
                  </div>
                  <div className="shopping-money-wrap">
                    {
                      data.TotalPrice != 0 ?
                        <div className="shopping-money-price">
                          <span style={{
                            marginRight: '.06rem'
                          }}>¥</span>
                          { data.TotalPrice }
                        </div>
                        :
                        <div className="classname" style={{
                          color: '#9b9b9d',
                          lineHeight: '.88rem'
                        }}>请选择商品</div>
                    }
                  </div>
                </div>
                <div >
                  <button className={`sure-waimai-order ${ data.TotalNum == 0 ? 'disabledBtn':'' }`} onClick={(e)=> {this.verticalListSettlement(e);e.stopPropagation()}} data-compindex={this.props.index}>去结算</button>
                </div>
              </div>
            )
          }
          {
            !data.showSearch && data.selected == 2 && (
              <div className="verticalList-shop-evaluate">
                {
                  !!((data.assessList && data.assessList.length>0) || data.moreAssess) && (
                    <ScrollView style={{
                        height: `calc(${data.heightPx}px ${data.infoHeight ? '' : '- ' +(data.shopHeight || 0) + 'px'} - .90rem${isShowBottom ? ' - .98rem' : ''})`,
                      }} scroll-y={true} >
                      <div style={{
                          width: '100%',
                          height: '.12rem',
                          background: '#F3F3F3'
                        }}></div>
                      <div style={{
                          padding: '.30rem',
                          display: 'flex',
                          justifyContent: 'space-between'
                        }}>
                        <div className={`verticalList-assess-btn ${data.assessActive == 0 ? 'active' :''}`} data-active="0" data-compindex={this.props.index} onClick={(e)=> {this.verticalListChangeAssessType(e);e.stopPropagation()}}>有图({data.assessNum[4]||0})</div>
                        <div className={`verticalList-assess-btn ${data.assessActive == 1 ? 'active' :''}`} data-active="1" data-compindex={this.props.index} onClick={(e)=> {this.verticalListChangeAssessType(e);e.stopPropagation()}}>好评({data.assessNum[1]||0})</div>
                        <div className={`verticalList-assess-btn ${data.assessActive == 2 ? 'active' :''}`} data-active="2" data-compindex={this.props.index} onClick={(e)=> {this.verticalListChangeAssessType(e);e.stopPropagation()}}>中评({data.assessNum[2]||0})</div>
                        <div className={`verticalList-assess-btn ${data.assessActive == 3 ? 'active' :''}`} data-active="3" data-compindex={this.props.index} onClick={(e)=> {this.verticalListChangeAssessType(e);e.stopPropagation()}}>差评({data.assessNum[3]||0})</div>
                      </div>
                      {
                        data.showAssess && data.showAssess.map((item, i) => (
                          <div key={i} className="verticalListAssessList">
                            <img src={item.buyer_headimgurl}/>
                            <div className="assessInfoTop">
                              <div className="verticalListNickname">
                                <span className="tackoutNickText">{item.buyer_nickname}</span>
                                <span className=" pull-right">{item.add_time}</span>
                              </div>
                              <div className="verticalListService">商家服务：
                                <label className={`ico-moon icon-satisfied ${item.assess_info.level == 1 ? 'active' :''}`}></label>
                                <span className={item.assess_info.level == 1 ? 'active' :''}> 满意</span>
                                <span style={{color:'#9b9b9b',margin:'0 .09rem'}}>|</span>
                                <label className={`ico-moon icon-satisfied ${item.assess_info.level == 2 ? 'active' :''}`}></label>
                                <span className={item.assess_info.level == 2 ? 'active' :''}> 一般</span>
                                <span style={{color:'#9b9b9b',margin:'0 .09rem'}}>|</span>
                                <label className={`ico-moon icon-satisfied ${item.assess_info.level == 3 ? 'active' :''}`}></label>
                                <span className={item.assess_info.level == 3 ? 'active' :''}> 不满意</span>
                              </div>
                            </div>
                            <div className="verticalList-assess-title">
                              <span className="verticalList-assess-goodsTitle">{item.goods_info.title}：</span>
                              <span className="verticalList-assess-goodsContent">{item.assess_info.content}</span>
                            </div>
                            {
                              !!item.assess_info.has_img && (
                                <div style={{marginLeft: '.74rem'}}>
                                  {
                                    item.assess_info.img_arr && item.assess_info.img_arr.map((imgs, index) => (
                                      <img key={index} data-imgarr={JSON.stringify(item.assess_info.img_arr)} data-src={imgs} src={imgs} onClick={(e)=> {this.previewImage(e);e.stopPropagation()}}/>
                                    ))
                                  }
                                </div>

                              )
                            }
                          </div>
                        ))
                      }
                      {
                        !!data.moreAssess && (
                          <div className="getMoreAssess" onClick={this.verticalListGetMoreAssess} data-compindex={this.props.index} data-nextpage={data.assessCurrentPage + 1}>查看更多
                            <label className="ico-moon icon-downarrow"></label>
                          </div>
                        )
                      }
                      {
                        !data.moreAssess && (
                          <div className="getMoreAssess">{data.assessList.length ? '已经到底啦' : '暂无评价'}</div>
                        )
                      }
                    </ScrollView>
                  )
                }
                {
                  !!(!data.moreAssess && !(data.assessList && data.assessList.length)) && (
                    <div className='noMoreAssess'>
                      <img mode='aspectFit' src='https://www.zhichiwangluo.com/zhichi_frontend/static/webapp/images/moreAssess.png'/>
                      <div className="getMoreAssess" style={{background:'#fff'}}>暂无任何评价</div>
                    </div>
                  )
                }
              </div>
            )
          }
          {
            !data.showSearch && data.selected == 3 && (
              <div className="tokeout-shop-info" style={{
                  padding: '0'
                }}>
                <div style={{fontSize:'.26rem',color:'#333333'}}>
                  <div className="info-title" style={{fontSize:'.30rem'}}>商家信息</div>
                  <div className='info-shopInfo'>
                    <div className="info-adress" onClick={(e)=> {this.openVerticalListLocation(e);e.stopPropagation()}} data-name={data.shopInfo.title} data-address={data.shopInfo.address_detail} data-lat={data.shopInfo.latitude} data-lng={data.shopInfo.longitude}>
                      <label className="ico-moon icon-fesadress"></label>
                      <span>{data.shopInfo.address_detail}</span>
                    </div>
                    <div onClick={(e)=> {app.callPhone(e);e.stopPropagation()}} data-phone={data.shopInfo.service_phone} className='info-takeout-phone'>
                      <label className="ico-moon icon-fn-phone" style={{marginRight:'0',fontSize:'.40rem',color:'#d2d2d2'}}></label>
                    </div>
                  </div>
                  <div style={{width:'auto',overflow:'hidden',margin:'0 .26rem',padding:'.26rem 0',borderBottom:'.02rem solid #F3F3F3'}}>
                    <label className="ico-moon icon-tokeout-info" style={{float:'left',marginTop:'.08rem'}}></label>
                    <span style={{width:'6.50rem',whiteSpace:'normal'}}>{data.shopInfo.store_desc}</span>
                  </div>
                </div>
                {
                  !!(data.shopInfo.shop_environment  && data.shopInfo.shop_environment.length > 0) && (
                    <div className="cutoffLine" style={{backgroundColor:'#f3f3f3',marginBottom:'0rem',paddingBottom:'0rem',height:'.16rem'}}></div>
                  )
                }
                {
                  !!(data.shopInfo.shop_environment  && data.shopInfo.shop_environment.length > 0) && (
                    <div>
                      <div className="info-title">店铺风采</div>
                      <div className='info-mien' style={{whiteSpace:'nowrap',overflowX:'auto'}}>
                        {
                          data.shopInfo.shop_environment && data.shopInfo.shop_environment.map((imgs, index) => (
                            <img key={index} data-imgarr={JSON.stringify(data.shopInfo.shop_environment)} data-src={imgs} src={imgs} onClick={(e)=> {this.previewImage(e);e.stopPropagation()}}/>
                          ))
                        }
                      </div>
                    </div>
                  )
                }
              </div>
            )
          }
          {
            !!data.goodsDetailShow && (
              <div className="takeout-goods-picture" data-compindex={this.props.index}>
                <div style={{paddingBottom:'1.20rem'}}>
                  <div className='takeout-goods-pic'>
                    <label className="ico-moon icon-closes" data-compindex={this.props.index} onClick={this.verticalListHideDetailPop}></label>
                    {
                      !!data.goodsDetail.img_urls.length ?
                        <Carousel
                          dots={true}
                          infinite={true}
                          autoplay={true}
                          autoplayInterval={5000}
                        >
                          {data.goodsDetail.img_urls.map((item, index) => (
                            <img
                              key={index}
                              src={item}
                            />
                          ))}
                        </Carousel>
                        :
                        <img src={data.goodsDetail.cover} mode='aspectFit'/>
                    }
                  </div>
                  <div className='goods-info' style={{borderBottom: data.goodsDetail.description?'.02rem solid #F3F3F3':'none'}}>
                    <div className='goods-detail-title'>
                      <span className='text'>{data.goodsDetail.title}</span>
                      {
                        data.goodsDetail.vipGoods && data.customFeature.vipShopping && (
                          <span className='vip-goods'>会员购</span>
                        )
                      }
                    </div>
                    <div className='goods-sales-detail'>
                      {
                        data.customFeature.sale !== false && (
                          <span style={{marginRight:'.16rem'}}>销量{data.goodsDetail.sales}份</span>
                        )
                      }
                    </div>
                    <div className='waimai-title clearfix' style={{position:'relative'}}>
                      {
                        !data.goodsDetail.is_vip_goods ? (
                          <span style={{marginRight: '.18rem', color: '#FF6500', fontSize: '.32rem'}}>¥{data.goodsDetail.price}</span>
                        ) : (
                          <div className='goodsDetail_vip_goods'>
                            <span className='detail_vip_price'>¥{data.goodsDetail.vip_price}</span>
                            <span className='detail_vip_text'>会员价</span>
                            <span className='detail_price'>¥{data.goodsDetail.price}</span>
                          </div>
                        )
                      }
                      {
                        (data.customFeature.isShowVirtualPrice && data.goodsDetail.virtual_price != '0.00') && (
                          <span style={{color: '#666666',fontSize: '.28rem',textDecoration: 'line-through'}}>¥{data.goodsDetail.virtual_price}</span>
                        )
                      }
                      <label className="waimai-number-change" style={{top: '-.08rem'}}>
                        {
                          !!(data.goods_data_list[data.goodsDetail.id].totalNum > 0 && !data.customFeature.is_together) && (
                            <label className={`waimai-count-minus`} data-goodsid={ data.goodsDetail.id } onClick={(e)=> {this.verticalListListMinus(e);e.stopPropagation()}} data-stock={data.goods_data_list[data.goodsDetail.id].stock}
                              data-compindex={this.props.index} data-model={data.goodsDetail.goods_model} data-is-in-business={data.goodsDetail.is_in_business_time}></label>
                          )
                        }
                        {
                          data.goods_data_list[data.goodsDetail.id].totalNum  > 0 && (
                            <span className="waimai-number">{ data.goods_data_list[data.goodsDetail.id].totalNum }</span>
                          )
                        }
                        {
                          !data.goodsDetail.goods_model && (
                            <label className={`waimai-count-plus ${data.goods_data_list[data.goodsDetail.id].totalNum >= data.goods_data_list[data.goodsDetail.id].stock ? 'disabled' : ''}`} data-goodsid={ data.goodsDetail.id } onClick={(e)=> {this.verticalListListPlus(e);e.stopPropagation()}}
                              data-stock={data.goods_data_list[data.goodsDetail.id].stock} data-compindex={this.props.index} data-model={data.goodsDetail.goods_model} data-is-in-business={data.goodsDetail.is_in_business_time}></label>
                          )
                        }
                        {
                          !!data.goodsDetail.goods_model && (
                            <label className="waimai-count-model-plus" data-goodsid={ data.goodsDetail.id } onClick={(e)=> {this.verticalListListPlus(e);e.stopPropagation()}} data-stock={data.goods_data_list[data.goodsDetail.id].stock} data-compindex={this.props.index} data-model={data.goodsDetail.goods_model} data-is-in-business={data.goodsDetail.is_in_business_time}>选规格</label>
                          )
                        }
                      </label>
                    </div>
                  </div>
                  {
                    !!data.goodsDetail.description && (
                      <div className='goods-desc'>
                        <div style={{color: '#323232', fontSize: '.26rem', marginBottom: '.16rem'}}>商品描述</div>
                        <div className="rich-text" dangerouslySetInnerHTML={{ __html:  data.goodsDetail.des && data.goodsDetail.des.replace(/href=".*?"/g,'')}}></div>
                      </div>
                    )
                  }
                  {
                    data.goodsDetail.goodsAssess.count > 0 && (
                      <div className='goods-evaluate'>
                        <div className='evaluate-title'>
                          <span>评价</span>
                          <div className='evaluate-count pull-right' style={{color:'#999999'}}>{data.goodsDetail.goodsAssess.count}条评价</div>
                        </div>
                        {
                          data.goodsDetail.goodsAssess.data && data.goodsDetail.goodsAssess.data.map((item, index) => (
                            <div key={index} className='evaluate-info'>
                              <div className='evaluate-userInfo'>
                                <div className='evaluate-userInfo-pic'>
                                  <img src={item.buyer_headimgurl}/>
                                </div>
                                <div className='evaluate-userInfo-info'>
                                  <div className='evaluate-userInfo-nickname'>{item.buyer_nickname}</div>
                                  <div className='evaluate-userInfo-time'>{item.add_time}</div>
                                </div>
                              </div>
                              <div className='evaluate-desc'>
                                <div className='assess'>{item.assess_info.content}</div>
                              </div>
                              <div className='evaluate-pics'>
                                {
                                  item.assess_info.i_arr && item.assess_info.i_arr.map((imgs, index) => (
                                    <img key={index} data-imgarr={JSON.stringify(item.assess_info.img_arr)} data-src={imgs} src={imgs} onClick={(e)=> {this.previewImage(e);e.stopPropagation()}}/>
                                  ))
                                }
                              </div>
                            </div>
                          ))
                        }
                        {
                          data.goodsDetail.goodsAssess.is_more == 0 && (
                            <RequestStatus is="requestAll"></RequestStatus>
                          )
                        }
                        {
                          data.goodsDetail.goodsAssess.is_more == 1 && (
                            <div className='request-all' data-compindex={this.props.index} onClick={(e)=> {this.verticalListGetMoreGoodsAssess(e);e.stopPropagation()}}>点击加载更多</div>
                          )
                        }
                      </div>
                    )
                  }
                </div>
              </div>
            )
          }
          {
            !!data.goodsModelShow && (
              <div className="takeout-model-choose" data-compindex={this.props.index} onClick={this.verticalListHideModelPop}>
                <div
                  onClick={this.stopPropagation}
                  >
                  <div className="takeout-title">{data.goods_data_list[data.modelGoodsId].model.name}
                    <div className="takeout-title-close" data-compindex={this.props.index} onClick={this.verticalListHideModelPop}>
                      <span className='ico-moon icon-closes'></span>
                    </div>
                  </div>
                  <ScrollView style={{paddingLeft:'.40rem',height:'4.84rem',width:'6.10rem'}} scroll-y={true}>
                    {
                      data.goods_data_list[data.modelGoodsId].model.modelData && data.goods_data_list[data.modelGoodsId].model.modelData.map((goodsItems, index) => (
                        <React.Fragment key={index}>
                          <div className="" style={{paddingTop:'.30rem',paddingBottom:'.20rem',color:'#666',fontSize:'.26rem'}}>{goodsItems.name}：</div>
                          <div className="model-btn">
                            {
                              goodsItems.subModelName && goodsItems.subModelName.map((item, i) => (
                                <span key={i} className={`attr-btn ${goodsItems.subModelId[i] == data.modelIdArr[index] ? 'active' :''}`} data-id={goodsItems.subModelId[i]} data-goodsid={data.modelGoodsId} data-index={i} data-parentindex={index}
                                  data-modelname={item} data-compindex={this.props.index} onClick={(e)=> {this.verticalListChooseModel(e);e.stopPropagation()}}>{item}</span>
                              ))
                            }
                          </div>
                        </React.Fragment>
                      ))
                    }
                  </ScrollView>
                  <div className="takeoutGoodsModelBtn">
                    <span style={{paddingLeft: '.40rem'}}>
                      <span style={{fontSize:'.24rem',fontWeight:'normal',marginRight:'.10rem'}}>¥</span>
                      <span>{data.modelPrice}</span>
                      {
                        !!data.modelNum && (
                          <span style={{fontSize:'.32rem',color:'#000',fontWeight:'normal'}}> ({data.modelNum})</span>
                        )
                      }
                    </span>
                    {
                      !!(data.modelPrice > 0 && data.isModelPrice) && (
                        <span className='modle_vip_text'>会员价</span>
                      )
                    }
                    {
                      !data.modelNum && (
                        <div data-modelprice={data.modelPrice} data-goodsid={data.clickGoodsId} data-compindex={this.props.index} onClick={(e)=> {this.verticalListSureChooseModel(e);e.stopPropagation()}} style={{background:data.modelChoose.length > 0 && (data.modelChoose.length == data.modelIdArr.length) ? '#ff7100' : '#aaaaaa'}}>{data.modelChoose.length > 0 && (data.modelChoose.length == data.modelIdArr.length) ? "加入购物车" : "请选择规格"}</div>
                      )
                    }
                    {
                      !!data.modelNum && (
                        <div className="cart-btn" style={{background:'none'}}>
                          {
                            !data.customFeature.is_together && (
                              <label className="takeout-count-minus" onClick={(e)=> {this.verticalListMinuModel(e);e.stopPropagation()}} data-modelprice={data.modelPrice} data-goodsid={data.clickGoodsId} data-compindex={this.props.index}></label>
                            )
                          }
                          <input type="text" style={{width:'.60rem',display:'inline-block',verticalAlign:'middle',color:'#000'}} disabled="disabled" value={ data.modelNum } />
                          <label className={`takeout-count-plus ${(data.mdelInfo && data.mdelInfo.totalNum) >= (data.modelInfo && data.mdelInfo.stock) ? 'disabled': ''}`} data-modelprice={data.modelPrice} data-goodsid={data.clickGoodsId} data-compindex={this.props.index} onClick={(e)=> {this.verticalListSureChooseModel(e);e.stopPropagation()}}></label>
                        </div>
                      )
                    }
                  </div>
                </div>
              </div>
            )
          }
          {
            !!(data.shoppingCartShow && !data.customFeature.is_together) && (
              <div className="verticalList-shopping-carts-list" data-compindex={this.props.index} onClick={this.verticalListHideShoppingCart}>
                <div
                  onClick={this.stopPropagation} 
                  style={{maxHeight: `calc(${data.customFeature.showShopInfo ? (data.heightPx + 181) / 2 : (data.heightPx + 86) / 2}px + .76rem)`, height: 'auto'}}
                  className='carts-content'>
                <div className="chosen-title">已选商品
                  {
                    !!+data.TotalNum && (
                      <div className="pull-right ico-moon icon-delete" onClick={(e)=> {this.verticalListDeleteAllCarts(e);e.stopPropagation()}} data-compindex={this.props.index} style={{display:'inline-block',fontSize:'.26rem',fontWeight:'400',color:'#333',marginRight:'.50rem'}}> 清空</div>
                    )
                  }
                </div>
                {
                  +data.TotalNum === 0 && (
                    <div className='noGoods'>暂未选购商品</div>
                  )
                }
                <ScrollView
                  style={{maxHeight: `calc(${data.customFeature.showShopInfo ? (data.heightPx + 181) / 2 - 37 : (data.heightPx + 86) / 2 - 37}px + .50rem)`}}
                  scroll-y={true}>
                  {
                    data.cartGoodsIdList && data.cartGoodsIdList.map((items, index) => (
                      <React.Fragment key={index}>
                        {
                          data.cartList[0][items] && Object.values(data.cartList[0][items]).map((item, i) => (
                            <React.Fragment key={i}>
                              {item.modelId != 0 ?
                                (
                                  !!+item.num && (
                                    <div key={i} className={`shopping-cart-list ${item.in_business_time == 0 ? 'gray' : ''}`} style={{margin:'0 .30rem'}}>
                                      <div className="cart-info">
                                        <div className="cart-title" style={{marginTop:'.30rem'}}>{item.gooodsName}</div>
                                        <div className="cart-model">{item.modelName}</div>
                                      </div>
                                      <div className="cart-price">
                                        {
                                          !!item.is_vip_goods && (
                                            <span className='cart_vip_tips'>会员</span>
                                          )
                                        }
                                        <span>¥{item.totalPrice}</span>
                                      </div>
                                      <div className="cart-btn">
                                        {
                                          item.in_business_time != 0 ?
                                            (
                                              <React.Fragment>
                                                <label className={`verticalList-count-minus ${item.in_business_time == 0 ? 'disabled': ''}`} onClick={(e) => {this.verticalListCartListMinus(e);e.stopPropagation()}} data-id={item.cart_id} data-modelid={item.modelId} data-is-in-business={item.in_business_time} data-compindex={this.props.index} data-goodsid={item.id} data-stock={item.stock} data-index="0"
                                                  data-num={ item.num } data-price={item.price}></label>
                                                <input type="text" style={{width:'.50rem',display:'inline-block'}} disabled="disabled" value={ item.num }/>
                                                {
                                                  !!(!data.customFeature.is_together || buyer_index == 0) && (
                                                    <label className={`verticalList-count-plus ${item.in_business_time == 0 || (item.num >= item.stock) ? 'disabled' : ''}`} onClick={(e) => {this.verticalListCartListPlus(e);e.stopPropagation()}} data-modelid={item.modelId} data-compindex={this.props.index} data-is-in-business={item.in_business_time} data-goodsid={item.id} data-index="0" data-stock={item.stock} data-num={item.num} data-id={item.cart_id}></label>
                                                  )
                                                }
                                              </React.Fragment>
                                            )
                                            :
                                            (
                                              <span className="delete-single-cart" onClick={(e)=> {this.deleteSingleCarts(e);e.stopPropagation()}} data-modelid={item.modelId} data-compindex={this.props.index} data-goodsid={item.id}>删除</span>
                                            )
                                        }
                                      </div>
                                    </div>
                                  )
                                )
                                :
                                (
                                  !!+item.num && (
                                    <div className="shopping-cart-list" style={{margin:'0 .30rem'}}>
                                      <div className="cart-info">
                                        {
                                          item.in_business_time != 0  ?
                                            (
                                              <div className="cart-title" style={{lineHeight: '1.30rem'}}>{item.gooodsName}</div>
                                            )
                                            :
                                            (
                                              <React.Fragment>
                                                <div className="cart-title" style={{marginTop:'.30rem'}}>{item.gooodsName}</div>
                                                <div className="cart-model">(不在出售时间)</div>
                                              </React.Fragment>
                                            )
                                        }
                                      </div>
                                      <div className="cart-price">
                                        {
                                          !!item.is_vip_goods && (
                                            <span className='cart_vip_tips'>会员</span>
                                          )
                                        }
                                        <span>¥{item.totalPrice}</span>
                                      </div>
                                      <div className="cart-btn">
                                        {
                                          item.in_business_time != 0 ? 
                                            (
                                              <React.Fragment>
                                                <label className={`verticalList-count-minus ${item.in_business_time == 0 ? 'disabled': ''}`} data-is-in-business={item.in_business_time} onClick={(e) => {this.verticalListCartListMinus(e);e.stopPropagation()}} data-modelid={item.modelId} data-compindex={this.props.index} data-goodsid={item.id} data-stock={item.stock} data-id={item.cart_id} data-index="0"
                                                  data-price={item.price} data-num={ item.num}></label>
                                                <input type="text" style={{width:'.50rem',display:'inline-block'}} disabled="disabled" value={ item.num }/>
                                                {
                                                  !!(!data.customFeature.is_together || buyer_index == 0) && (
                                                    <label className={`verticalList-count-plus ${item.in_business_time == 0 || (item.num >= item.stock) ? 'disabled': '' }`} onClick={(e) => {this.verticalListCartListPlus(e);e.stopPropagation()}} data-modelid={item.modelId} data-is-in-business={item.in_business_time} data-compindex={this.props.index} data-goodsid={item.id} data-stock={item.stock} data-num={ item.num } data-index="0" data-id={item.cart_id}></label>
                                                  )
                                                }
                                              </React.Fragment>
                                            )
                                            :
                                            (
                                              <span className="delete-single-cart" onClick={(e)=> {this.deleteSingleCarts(e);e.stopPropagation()}} data-modelid={item.modelId} data-compindex={this.props.index} data-goodsid={item.id}>删除</span>
                                            )
                                        }
                                      </div>
                                    </div>
                                  )
                                )
                              }
                            </React.Fragment>
                          ))
                        }
                      </React.Fragment>
                    ))
                  }
                </ScrollView>
                </div>
              </div>
            )
          }
          {
            !!(data.shoppingCartShow && data.customFeature.is_together) && (
              <div className="verticalList-shopping-carts-list" data-compindex={this.props.index} onClick={this.verticalListHideShoppingCart} catchtouchmove="true">
                <div
                  onClick={this.stopPropagation}
                  style={{maxHeight: `calc(${data.customFeature.showShopInfo ? (data.heightPx + 181) / 2 : (data.heightPx + 86) / 2}px + .76rem)`, height: 'auto'}}
                  className='carts-content'>
                  <ScrollView
                    style={{maxHeight: `calc(${data.customFeature.showShopInfo ? (data.heightPx + 181) / 2 - 37 : (data.heightPx + 86) / 2 - 37}px + .50rem)`}}
                    scroll-y={true}
                    >
                    {
                      data.buyer_info && data.buyer_info.map((buyer, buyer_index) => (
                        <React.Fragment key={buyer_index}>
                          <div className="chosen-title" style={{borderRadius: buyer_index === 0 ? '.20rem .20rem 0 0' : null}}>
                            <img src={buyer.cover_thumb} className='cart_cover_thumb'/>
                            <span style={{verticalAlign:'middle'}}>{buyer.nickname}{buyer_index === 0 ? '（我）' : ''}</span>
                            {
                              !!data.TotalNum && (
                                <div className="pull-right" onClick={(e)=> {this.verticalListDeleteBuyerCarts(e);e.stopPropagation()}} data-compindex={this.props.index} data-index={buyer_index} style={{display:'inline-block',fontSize:'.26rem',fontWeight:'400',color:'#333',marginRight:'.50rem'}}> 
                                  <span className='ico-moon icon-delete' style={{verticalAlign:'middle'}}></span>
                                  <span style={{display:'inline-block', verticalAlign:'middle',marginLeft:'.06rem'}}> 清空</span>
                                </div>
                              )
                            }
                          </div>
                          {
                            !!((data.cartGoodsIdList.length === 0 || data.myCartNum === 0) && buyer_index === 0) && (
                              <div className='noGoods'>暂未选购商品</div>
                            )
                          }
                          {
                            data.cartGoodsIdList && data.cartGoodsIdList.map((cartid_item, cartid_index) => (
                              <React.Fragment key={cartid_index}>
                                {
                                  data.cartList[buyer_index][cartid_item] && [data.cartList[buyer_index][cartid_item]].map((item, goods_index) => (
                                    <div key={goods_index}>
                                      {
                                        item.modelId != 0 ?
                                          (
                                            !!+item.num && (
                                              <div key={cartid_index} className={`shopping-cart-list ${item.in_business_time == 0 ? 'gray' : ''}`}
                                                style={{margin:'0 .30rem'}}>
                                                <div className="cart-info">
                                                  <div className="cart-title" style={{marginTop:'.30rem'}}>{item.gooodsName}</div>
                                                  <div className="cart-model">{item.modelName}</div>
                                                </div>
                                                <div className="cart-price">
                                                  {
                                                    !!item.is_vip_goods && (
                                                      <span className='cart_vip_tips'>会员</span>
                                                    )
                                                  }
                                                  <span>¥{item.totalPrice}</span>
                                                </div>
                                                <div className="cart-btn">
                                                  {
                                                    item.in_business_time != 0 ?
                                                      (
                                                        <React.Fragment>
                                                          <label className={`verticalList-count-minus ${item.in_business_time == 0 ? 'disabled': ''}`}
                                                            onClick={(e) => {this.verticalListCartListMinus(e);e.stopPropagation()}} data-id={item.cart_id} data-modelid={item.modelId}
                                                            data-is-in-business={item.in_business_time} data-compindex={this.props.index}
                                                            data-goodsid={item.id} data-stock={item.stock} data-index={buyer_index} data-num={ item.num }
                                                            data-price={item.price}></label>
                                                          <input type="text" style={{width:'.50rem',display:'inline-block'}} disabled="disabled"
                                                            value={ item.num }/>
                                                          {
                                                            !!(!data.customFeature.is_together || buyer_index == 0) && (
                                                              <label
                                                                className={`verticalList-count-plus ${item.in_business_time == 0 || (item.num >= item.stock) ? 'disabled' : ''}`}
                                                                onClick={(e) => {this.verticalListCartListPlus(e);e.stopPropagation()}} data-id={item.cart_id} data-modelid={item.modelId}
                                                                data-compindex={this.props.index} data-is-in-business={item.in_business_time}
                                                                data-goodsid={item.id} data-index={buyer_index} data-stock={item.stock}
                                                                data-num={item.num}></label>
                                                            )
                                                          }
                                                        </React.Fragment>
                                                      )
                                                      :
                                                      (
                                                        <span className="delete-single-cart" onClick={(e)=> {this.deleteSingleCarts(e);e.stopPropagation()}} data-modelid={item.modelId}
                                                      data-compindex={this.props.index} data-goodsid={item.id}>删除</span>
                                                      )
                                                  }
                                                </div>
                                              </div>
                                            )
                                          )
                                          :
                                          (
                                            !!+item.num && (
                                            <div className="shopping-cart-list" style={{margin:'0 .30rem'}}>
                                              <div className="cart-info">
                                                {
                                                  item.in_business_time != 0  ?
                                                    (
                                                      <div className="cart-title" style={{lineHeight: '1.30rem'}}>{item.gooodsName}</div>
                                                    )
                                                    :
                                                    (
                                                      <React.Fragment>
                                                        <div className="cart-title" style={{marginTop:'.30rem'}}>{item.gooodsName}</div>
                                                        <div className="cart-model">(不在出售时间)</div>
                                                      </React.Fragment>
                                                    )
                                                }
                                              </div>
                                              <div className="cart-price">
                                                {
                                                  !!item.is_vip_goods && (
                                                    <span className='cart_vip_tips'>会员</span>
                                                  )
                                                }
                                                <span>¥{item.totalPrice}</span>
                                              </div>
                                              <div className="cart-btn">
                                                {
                                                  item.in_business_time != 0 ? 
                                                    (
                                                      <React.Fragment>
                                                        <label className={`verticalList-count-minus ${item.in_business_time == 0 ? 'disabled': ''}`} data-is-in-business={item.in_business_time} data-id={item.cart_id} onClick={(e) => {this.verticalListCartListMinus(e);e.stopPropagation()}} data-modelid={item.modelId} data-compindex={this.props.index} data-goodsid={item.id} data-stock={item.stock} data-index={buyer_index}
                                                          data-price={item.price} data-num={ item.num}></label>
                                                        <input type="text" style={{width:'.50rem',display:'inline-block'}} disabled="disabled" value={ item.num }/>
                                                        {
                                                          !!(!data.customFeature.is_together || buyer_index == 0) && (
                                                            <label className={`verticalList-count-plus ${item.in_business_time == 0 || (item.num >= item.stock) ? 'disabled': '' }`} onClick={(e) => {this.verticalListCartListPlus(e);e.stopPropagation()}} data-id={item.cart_id} data-modelid={item.modelId} data-is-in-business={item.in_business_time} data-compindex={this.props.index} data-goodsid={item.id} data-stock={item.stock} data-num={ item.num } data-index={buyer_index} ></label>
                                                          )
                                                        }
                                                      </React.Fragment>
                                                    )
                                                    :
                                                    (
                                                      <span className="delete-single-cart" onClick={(e)=> {this.deleteSingleCarts(e);e.stopPropagation()}} data-modelid={item.modelId} data-compindex={this.props.index} data-goodsid={item.id}>删除</span>
                                                    )
                                                }
                                              </div>
                                            </div>
                                            )
                                          )
                                      }
                                    </div>
                                  ))
                                }
                              </React.Fragment>
                            ))
                          }
                        </React.Fragment>
                      ))
                    }
                  </ScrollView>
                </div>
              </div>
            )
          }
          {
            !!data.showSettlementMask && (
              <div className="settlement-mask">
                <div className="settlement-box">
                  <div className="settlement-title">请分开结算以下商品</div>
                  {
                    data.canUsePickUpType[1] && !!data.canUsePickUpType[1].cart_list.length && (
                      <div className="settlement-type">
                        <div className="settlement-type-content">
                          <div>
                            <span className="settlement-type-title">快递商品</span>
                            <span className="settlement-type-express">配送费{data.canUsePickUpType[1].express_data && data.canUsePickUpType[1].express_data.express_fee}元</span>
                          </div>
                          <div>
                            <span className="settlement-type-count">共{data.canUsePickUpType[1].goods_num}件，合计：</span>
                            <span className="settlement-type-price" style={{color: data.storeStyle && data.storeStyle.theme}}>¥{data.canUsePickUpType[1].goods_price}</span>
                          </div>
                        </div>
                        <div className="settlement-btn-box">
                          <div data-type="1" data-cart-id={data.canUsePickUpType[1].cart_list} className="settlement-btn" style={{color:data.storeStyle && data.storeStyle.theme,borderColor:data.storeStyle && data.storeStyle.theme}} onClick={(e)=> {this.goodsPay(e);e.stopPropagation()}} data-compindex={this.props.index}>去结算</div>
                        </div>
                      </div>
                    )
                  }
                  {
                    data.canUsePickUpType[3] && !!data.canUsePickUpType[3].cart_list.length && (
                      <div className="settlement-type">
                        <div className="settlement-type-content">
                          <div>
                            <span className="settlement-type-title">上门自提商品</span>
                            <span className="settlement-type-express">配送费0元</span>
                          </div>
                          <div>
                            <span className="settlement-type-count">共{data.canUsePickUpType[3].goods_num}件，合计：</span>
                            <span className="settlement-type-price" style={{color:data.storeStyle && data.storeStyle.theme}}>¥{data.canUsePickUpType[3].goods_price}</span>
                          </div>
                        </div>
                        <div className="settlement-btn-box">
                          <div data-type="3" data-cart-id={data.canUsePickUpType[3].cart_list} className="settlement-btn" style={{color:data.storeStyle && data.storeStyle.theme,borderColor:data.storeStyle && data.storeStyle.theme}} onClick={(e)=> {this.goodsPay(e);e.stopPropagation()}} data-compindex={this.props.index}>去结算</div>
                        </div>
                      </div>
                    )
                  }
                  {
                    data.canUsePickUpType[2] && !!data.canUsePickUpType[2].cart_list.length && (
                      <div className="settlement-type">
                        <div className={`settlement-type-content ${data.intraCityData.is_enough_price != 1 || data.intraCityData.in_distance != 1 ? 'no-achieve-intra-box' : ''}`}>
                          <div>
                            <span className="settlement-type-title">同城配送商品</span>
                            <span className="settlement-type-express">配送费{data.intraCityData.express_fee}元</span>
                          </div>
                          <div>
                            <span className="settlement-type-count">共{data.canUsePickUpType[2].goods_num}件，合计：</span>
                            <span className="settlement-type-price" style={{color:data.storeStyle && data.storeStyle.theme}}>¥{data.canUsePickUpType[2].goods_price}</span>
                          </div>
                          {
                            data.intraCityData.in_business_time != 1 ? (
                              <div className="no-achieve-intra" style={{color:data.storeStyle && data.storeStyle.theme}}>店铺已打烊</div>
                            ) : (
                              data.intraCityData.is_enough_price != 1 ? (
                                <div className="no-achieve-intra" style={{color:data.storeStyle && data.storeStyle.theme}}>未达到起送价 还差{data.intraCityData.min_deliver_price_balance}元</div>
                              ) : (
                                data.intraCityData.in_distance != 1 ? (
                                  <div className="no-achieve-intra" style={{color:data.storeStyle && data.storeStyle.theme}}>不在配送范围</div>
                                ) : null
                              )
                            )
                          }
                        </div>
                        <div className="settlement-btn-box">
                          <div data-type="2" data-cart-id={data.canUsePickUpType[2].cart_list} className={`settlement-btn ${data.intraCityData.is_enough_price != 1 || data.intraCityData.in_distance != 1 || data.intraCityData.in_business_time != 1 ? 'no-achieve-intra-btn' : ''}`} style={{color:data.storeStyle && data.storeStyle.theme,borderColor: data.storeStyle && data.storeStyle.theme}} onClick={data.intraCityData.is_enough_price != 1 || data.intraCityData.in_distance != 1 || data.intraCityData.in_business_time != 1 ? null : ((e) => {this['goodsPay'](e);e.stopPropagation()})} data-compindex={this.props.index}>去结算</div>
                          {
                            (data.intraCityData.in_business_time == 1 && data.intraCityData.is_enough_price == 1 && data.intraCityData.in_distance != 1) && (
                              <div className="settlement-btn" style={{marginLeft:'.20rem',color:data.storeStyle && data.storeStyle.theme,borderColor:data.storeStyle && data.storeStyle.theme}} onClick={(e)=> {this.vlSelectGoodsSameJourney(e);e.stopPropagation()}}  data-compindex={this.props.index}>修改地址</div>
                            )
                          }
                        </div>
                      </div>
                    )
                  }
                  {
                    data.canUsePickUpType[4] && !!data.canUsePickUpType[4].cart_list.length && (
                      <div className="settlement-type">
                        <div className={`settlement-type-content ${data.dining_data.in_business_time != 1 ? 'no-achieve-intra-box' : ''}`}>
                          <div>
                            <span className="settlement-type-title">堂食点餐</span>
                          </div>
                          <div>
                            <span className="settlement-type-count">共{data.canUsePickUpType[4].goods_num}件，合计：</span>
                            <span className="settlement-type-price" style={{color:data.storeStyle && data.storeStyle.theme}}>¥{data.canUsePickUpType[4].goods_price}</span>
                          </div>
                          {
                            data.dining_data.in_business_time != 1 && (
                              <div className="no-achieve-intra" style={{color:data.storeStyle && data.storeStyle.theme}}>店铺已打烊</div>
                            )
                          }
                        </div>
                        
                        <div className="settlement-btn-box">
                          <div form-type='submit' className={`settlement-btn ${data.dining_data.in_business_time != 1 ? 'no-achieve-intra-btn' : ''}`} style={{color:data.storeStyle && data.storeStyle.theme,borderColor:data.storeStyle && data.storeStyle.theme}} onClick={data.dining_data.in_business_time != 1 ? null : ((e) => {this['goodsPay'](e);e.stopPropagation()})} data-type="4" data-cart-id={data.canUsePickUpType[4].cart_list} data-compindex={this.props.index}>去结算</div>
                        </div>
              
                      </div>
                    )
                  }
                </div>
                <div className="close-settlement-mask" data-compindex={this.props.index} onClick={(e)=> {this.verticalListCloseSettlement(e);e.stopPropagation()}}>关闭</div>
              </div>
            )
          }
          {
            data.shoppingCouponsList && (
              <div className='takeout-shopping-carts-list coupons-list'>
                <div className='shop-info-detail'>
                  <ScrollView>
                    <div className='shop-name'>{data.shopInfo.title}</div>
                    <div className='shop-info-content'>
                      <div className='content-text'>营业时间</div>
                      <div className='info-deliver-content'>{data.shopInfo.business_time_str}</div>
                    </div>
                    <div className='shop-info-content'>
                      <div className='content-text'>店铺地址</div>
                      <div className='info-deliver-content'>{data.shopInfo.address}</div>
                    </div>
                    {
                      !!data.customFeature.isShowNotice && data.shopInfo.shop_notice && (
                        <div className='shop-info-content'>
                          <div className='content-text'>公告</div>
                          <div className='info-deliver-content'>
                            公告：{data.shopInfo.shop_notice}
                          </div>
                        </div>
                      )
                    }
                  </ScrollView>
                  <div className='detail-close' data-compindex={this.props.index} onClick={this.verticalListHideCouponsList}>
                    <label className='ico-moon icon-closes'></label>
                  </div>
                </div>
              </div>  
            )
          }
          {
            data.showVipDialog && (
              <div className='verticalList-vipDialog' data-compindex={this.props.index} onClick={(e)=> {this.verticalListCloseVipDialog(e);e.stopPropagation()}}>
                <div onClick={this.stopPropagation}>
                  <label onClick={this.verticalListCloseVipDialog} className="ico-moon icon-closes" data-compindex={this.props.index}></label>
                  <div className='vipCardUp'>
                    <img src='http://test.zhichiwangluo.com/zhichi_frontend/static/webapp/images/takeout/vip_card_up.png'/>
                  </div>
                  <div className='cardTips'>
                    <span>您当前的会员卡，暂无购买该商品权限，可升级会员卡</span>
                  </div>
                  <ScrollView>
                    {
                      data.vipCondtionInfo && data.vipCondtionInfo.vip_card_data && data.vipCondtionInfo.vip_card_data.length > 0 && data.vipCondtionInfo.vip_card_data.map((item, index) => (
                        <div key={index} className='cardContent'>

                          <div className='card-content-title'>{item.title}会员卡(V{item.level})达成条件：</div>
                          {
                            item.trade_count > -1 && (
                              <div className='card-content-tips'>累计交易成功{item.trade_count}笔</div>
                            )
                          }
                          {
                            item.consume_count > -1 && (
                              <div className='card-content-tips'>或累计消费金额{item.consume_count}元</div>
                            )
                          }
                          {
                            item.integral_count > -1 && (
                              <div className='card-content-tips'>或累计积分达到{item.integral_count}笔</div>
                            )
                          }
                        </div>
                      ))
                    }
                    {
                      data.vipCondtionInfo && data.vipCondtionInfo.paid_vip_card_data && data.vipCondtionInfo.paid_vip_card_data.length > 0 && data.vipCondtionInfo.paid_vip_card_data.map((item, index) => (
                        <div key={index} className='cardContent'>
                          <div className='card-content-title'>{item.title}会员卡(V{item.level})达成条件：</div>
                          <div className='card-content-tips'>价格：每月{item.price}</div>
                        </div>
                      ))
                    }
                  </ScrollView>
                </div>
              </div>
            )
          }
          {
            !!(data.customFeature.showScanCode && data.selected == 1) && (
              <div className='scanCode' onClick={(e)=> {this.scanShopping(e);e.stopPropagation()}} onTouchMove={this.scanMove} data-compindex={this.props.index} style={{top: data.scanCode + 'px'}} >
                <span className="ico-moon icon-shopping-scan"></span>
                <div className="scan-word">扫码</div>
              </div>
            )
          }
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/custom-component/vertical-list-custom-component/VerticalListCustomComponent.jsx